{
  "accessibility": {
    "closeModal": "Luk modal",
    "useSetting": "Brug indstillingen",
    "srOnly": {
      "close": "Luk",
      "loading": "Indlæser ..."
    }
  },
  "account": {
    "salesResources": {
      "title": "Salgsressourcer",
      "searchDocuments": "Søg i dokumenter",
      "minimalRating": "Minimal vurdering",
      "maxRating": "Maksimal vurdering"
    },
    "saasRebilling": {
      "enableRebillingMessage": "Aktiver genfakturering for denne klient for at opnå op til 10 gange fortjeneste på brug af telefon, e-mails, automatiseringer osv.",
      "enableRebilling": "Aktivér genfakturering",
      "servicesActivateAfterPayment": "Genfaktureringstjenester vil være aktive, når kunden har tilføjet en betalingsmetode. Indtil da vil klientens konto-adgang være begrænset.",
      "cannotModifyOnHold": "Genfaktureringskonfigurationer kan ikke ændres, da denne konto allerede har en SaaS-plan på hold. Genfaktureringsmarkeringer vil blive konfigureret i henhold til planen, når klienten tilføjer en betalingsmetode.",
      "rebillingSettings": "Genfaktureringsindstillinger"
    }
  },
  "affiliates": {
    "aboutMe": "Om mig",
    "error": {
      "unableToSend": "Kan ikke sende e-mailen"
    },
    "industriesServed": "Betjente brancher",
    "sendAMessage": "Send en besked",
    "sendMessageIntro": "Send en besked for at præsentere dig selv for denne rådgiver. Inkluder oplysninger om dig selv og de tjenester, du søger.",
    "socialSites": "Sociale medier",
    "success": {
      "emailSent": "E-mailen er blevet sendt"
    },
    "validationErrors": {
      "validEmail": "Angiv en gyldig e-mail.",
      "validMessage": "Angiv en gyldig besked.",
      "validName": "Angiv et gyldigt navn."
    },
    "yearsInBusiness": "År i branchen",
    "yourEmail": "Din e-mail",
    "yourName": "Dit navn",
    "paymentDetailsAccessMessage": " Denne sektion med betalingsoplysninger er kun tilgængelig og kan redigeres af <strong>agenturets ejer</strong>. Hvis du har brug for hjælp, bedes du kontakte din <strong>agenturejer ({ agencyOwnerEmail })</strong>.",
    "partnerBadgeAlt": "Partner-badge",
    "photoAlt": "Partnerbillede",
    "defaultCompany": "Ingen virksomhed",
    "moreServices": "+ {count} flere tjenester"
  },
  "agency": {
    "saas": {
      "saasMode": "SaaS-tilstand",
      "pendingPaymentInformation": "Oplysninger om afventende betaling",
      "customerId": "Kunde-ID",
      "noPaymentMethods": "Det ser ud til, at der ikke er tilføjet nogen betalingsmetoder. Tilføj en betalingsmetode for at aktivere SaaS-tilstand.",
      "enableSaasDescription": "Aktivér SaaS på denne placering for at oprette et abonnement, genfakturere telefon- og e-mailforbrug",
      "missingEmailAddress": "Kontoens e-mailadresse mangler, tilføj oplysningerne først.",
      "toConvertToSaaS": "For at konvertere denne konto til SaaS skal du først tilføje en lokationsadministrator og prøve igen",
      "newUser": "Opret ny bruger",
      "stripeCustomerConnected": "Stripe-kunden fik succesfuld forbindelse!",
      "requestClientPaymentDetails": "Anmod om kundens betalingsoplysninger",
      "saasLocationDescription": "Placeringer i SaaS-tilstand har brug for din klients kreditkort for at fungere. Du kan anmode ved at sende en e-mail, sms eller dele en URL",
      "selectSpace": "Vælg plads for at fortsætte",
      "spaceDescription": "Den plads, du vælger her, vil blive brugt til at gemme denne kundes oplysninger, behandle deres betalinger og administrere deres abonnementer.",
      "stripe": "Stripe",
      "freeCreditsDescription": "Når en bruger tilmelder sig, kan du tilbyde vedkommende gratis kreditter til at bruge e-mail- og telefonitjenester.",
      "thatAboutMinsInCalls": "Det er cirka {count} beskeder eller {count1} min. i opkald",
      "subscriptionSettings": "Abonnementsindstillinger",
      "toUpgradeOrCancelPlan": "For at opgradere eller annullere et abonnement",
      "allowClientUpgrade": "Giv kunden (underkontoen) mulighed for at opgradere til et højere abonnement.",
      "addNewPlanFeatures": "Tilføj nye planfunktioner ved opgradering",
      "upgradeFeatureDescription": "Ved opgradering til en højere plan får underkontiene adgang til de yderligere funktioner i den nye plan. adgang til de ekstra funktioner i den nye abonnementsplan.",
      "allowClientCancel": "Giv kunden (underkontoen) mulighed for at annullere sit abonnement.",
      "snapshotDescription": "Det valgte øjebliksbillede tilføjes automatisk til den nyoprettede SaaS-placering",
      "ownSnapshots": "Egne øjebliksbilleder",
      "selectAndContinue": "Vælg og fortsæt"
    },
    "advancedSettings": {
      "controlLocationSettings": "Administrer adresseindstillingerne",
      "disableAddSmtp": "Deaktiver knappen Tilføj e-mailservice i underkontoens indstillinger for e-mailservicer",
      "disableAddSmtpDescription": "Begræns underkonto-brugere i forhold til at indbefatte deres egen e-mailserviceudbyder",
      "enableReVerification": "Aktivér genbekræftelse i 90 dage",
      "lcEmailNotEnabled": "Placeringen har ikke LeadConnector som standard e-mailudbyder",
      "onlyVisibleForAgency": "Du kan kun se disse indstillinger aktiveret for et agentur",
      "reVerificationDescription": "Hver e-mailbekræftelsesstatus vil blive tilbagekaldt efter 90 dage (beskyt dit afsenderomdømme, og sørg for maksimal leveringsdygtighed i indbakken).",
      "account": {
        "accountDetails": "Kontooplysninger",
        "advancedEmailSettings": "Avancerede e-mailindstillinger",
        "hipaa": "HIPAA",
        "hipaaCompliant": "HIPAA-overholdende",
        "smsEmailLimits": "SMS/e-mail-grænser",
        "socialProfiles": "Sociale profiler",
        "subscribed": "Abonneret"
      },
      "activityTracking": {
        "history": "Historie"
      },
      "addAccount": {
        "accountInfo": "Kontooplysninger",
        "accountSnapshots": "Øjebliksbilleder af konto",
        "businessNiche": "Virksomhedens niche",
        "chooseBusinessNiche": "Vælg virksomhedens niche ...",
        "pickSnapshot": "Vælg et øjebliksbillede",
        "selectSnapshot": "Vælg øjebliksbillede",
        "title": "Tilføj underkonto",
        "accountInfo1": "Kontooplysninger"
      },
      "addBalance": {
        "addBalanceToWallet": "Tilføj saldo til tegnebog",
        "addMoneyToWallet": "Tilføj penge til tegnebogen",
        "balanceAddedSuccessfully": "Saldo tilføjet",
        "cardWillBeCharged": "Kort, der ender på {cardNumber}, vil blive debiteret",
        "complimentaryCredits": "Gratis kreditter ({credits})",
        "creditsRemovedByAgency": "Kreditter slettet via agentur",
        "currentBalance": "Aktuel saldo",
        "customerCCWillNotBeCharged": "Kundens kreditkort vil ikke blive opkrævet",
        "moneyWillBeAddedToWallet": "Penge vil blive tilføjet til tegnebogen",
        "pleaseProvideAmountBetween": "Angiv et beløb mellem {min} og {max}",
        "processing": "Behandler",
        "removeBalance": "Fjern saldo",
        "transactionSuccessful": "Transaktion gennemført",
        "walletBalance": "Tegnebogssaldo ({balance})"
      },
      "addPaymentMethod": {
        "adding": "Tilføjer ...",
        "cardDetails": "Kortoplysninger",
        "cardSuccessfullyAdded": "Kort tilføjet",
        "errorWhileAddingCard": "Fejl under tilføjelse af nyt kort.",
        "maximumCardUpdateLimitReached": "Maksimal grænse for kortopdateringer er nået",
        "rateLimitMessage": "Det ser ud til, at du har nået det maksimale antal forsøg på at tilføje kort, der er tilladt pr. dag. Prøv igen efter 24 timer."
      },
      "aiProductRebilling": {
        "funnel": " tragt",
        "images": " Billeder,",
        "per1000Words": " /1000 ord, ",
        "perFunnel": " /tragt",
        "perImage": " /billede,",
        "pleaseCheckSupport": "Se vores",
        "ratesMayDiffer": "Priserne kan variere afhængigt af region. De viste beregninger er i henhold til priserne for UK,",
        "ratesMayDifferUS": "Priserne kan variere afhængigt af region. Beregninger vist i henhold til Twilio-priser for USA. Se Twilio for at få flere oplysninger.",
        "pleaseCheckTwilioRates": "Udgående SMS til USA/Canada vil blive opkrævet til 0,0079 USD/segment. Indgående SMS til 0,0075 USD/segment.",
        "words": " ord, "
      },
      "api": {
        "advancedFunctionalityNote": "Besked om avanceret funktionalitet",
        "agencyApiKeys": "Agenturets API-nøgler",
        "apiAccess": {
          "partOfAdvancedApi": "Dette er en del af den avancerede API, der er tilgængelig i Pro-abonnementet.",
          "toUpgrade": "for at opgradere."
        },
        "createNew": "Opret ny",
        "developerCouncilInfo": "Information om Udviklerrådet",
        "noAccess": "Du har ikke adgang til denne sektion.",
        "securityAlert": "Sikkerhedsadvarselsmeddelelse",
        "table": {
          "fetchingKeys": "Henter virksomhedsnøgler ...",
          "noKeysYet": "Du har endnu ikke nogen API-nøgler.",
          "toCreateFirstKeys": "for at oprette dine første API-nøgler."
        },
        "zapierNote": "Zapier-note"
      },
      "calendarBeta": {
        "abilityChooseGoogleCalendars": "Mulighed for at vælge Google Kalendere til 'Tilføj til' + 'Konflikt'-kalendere for at kontrollere for at beregne tilgængelighed for hver bruger",
        "abilityToAllocateRoundRobin": "Mulighed for at allokere aftaler i automatisk tildeling af aftaler",
        "abilityToChooseSpecificUser": "Mulighed for at vælge en specifik bruger, som aftalen skal bookes hos",
        "adminAbilitySeeEveryUser": "Admin – Mulighed for at se hver brugers kalenderaftaler",
        "adminAbilityViewAllCalendar": "Admin – Mulighed for at se alle brugeres kalenderaftaler",
        "adminsCanDeleteIntegrations": "Administratorer kan slette alle integrationer, de ønsker, men brugere kan kun fjerne deres egne.",
        "adminsCanSeeAllIntegrations": "Administratorer kan se alle integrationer, uanset hvem der har oprettet dem, men brugere kan se integrationer, de har oprettet til sig selv.",
        "contactDetailAppointments": "Kontaktoplysninger > Aftaler (Ny)",
        "conversationsScheduleAppointment": "Samtaler > Planlæg aftale (ny)",
        "essentialConsiderations": "Vigtige overvejelser",
        "funnelsWebsitesCalendar": "Tragte/websites > Kalender (ny)",
        "helpReorientTriggers": "Under opkaldet hjælper vi med at justere udløserne, så de passer til den nye kalenderkonfiguration.",
        "iAgreeMessage": "Hvis du er tilfreds med de førnævnte ændringer, skal du klikke på 'Jeg accepterer' og komme i gang med Kalender (Beta) på denne placering.",
        "integrationNew": "Integration (Ny)",
        "loseAbilityToViewEdit": "Brugere i den nye version mister muligheden for at 'se/redigere' aftaler (oprettet i den tidligere version) via modalvinduet Oplysninger om muligheder – men de kan fortsætte med at udføre alle disse handlinger på siden Aftaler.",
        "newOldTriggersCoexist": "De nye og gamle udløsere vil eksistere side om side",
        "nonAdminAbilityViewPersonal": "Ikke-administrator – mulighed for kun at se deres personlige aftaler (tildelte data/kalenderkortlægning under TEAMLEDELSE har ingen indflydelse)",
        "nonAdminViewPersonalOnly": "Ikke-administrator – Mulighed for kun at se deres personlige aftaler",
        "notAtMoment": "Ikke lige nu. Men vi prøver hårdt på at få det ud til mobilen så hurtigt som muligt.",
        "oldAppointmentsCanBeViewed": "De gamle aftaler kan nemt ses på aftalesiden via en vippeknap.",
        "oldAppointmentsDisplayed": "Gamle aftaler vises sammen med de nye aftaler på den samme aftaleliste",
        "oldCalendarVersionAppointments": "Gammel kalenderversion + gamle aftaler",
        "onlyNewCalendarWidget": "Kun den nye kalender-widget kan tilføjes",
        "opportunityAddAppointment": "Mulighed > Tilføj aftale (ny)",
        "profilePageAdmin": "Profilside for administrator (ny)",
        "profilePageAllUsers": "Profilside (Alle brugere)",
        "providesAllOptions": "Giver alle nødvendige muligheder (Grupper + Serviceydelser) til konfiguration af den nye kalender",
        "reintegratingConnectionsRequired": "Det kan være nødvendigt at genintegrere alle forbindelser, når Kalender Beta er aktiveret for en lokation",
        "roundRobinHighlight": "Muligheden for automatisk tildeling af aftaler mellem forskellige grupper af agenter er det primære højdepunkt i denne opdatering.",
        "schedulingCalendarAppointments": "Planlægning > Kalender/Aftaler (Nye filtre + Skift mellem nye og gamle aftaler)",
        "settingsCalendarBeta": "Indstillinger > Kalender (Beta)",
        "surfacingFirstTime": "Fremhæver det for første gang",
        "teamManagementAdminOnly": "Teamadministration (kun tilgængelig for administratorer)",
        "toggleOffNewVersion": "Slå fra (ny version)",
        "toggleOnOldVersion": "Slå til (gammel version)",
        "whatChangesWithNewVersion": "Hvilke ændringer indeholder den nye version af kalenderen?",
        "whatDoesCalendarEntail": "Hvad indebærer kalenderen (Privat Beta)?",
        "whatHappensToOldAppointments": "Hvad sker der med vores gamle aftaler efter overgangen?",
        "whatWillWeSeeMobile": "Hvad vil vi se på mobilen under betaversionen?",
        "willOldAppointmentsBeFactored": "Vil de gamle aftaler blive taget i betragtning, når tilgængeligheden for de nye aftaler beregnes?",
        "willOldCalendarUrlsWork": "Vil vores gamle kalender-URL'er fortsætte med at virke efter overgangen?",
        "willWeGetNewVersionMobile": "Får vi lov til at bruge den nye version på mobilen under betaversionen?",
        "yesOldSettingsPageContinues": "Ja. Faktisk vil den gamle indstillingsside fortsat eksistere, og det samme gælder din mulighed for at foretage ændringer der. Den gamle kalenderwidget og den nye kalenderwidget vil fungere uafhængigt, men være konstant synkroniseret med hinanden for at sikre nøjagtig beregning af din tilgængelighed på tværs af de to systemer. For at undgå forvirring vil vi kraftigt opfordre dig til at bruge de nye URL'er, hvor det er muligt, så du ikke behøver at overvåge to separate URL'er for samme brugersæt.",
        "yesSyncOnGoogleCalendar": "Ja, da envejssynkronisering er aktiveret, vil Google Kalender sørge for, at utilgængelige tidsrum blokeres."
      },
      "companyPlansModal": {
        "billedAnnually": "Faktureres årligt",
        "billedMonthly": "Faktureres månedligt",
        "changePlanFor": "Rediger plan for {locationName}",
        "notAuthorized": "Du er ikke autoriseret til at udføre denne handling. Kun agenturbrugere/administratorer og lokationsadministratorer kan udføre dette.",
        "payAnnually": "Betal årligt",
        "payMonthly": "Betal månedligt"
      },
      "locationBillingHistory": {
        "billingHistory": "Faktureringshistorik",
        "cardNo": "Kortnummer",
        "errorWhileFetchingInvoices": "Fejl under hentning af fakturaer. Klik for at prøve igen.",
        "invoiceDescription": "Fakturabeskrivelse",
        "invoiceNo": "Fakturanr.",
        "noInvoices": "Ingen fakturaer",
        "refunded": "Tilbagebetaling",
        "succeeded": "blev gennemført",
        "view": "VIS"
      },
      "locationWallet": {
        "autoRechargeWith": "Automatisk indbetaling på",
        "balance": "Saldo:",
        "credits": "Kreditter",
        "seeTransactions": "Se transaktioner",
        "whenBalanceLowerThan": "når saldoen er under"
      },
      "mailTransactionModal": {
        "checkYourEmail": "Kontrollér din e-mail ({emails}).",
        "csvSentMessage": "Vi sender en CSV-fil til din e-mailadresse. Dette tager som regel 7-10 minutter.",
        "enterEmailAddress": "Indtast e-mailadresse",
        "exportAndSendCsv": "Eksportér og send CSV",
        "exportTransactions": "Eksportér transaktioner",
        "itUsuallyArrives": "Det kommer normalt inden for 10 minutter.",
        "useCommasToSeparate": "Brug kommaer til at adskille flere e-mails."
      },
      "modifySubscription": {
        "cancelClientDescription": "Opsig din kundes abonnement, og luk kontoen",
        "cancelDescription": "Opsig dit abonnement, og luk kontoen",
        "cancelImmediately": "Annuller straks",
        "cancelNow": "Annuller nu",
        "cancelSubscription": "Annuller abonnement",
        "changedYourMind": "Har du ændret mening?",
        "changedYourMindClient": "Du kan genoptage din kundes abonnement.",
        "changedYourMindYou": "Du kan genoptage dit abonnement",
        "confirmByTyping": "Bekræft ved at skrive {text} nedenfor",
        "confirmCancellation": "Bekræft annullering",
        "modifySubscription": "Rediger abonnement",
        "modifyYourSubscription": "Rediger dit abonnement",
        "resumeSubscription": "Genoptag abonnement",
        "subscriptionWillBeCancelledOn": "Dette vil planlægge, at dit abonnement opsiges den {date}. Du kan genoptage abonnementet ved at afbryde den planlagte annullering når som helst.",
        "subscriptionWillBeCancelledOnClient": "Dette vil planlægge, at din kundes abonnement opsiges den {date}. Du og dine kunder kan genoptage abonnementet ved at afbryde den planlagte opsigelse når som helst.",
        "subscriptionWillBeCancelledOnDate": "Dit abonnement vil blive opsagt den {date}.",
        "subscriptionWillBeCancelledOnDateClient": "Din kundes abonnement vil blive opsagt den {date}.",
        "subscriptionWillBeResumed": "Dit abonnement vil blive genoptaget, og du vil blive faktureret normalt.",
        "subscriptionWillBeResumedClient": "Din kundes abonnement vil blive genoptaget, og de vil begynde at blive faktureret normalt.",
        "upgradeDescription": "Skift til et højere abonnement",
        "weAreGladYouStaying": "Vi er glade for, at du bliver!",
        "nextBillingDate": "Næste faktureringsdato: {date}",
        "cancelImmediatelyTitle": "Vil du virkelig annullere abonnementet med det samme?",
        "cancelNowDescription": "Dit abonnement er planlagt til at blive opsagt den {date}. Hvis du vælger at opsige nu, stoppes din konto med det samme, inklusive al udgående aktivitet som planlagte beskeder og e-mails.",
        "cancelNowDescriptionClient": "Din klients abonnement er planlagt til at blive annulleret den {date}. Hvis du vælger at annullere nu, så vil din klients konto, inklusive al udgående aktivitet som planlagte beskeder og e-mails, blive stoppet med det samme.",
        "modifyDescription": "Du kan {action} dit abonnement",
        "modifyDescriptionClient": "Du kan {action} din klients abonnement"
      },
      "noPaymentMethodWarning": {
        "addNow": "Tilføj nu",
        "youNeedToEnterCardInfo": "Du skal indtaste dine kortoplysninger.",
        "youNeedToEnterClientCardInfo": "Du skal indtaste din klients kortoplysninger."
      },
      "productRebilling": {
        "chargesBasedOnTokens": "Priserne er baseret på tokens. Ordoptællingerne vist nedenfor er estimater, der hjælper dig med at forstå brugen. De faktiske priser kan variere.",
        "examplePricingGpt4oMini": "Eksempel på prissætning - GPT-4o Mini",
        "for750kWords": "(for 750.000 ord) ",
        "gpt4oMini": " GPT-4o-mini ",
        "input": "Input",
        "or": "eller ",
        "output": "Output",
        "perImage": " /billede",
        "perResultSelection": " /resultatvalg",
        "ratesMayDifferUK": "Priserne kan variere afhængigt af region. De viste beregninger er baseret på priser for Storbritannien. Se vores",
        "ratesMayDifferUS": "Priserne kan variere afhængigt af region og typen af nummer. Beregninger vist i henhold til Twilio-priser for USA.",
        "pleaseCheckSupport": "Se vores",
        "resultSelection": " Resultatvalg",
        "supportDoc": "supportdokument",
        "forMoreDetails": "for flere oplysninger",
        "words": " ord"
      },
      "removePaymentMethod": {
        "endingIn": "Ender på *{cardNo}",
        "no": "Nej",
        "removeCard": "Fjern kort?",
        "removing": "Fjerner ...",
        "yesRemove": "Ja, fjern"
      },
      "requestSaasModal": {
        "requestClientPaymentDetails": "Anmod om kundes betalingsoplysninger",
        "saasLocationDescription": "Opret et SaaS-abonnement for denne lokation",
        "selectSpace": "Vælg område",
        "spaceDescription": "Vælg, hvor du vil konfigurere fakturering for denne lokation"
      },
      "saasEnableProducts": {
        "disable": "Deaktiver",
        "enableDisableProducts": "Aktivér/deaktiver produkter",
        "feature": "Funktion",
        "unsavedChanges": "Ændringer, der ikke er gemt"
      },
      "saasSubscriptionPlan": {
        "agencyStripeFailed": "Næste fakturering for denne kunde ser ud til at være i fortiden. Dette sker, når dit agenturs Stripe-konto ikke fungerer korrekt. Log ind på dit bureaus Stripe for at rette det.",
        "copiedText": "kopieret tekst:",
        "couldNotCopy": "Asynkron: Kunne ikke kopiere tekst: ",
        "multiplier": " X ",
        "nextBillingDatePrefix": " Næste faktureringsdato: ",
        "plan": "Plan",
        "pleaseContactAgency": "Kontakt agenturet for at aktivere dit abonnement.",
        "stripeSubscriptionId": "Stripe-abonnements-id:",
        "subscriptionPlans": "Abonnementsplaner",
        "subscriptionWillBeCancelledOn": "Dit abonnement vil blive opsagt den {date}",
        "subscriptionWillBeCancelledOnClient": "Din kundes abonnement vil blive opsagt den {date}",
        "toModifyClientSubscription": "for at ændre din kundes abonnement",
        "toModifyYourSubscription": "for at ændre dit abonnement",
        "whatsappNumberSubscription": "WhatsApp-nummerabonnement",
        "yourBillingDatePast": "Din næste faktureringsdato ser ud til at være i fortiden. Kontakt {email} for at få rettet dette. Alt vil fortsætte som normalt i mellemtiden."
      },
      "salesResources": {
        "certifiedUser": "Certificeret bruger",
        "clearFilter": "Ryd filter",
        "dateRange": "Dato Omfang"
      },
      "upgradePlanProcessedModal": {
        "paymentInfo": "Du betaler $ {amount} /måned, faktureret {interval}",
        "planUpgradeFailed": "Din plan kunne ikke opgraderes!!",
        "planUpgraded": "Din plan er blevet opgraderet!",
        "retryUpgrade": "Prøv at opgradere igen",
        "upgradeFailed": "Din planopgradering mislykkedes. Prøv igen.",
        "upgradedSuccessfully": "Du har opgraderet dit abonnement {oldPlan} til {newPlan}"
      },
      "upgradePlanSelectionModal": {
        "billedAsMonthlyCharge": "faktureret som et månedligt gebyr på {amount} /måned",
        "billedAsYearlyCharge": "faktureret som en årlig betaling på {amount} /år",
        "upgradeFrom": "Opgrader fra",
        "whatYouWillGet": "Dette får du:"
      },
      "walletTransactionModal": {
        "balanceAfterTransaction": "Saldo efter transaktionen:",
        "callDuration": "Opkaldsvarighed:",
        "callSid": "Opkalds-SID:",
        "charge": "Opkrævning:",
        "contact": "Kontakt:",
        "contactName": "Navn på kontakt:",
        "contactPhone": "Telefonnr. på kontakt:",
        "credit": "Kredit:",
        "creditsAfterTransaction": "Kreditter efter transaktionen:",
        "dateSent": "Afsendelsesdato",
        "deleted": "<Deleted>.",
        "discount": "Rabat:",
        "eventId": "Begivenheds-ID:",
        "from": "Fra:",
        "noContactFound": "Kontakt ikke fundet",
        "noOfSegments": "Antal segmenter:",
        "openContactPage": "Åbn kontaktside",
        "openConversation": "Åbn samtale",
        "openEvent": "Åben begivenhed",
        "originalCharge": "Oprindelig pris:",
        "received": "Modtaget",
        "smsSid": "SMS-SID:",
        "timeBilled": "Tid faktureret:",
        "timeOfCall": "Tidspunkt for opkald",
        "transactionDetails": "Transaktionsoplysninger -",
        "transactionId": "Transaktions-ID:",
        "type": "Type:",
        "segments": "Segmenter"
      },
      "calendarSettings": {
        "meetings": "Møder",
        "services": "Serviceydelser",
        "hideCalendarWarning": "Hvis du ønsker at skjule kalender-widget helt, skal du gøre det fra Konfig > mit personale > roller og tilladelser",
        "calendarSettingsUpdated": "Opdatering af kalenderindstillinger",
        "meetingDescription": "Aktivér denne indstilling for at give underkonti tilladelse til at bruge Møder-funktionen, der er designet til at administrere salgskalendere, onboarding-opkald, automatisk tildeling af aftaler, teamsamarbejder, klassebookinger, interviews og meget mere. Ideel til virksomheder, der har brug for fleksible og samarbejdsorienterede planlægningsværktøjer.",
        "serviceDescription": "Aktivér serviceydelser for at give underkonti adgang til en komplet bookingløsning til servicebaserede virksomheder. Dette omfatter oprettelse af bookingsider med flere serviceydelser, administration af ressourcer, håndtering af flere lokationer, indstilling af medarbejderspecifik prissætning, tilføjelse af servicevarianter eller plus-tilføjelser og meget mere."
      }
    },
    "apiKeys": {
      "apiKey": "ApiKey",
      "copied": "Kopieret!",
      "copyApiKey": "Kopiér API-nøglen",
      "createApiKey": "Opret API-nøgle",
      "deleteAllKeys": "Slet alle nøgler",
      "nameRequired": "Navnefeltet er påkrævet.",
      "somethingWentWrong": "Ups! Noget gik galt! Prøv igen.",
      "updatedSuccessfully": "Opdateret"
    },
    "billing": {
      "accountPaused": "Din konto {name} er blevet sat på pause.",
      "accountProvisioned": "Din konto bliver klargjort.",
      "activateSubAccount": "Aktivér underkonto",
      "activeServices": "Aktive serviceydelser",
      "addNewCard": "Tilføj nyt kort",
      "addNewService": "Tilføj ny serviceydelse",
      "addPaymentMethod": "tilføje en betalingsmetode",
      "alertIcon": "alarmikon",
      "approve": "Godkend",
      "authenticateCardMessage": "For ekstra sikkerhed skal du bekræfte dine kortoplysninger igen.",
      "badActorWarning": "Hvis du mener, at denne underkonto er blevet oprettet af en dårlig aktør, anbefaler vi, at du sletter denne underkonto og annullerer det matchende abonnement.",
      "callUs": "Ring til os",
      "cancelAndDelete": "Annuller abonnement, og slet underkonto",
      "completeFormNextStep": "Udfyld formularen i næste trin",
      "congratulations": "🎉 Tillykke! 🎉",
      "contactAgency": "Kontakt dit agentur for at løse dette problem",
      "contactThroughEmailOrPhone": "Du kan enten kontakte os via e-mail eller pr. telefon for at løse det.",
      "dataSafe": "Alle dine data er sikre, og alle automatiseringer, websider osv. genoptages, når betalingen er gennemført.",
      "declineSubAccount": "Afvis underkontoen",
      "deleteRecommendation": "Det anbefales at slette denne underkonto. Ellers kan du gøre dette senere fra siden Underkonti > Administrer kunde.",
      "emailUsAt": "Send os en e-mail på",
      "moveToDashboard": "Flyt til kontrolpanel",
      "noPaymentMethods": "Det ser ud til, at der ikke er tilføjet nogen betalingsmetoder! Du skal",
      "paymentMethod": "Betalingsmetode",
      "paymentMethodUpdated": "Din betalingsmetode er blevet opdateret",
      "paymentNotCompleted": "Du ser denne besked, fordi betalingen ikke blev gennemført.",
      "proceedToNextStep": "Fortsæt til næste trin",
      "questionMark": "?",
      "reachOutMessage": "Du er velkommen til at kontakte os, hvis du har spørgsmål.",
      "reactivateBillingFor": "Genaktiver fakturering for {location}",
      "retryPayment": "Prøv at udføre betalingen igen",
      "secureSystemMessage": "Vi er gået over til et mere sikkert faktureringssystem.",
      "setupMessage": "Nogen vil kontakte dig for at oprette kontoen. Det tager normalt 12-24 timer.",
      "signout": "Log ud",
      "subAccountId": "Underkonto-id:",
      "successfullyInitiated": "{product} er blevet startet",
      "systemError": "Der er en systemfejl",
      "toReactivate": "for at genaktivere kontoen",
      "userImage": "brugerbillede",
      "verificationSkipped": "Bekræftelse af e-mail og telefonnummer springes over for denne underkonto, og kunden vil kunne opnå adgang til den.",
      "verifyAccount": "Bekræft konto",
      "verifyAfterAttempt": "Du kan bekræfte denne konto efter mindst ét bekræftelsesforsøg fra underkontoadministratoren",
      "verifySubAccount": "Bekræft underkontoen",
      "recommendedPlans": "Anbefalede planer",
      "buildYourOwnPlan": "Skab Deres egen plan",
      "resetToDefaults": "Nulstil til standardindstillinger",
      "paymentMethodChange": "Hvis du har brug for at ændre betalingsmetode",
      "approveSubAccount": "Godkend underkontoen",
      "approveSubAccountDescription": "Underkontoen vil blive genoptaget, og underkontoens administratorer vil kunne få adgang til og bruge den.",
      "productInitiated": "Produkt initialiseret"
    },
    "deleteConfirmation": {
      "actionCannotBeReversed": "Denne handling kan ikke fortrydes.",
      "cancelKeep": "Annuller, behold",
      "confirmDeletionInstructions": "Bekræft sletning ved at skrive {word} nedenfor:",
      "enterConfirm": "Indtast {word} for at regenerere",
      "message": "Denne placerings-API-nøgle vil blive slettet.",
      "title": "Slet API-nøgle til placering?",
      "yesDelete": "Ja, slet"
    },
    "generalDetails": {
      "noPermission": "Du har ikke tilladelse til at uploade filen. Kontrollér dine tilladelser med din agenturadministrator.",
      "relatedContacts": "Relaterede kontakter ({count})"
    },
    "locationApiKeys": {
      "deleteAllConfirmMessage": "Er du sikker på, at du vil slette alle API-nøgler for placeringen?",
      "deleteAllConfirmTitle": "Vil du slette alle API-nøgler for placeringen?",
      "deleteConfirmMessage": "Dette vil slette API-nøglen for placeringen: {location}. Ønsker du at fortsætte?",
      "deleteAgencyApiKeyConfirmMessage": "Dette vil slette API-nøglen. Ønsker du at fortsætte?",
      "fetchingLocations": "Henter placeringer ...",
      "maxApiKeysMessage": "Du kan maksimalt have 5 API-nøgler.",
      "noLocationsFound": "Der blev ikke fundet nogen placeringer",
      "old": "Gammel",
      "proPlanRequiredMessage": "Dette er en del af den avancerede API, der er tilgængelig i Pro-abonnementet.",
      "searchLocation": "Søg placering",
      "title": "API-nøgle til placering"
    },
    "locationCard": {
      "deletionScheduledMessage": "Denne underkonto vil blive slettet den {date}, hvis du har skiftet mening –",
      "emailUsageNotRebilled": "E-mailforbruget bliver ikke genfaktureret",
      "emailUsageRebilled": "E-mailforbruget bliver viderefaktureret til din klient",
      "listings": "Annoncer",
      "manageClient": "Administrer kunde",
      "paymentPending": "Betaling afventer",
      "remainingWalletBalance": "Resterende saldo på tegnebogen for denne SaaS-placering",
      "requestPaymentAgain": "Anmod om betaling igen",
      "saasModeActivated": "SaaS-tilstand er aktiveret",
      "saasModeNotActivated": "SaaS-tilstand er ikke aktiveret",
      "saasSubscriptionNotEnabled": "SaaS-abonnementet er ikke aktiveret",
      "saasSubscriptionRunning": "SaaS-abonnementet kører",
      "social": "Sociale medier",
      "switchToSaaS": "Skift til SaaS",
      "switchToSubAccount": "Skift til underkonto",
      "telephoneUsageNotBilled": "Telefonforbruget faktureres ikke",
      "telephoneUsageRebilled": "Telefonforbruget bliver viderefaktureret til din klient",
      "wordpressActive": "WordPress er aktiv",
      "wordpressInactive": "WordPress er inaktiv",
      "wordpressNotSoldYet": "WordPress er endnu ikke solgt",
      "wordpressSaleSuccessful": "WordPress-salget er en succes",
      "yextActive": "Yext er aktiv",
      "yextInactive": "Yext er inaktiv",
      "yextNotSoldYet": "Yext er endnu ikke solgt",
      "yextSaleSuccessful": "Yext-salget er vellykket",
      "reviews": "Anmeldelser"
    },
    "messageUsage": {
      "acceptTnc": "Acceptér vilkår og betingelser",
      "cannotPerformAction": "Denne handling kan ikke udføres. Kontakt support.",
      "currentLimit": "Aktuel grænse",
      "days": "Dag(e)",
      "failedToUpdate": "Beskedforbruget kunne ikke opdateres",
      "helpCentre": "Hjælpecenter",
      "increaseLimitFurther": "Øg grænsen yderligere",
      "increaseLimitNow": "Øg grænsen nu",
      "lessThanUsage": "Det aktuelle forbrug er {usage}, og det valgte forbrug er mindre end det aktuelle forbrug.",
      "lessThanUsageModal": "Det aktuelle forbrug er {usage}, grænsen kan ikke være mindre end det aktuelle forbrug",
      "limitAlreadyUnlocked": "Grænsen er allerede låst op",
      "limitReached": "Grænse nået",
      "limitUpdatedFrom": "{type} grænse opdateret fra {old} til {new}",
      "lookingForSmsLimit": "Leder du efter SMS-begrænsningen?",
      "minLimitShould": "Min. grænse skal være {limit}",
      "newLimit": "Ny {type}-grænse",
      "perDay": "/dag",
      "sameLimit": "Den valgte grænse er den samme som den aktuelle grænse!",
      "smsLimitLocation": "SMS-grænsen kan nu findes på lokationsniveau",
      "smsLimitSettingsInfo": "Du finder nu disse indstillinger under \"Beskedgrænse\" i \"Avancerede indstillinger\".",
      "timesInLast30Days": "Gange i de seneste 30 dage",
      "todaysUsage": "Dagens brug",
      "typePerDay": "{type}/dag",
      "updateLimit": "Opdater grænse",
      "updateLimitFor": "Opdater {type}-grænsen for {name}"
    },
    "prospectDetails": {
      "activeCampaignsWorkflows": "Aktiv {type}",
      "contactSource": "Kontaktkilde",
      "customer": "Kunde",
      "noPastCampaignsWorkflows": "Ingen tidligere {type}",
      "pastCampaignsWorkflows": "Tidligere {type}"
    },
    "settings": {
      "affiliateSettings": "Indstillinger for tilknyttede enheder",
      "agencyBilling": "Agenturfakturering",
      "agencyTeamManagement": "Agenturets teamledelse",
      "apiKeys": "API-nøgler",
      "compliance": "Overholdelse",
      "customMenuLink": "Tilpasset menulink",
      "launchpadSettings": "Launchpad-indstillinger",
      "phoneSystemTwilio": "Telefonsystem - Twilio",
      "smtpService": "SMTP-service",
      "userSettings": "Brugerindstillinger",
      "agencySettings": "Agenturindstillinger",
      "mailgun": "MailGun"
    },
    "snapshot": {
      "errorCreating": "Fejl under oprettelse af øjebliksbillede",
      "pickAnAccount": "Du skal vælge en konto.",
      "snapshotName": "Navn på øjebliksbillede",
      "snapshotNameRequired": "Du skal give øjebliksbilledet et navn."
    },
    "socialDetails": {
      "blogRss": "Blog RSS",
      "foursquare": "Foursquare",
      "foursquareUrl": "Foursquare-URL",
      "googlePlacesId": "Google Places-ID",
      "googlePlus": "Google+",
      "googlePlusUrl": "Google+ URL",
      "instagramUrl": "Instagram-URL",
      "linkedInUrl": "LinkedIn-URL",
      "pinterest": "Pinterest",
      "pinterestUrl": "Pinterest URL",
      "yelp": "Yelp",
      "yelpUrl": "Yelp-URL",
      "youTube": "YouTube"
    },
    "requestSms": "Anmodning via SMS",
    "iAlreadyHaveACustomer": "Jeg har allerede en kunde",
    "noAccountFound": "Ingen konto blev fundet!!",
    "thisIs": "Dette er",
    "pleaseEnterValueBetween0To30Days": "Indtast en værdi mellem 0 og 30 dage",
    "learnHowToAddOneTimeSetupFeeToThesePlans": "Få mere at vide om, hvordan du inkluderer et engangsopsætningsgebyr for disse planer",
    "doNotDeleteStripeProductsWarning": "<span style=\"font-weight: bold;\">Slet ikke</span> disse produkter i din Stripe-konto",
    "opportunityStats": "Opportunitetsstatistik",
    "createNewSnapshot": "Opret et nyt øjebliksbillede",
    "stripeSettings": {
      "agencyDashboardVisibleTo": "Agenturets kontrolpanel synligt for",
      "onlyMe": "Kun mig",
      "allAgencyAdmins": "Alle agenturadministratorer",
      "stripeConnect": "Den vil snart blive udfaset. Skift til Stripe Connect",
      "recommendStripe": "Vi anbefaler at bruge Stripe Connect for bedre sikkerhed.",
      "switchToStripeConnect": "Skift til Stripe Connect",
      "highLevelAccess": "HighLevel vil have adgang til dine data og kan oprette betalinger og kunder på dine vegne.",
      "stripeAccountWarning": "Når forbindelsen er blevet oprettet, kan Stripe-kontoen ikke ændres senere. Det anbefales at bruge en ny Stripe-konto specielt til Highlevel-indtjening.",
      "connectToStripeAccount": "Forbind til din Stripe-konto",
      "unverified": "Den Stripe-konto, der er knyttet til dette bureau, er ikke bekræftet og kan ikke opkræve betalinger. Fuldfør bekræftelsen ved at logge ind på din Stripe-konto.",
      "loginToStripe": "Log ind på Stripe",
      "connectedAccount": "Tilknyttet konto",
      "verified": "Verificeret",
      "totalPendingBalance": "Udestående saldo i alt",
      "disconnectStripe": "Afbryd Stripe",
      "removeSaasPlanConfigurations": "Skal alle SaaS-planindstillinger fjernes?",
      "haveSaasPlans": "Du har oprettede SaaS-planer i Stripe-kontoen!",
      "disconnectWarning": "Hvis du afbryder, vil alle SaaS-planer gå tabt, og du vil være nødt til at oprette dem igen.",
      "acknowledgeDisconnect": "Jeg er bekendt med, at alle mine SaaS-planer vil gå tabt, og at jeg vil blive nødt til at oprette dem igen",
      "disconnect": "Afbryd"
    },
    "zoomSuccess": {
      "title": "Jeg håber, du havde en god oplevelse!",
      "message": "Tak fordi du var på telefonen. Jeg glæder mig til at være vært for dig igen!"
    },
    "supportDashboard": {
      "trialExperienceSpecialist": "Din specialist i prøveversionen",
      "successSpecialist": "Din success-specialist",
      "supportSpecialist": "Din supportspecialist",
      "jumpOnZoomCall": "Deltag i et Zoom-opkald med mig til dit kick-off-opkald",
      "jumpOnChat": "Hop ind på en chat med mig for at få hjælp",
      "joinVideoCallNow": "Deltag i videoopkald nu",
      "whatToExpect": "Hvad kan man forvente?",
      "helpArticles": "Hjælpeartikler",
      "changelog": "Ændringslog",
      "ideasBoard": "Idétavle"
    },
    "saasDashboard": {
      "title": "SaaS Dashboard",
      "plansAndPricing": "Planer og priser"
    },
    "listAccounts": {
      "newInterfaceAvailable": "En renere og hurtigere brugerflade er nu tilgængelig for denne side. Prøv den af!",
      "enableInLabs": "Aktivér i Labs",
      "pendingTransferRequests": "Du har afventende anmodninger om overførsel af underkonti.",
      "otherAgenciesRequested": "Andre bureauer har anmodet om at overføre underkonti til dig.",
      "reviewRequests": "Gennemgang af anmodninger",
      "clientList": "Klientliste (underkonti)",
      "subAccountTransfers": "Overførsler mellem underkonti"
    },
    "implementationModal": {
      "title": "Din oplevelse med videoopkald på højt niveau er lige ved at begynde!",
      "videoCall": "Videoopkald",
      "whatsNext": "Hvad er det næste?",
      "enteringLobby": "Du vil komme ind i vores lobby sammen med andre HighLevelers ligesom dig!",
      "successConcierge": "Vores succeskonsulent vil hilse på dig og forbinde dig med den næste ledige rådgiver til en 1:1-samtale.",
      "haveReady": "Hav følgende klar",
      "stableInternet": "Fast internetforbindelse.",
      "videoNameMatches": "Dit videonavn matcher dit HighLevel-brugernavn.",
      "estimatedDuration": "Anslået sessionsvarighed",
      "firstVisit": "Første besøg: HighLevel onboarding-session: (45-60 minutter).",
      "returning": "Tilbagelevering: Fortsat assistance til implementeringsopsætning (15-25 min).",
      "meetingBegins": "Dit møde begynder automatisk om <span class=\"text-[#155EEF]\">{ countdown } sekunder.</span>  Eller du kan tilmelde dig med det samme ved at klikke på knappen nedenfor:",
      "joinNow": "Deltag nu"
    },
    "gdpr": {
      "logo": "GDPR-logo",
      "dataProtection": "Databeskyttelse og GDPR",
      "introduction": "Indledning",
      "intro1": "HighLevel er forpligtet til at beskytte vores brugeres og deres kunders privatliv. Vi holder os opdateret om udviklingen inden for databeskyttelseslovgivningen for at sikre, at du kan være tryg ved din sikkerhed, når du bruger vores platform.",
      "intro2": "Denne side har til formål at forklare reglerne, hvordan de gælder for din brug af HighLevel-platformen, og de skridt, vi har taget for at overholde dem.",
      "intro3": " Du bør gennemgå dette dokument sammen med vores privatlivspolitik og kontakte en specialiseret jurist, hvis du har brug for yderligere information eller rådgivning.",
      "gdprRegulation": "Den generelle forordning om databeskyttelse (GDPR)",
      "regulation1": "Forordning (EU) 2016/679, bedre kendt som den generelle forordning om databeskyttelse (GDPR), er en EU-forordning, der har til formål at harmonisere databeskyttelses- og privatlivslovgivningen i hele EU. Bestemmelserne i GDPR gælder, når der er tale om personoplysninger om en registreret i EU.",
      "regulation2": "GDPR har fokus på at give enkeltpersoner mere kontrol over, hvordan virksomheder bruger deres data, og gøre indsamling og behandling af data mere gennemsigtig.",
      "regulation3": "GDPR blev indarbejdet direkte i britisk lov efter udløbet af Brexit-overgangsperioden, hvilket betyder, at britiske virksomheder stadig skal overholde dens bestemmelser gennem 'UK GDPR'.",
      "basicConcepts": "Grundlæggende GDPR-begreber",
      "controllerAndProcessor": "Dataansvarlig og databehandler",
      "controllerProcessorObligation": "GDPR pålægger en person forskellige forpligtelser afhængigt af, om vedkommende er dataansvarlig eller databehandler af personoplysninger.",
      "controllerDefinition": " En dataansvarlig er en enhed, der beslutter at behandle personoplysninger og træffer beslutninger om grundlaget for behandlingen og de metoder, der vil blive anvendt. Dataansvarlige har visse forpligtelser vedrørende personoplysninger, som du bør gøre dig bekendt med, inden du indsamler personoplysninger fra dine kunder.",
      "processorDefinition": "En databehandler er en enhed, der behandler data for og på vegne af en dataansvarlig. De træffer ingen uafhængige beslutninger vedrørende dataene eller deres behandling, da de kun behandler dem på vegne af den dataansvarlige og skal overholde alle instruktioner givet af den dataansvarlige.",
      "youAreController": "Når du bruger HighLevel-tjenesten, er du dataansvarlig. Du har kontrol over de data, du uploader til HighLevel-systemet, hvad du gør med disse data, og hvorfor. Som følge heraf er du ansvarlig for at sikre, at du har et retsgrundlag for at behandle dataene, og at du ikke opbevarer dataene længere end nødvendigt.",
      "highlevelIsProcessor": "Du bør sikre dig, at du forstår dine forpligtelser som dataansvarlig og opdaterer dine egne systemer og politikker for at tillade lovlig overførsel af personoplysninger til HighLevel. HighLevel er databehandler. Vi opbevarer og administrerer, via HighLevel-platformen, de data, du har indsamlet efter dine instruktioner. Vi vil aldrig bruge personoplysninger, som du har uploadet til HighLevel-systemet, til vores egne formål eller uden din instruktion.",
      "legalBasisForProcessing": "Retsgrundlag for behandling",
      "legalBasisRequirement": "Personoplysninger må kun indsamles og behandles, hvis der er et lovligt grundlag for det. De tilladte retsgrundlag er fastsat i GDPR.",
      "processorReliesOnCustomers": "Som databehandler er HighLevel afhængig af, at vores kunder vælger det korrekte grundlag for indsamling og behandling af personoplysninger, og at de indfører de nødvendige meddelelser og samtykker. Før du bruger HighLevel-tjenesten, bør du tage dig tid til at identificere, hvilke retsgrundlag der måtte være tilgængelige for dig, og kun indsamle og opbevare personoplysninger i det omfang, det er nødvendigt for at opfylde dette grundlag. Du bør ikke ændre det grundlag, hvorunder du har indsamlet personoplysninger, uden en særlig god grund, så det er vigtigt at forstå kravene i de forskellige grundlag og sørge for at vælge det rigtige fra starten.",
      "dataSubjectAccessRights": "Rettigheder til adgang for den registrerede",
      "dataSubjectRights": "GDPR giver registrerede (dvs. dine kunder) visse rettigheder vedrørende deres personoplysninger, herunder retten til at få adgang til, rette og/eller slette data vedrørende dem.",
      "highlevelEasySystems": "HighLevel har implementeret enkle systemer, så du kan informere os, hvis du modtager en sådan anmodning fra en registreret, og så vi kan informere dig, hvis vi modtager en sådan anmodning. Vi vil sørge for, at disse anmodninger imødekommes omgående i overensstemmelse med dine instruktioner. Du bør gøre dig bekendt med de forpligtelser, der pålægges dig, herunder i forbindelse med eventuelle personoplysninger, du opbevarer på dine egne systemer eller i andre tjenester end HighLevel.",
      "transfersToUSA": "Overførsler af data til USA",
      "transfersRestrictions": "Personoplysninger må ikke overføres uden for EØS, undtagen under særlige omstændigheder. Vi anvender standardkontraktbestemmelserne som en del af vores databehandleraftale, som vi underskriver med alle vores kunder.",
      "dataSecurity": "Datasikkerhed",
      "securitySafeguards": "Vi har indført stærke sikkerhedsforanstaltninger og -foranstaltninger for at sikre, at alle personoplysninger, vi opbevarer, opbevares sikkert. Vi tester regelmæssigt vores produkter for fejl og sårbarheder.",
      "backupSystems": "Vi sikrer, at vi har regelmæssige backupsystemer på plads, og at vi har systemer og processer til datagendannelse og dataintegritet for at minimere risikoen for beskadigelse eller tab af personoplysninger.",
      "stepsForCompliance": "Skridt, vi har taget for at sikre overholdelse af GDPR",
      "dutyAsProcessor": "Vi tager vores pligter som databehandler meget alvorligt. Vi har implementeret en række procedurer og taget en række skridt for at sikre, at vi fortsat overholder GDPR, og at du lovligt kan sende de personoplysninger, du har indsamlet, til os, for eksempel:",
      "standardContractualClauses": "Vores databehandleraftale anvender standardkontraktbestemmelserne for at sikre, at du lovligt kan sende personoplysninger til os i USA.",
      "detectBreaches": "Vi er i stand til at opdage personlige brud og informere vores kunder hurtigst muligt.",
      "dealWithAccessRequests": "Vi kan håndtere anmodninger om indsigt og sletning af personoplysninger og sørge for at informere dig, når en registreret person har fremsat en sådan anmodning til os.",
      "assessedDocumented": "Vi har vurderet og dokumenteret de personoplysninger, som vi behandler på dine vegne.",
      "assessedSecurity": "Vi har vurderet vores sikkerhed og opgraderet den, hvor det var nødvendigt, for at sikre, at den er passende i forhold til det risikoniveau, vi står over for i forbindelse med et databrud.",
      "dataProcessingAgreement": "Databehandleraftale",
      "dateUpdated": "Dato opdateret: 1. april 2023",
      "downloadAgreement": "Download aftale",
      "supportEmail": "support{'@'}gohighlevel.com",
      "anyQuestions": "Har du spørgsmål?"
    },
    "sendGridSettings": {
      "title": "SendGrid-indstillinger",
      "settingsForLocations": "SendGrid-indstillinger for lokationer",
      "sendGrid": "SendGrid",
      "last12Months": "De seneste 12 måneder",
      "totalSent": "Sendt i alt",
      "opens": "Åbner",
      "clicks": "Klik",
      "bounces": "Afvisninger"
    },
    "launchpadSettings": {
      "disableLaunchpad": "Deaktiver Launchpad for alle mine lokationer.",
      "description1": "Launchpad er en velgennemtænkt landingsside, der har vist sig at øge kundetilfredsheden og fastholdelsen ved at øge produktbrugen. ",
      "description2": "Det har vist sig at være fremragende funktioner at forbinde GMB, FB, webchat-plugin, mobilapp m.fl., som fastholder kunderne i længere tid.",
      "confirmDisable": "Er du sikker på, at du vil deaktivere Launchpad?"
    },
    "affiliateSettings": {
      "affiliateLinkDescription": "Dette er dit affiliate-link. Brug dette link til at give folk, du kender, mulighed for at oprette en konto. Du vil modtage 40 % af deres månedlige, tilbagevendende omsætning resten af livet.",
      "appendToUrls": "Tilføj dette til slutningen af dine URL'er:",
      "needToSignUp": "Har du brug for at tilmelde dig?",
      "goToUrl": "Gå til URL'en:",
      "andSignUpUsing": "og tilmeld dig ved hjælp af e-mailadressen",
      "asYourEmailAddress": "som din e-mailadresse til FirstPromoter.",
      "pageSettings": "Sideindstillinger",
      "facebookPixelId": "Facebook Pixel-id",
      "pixelId": "Pixel-id"
    },
    "agencyAPIKeySettings": {
      "enhancedAccountSecurity": "Fra den 17. juni 2024 vil Enhanced Account Security som standard automatisk blive aktiveret på din konto. De forbedrede sikkerhedsfunktioner omfatter:",
      "discontinuationOfAutoGeneration": "Ophør af automatisk generering af placerings-API-nøgler",
      "exclusionOfApiKeysInLocationCrudApis": "Udelukkelse af API-nøgler i placerings-CRUD API'er",
      "optOutLink": "For at fravælge denne ændring skal du deaktivere Udvidet kontosikkerhed i <a href=\"/settings/company\">Indstillinger &gt; Virksomhed</a>",
      "advancedFunctionalityNote": "Denne API er til avanceret funktionalitet. Vores supportteam er ikke i stand til at yde direkte assistance vedrørende API-konfigurationen.",
      "developerCouncilInfo": "Vi tilbyder et Udviklerråd, som mødes til kontortider en gang om måneden (<a href=\"https://gohighlevel.com/events\">https://gohighlevel.com/events</a>) og en Udviklerfællesskabs Slack-kanal, hvor du kan få hjælp fra fællesskabet og vores API-team. (<a href=\"https://www.gohighlevel.com/dev-slack\">https://www.gohighlevel.com/dev-slack</a>)",
      "zapierNote": "For at bruge Zapier skal du bruge Location API-nøglen for den specifikke placering. Du kan få det fra listen nedenfor eller ved at skifte til kontoen ved hjælp af skifteren i venstre menu.",
      "partOfAdvancedApi": "Dette er en del af den avancerede API, der er tilgængelig i Pro-abonnementet.",
      "upgradeMessage": "Dette er en del af den avancerede API, der er tilgængelig i Pro-abonnementet. <a>Klik her</a> for at opgradere."
    },
    "accountMap": {
      "addAccountManually": "Tilføj konto manuelt"
    },
    "accountTeamsManagement": {
      "settingsAsGroups": "Indstillinger som grupper."
    },
    "accountDetails": {
      "basicDetails": "Grundlæggende oplysninger",
      "saas": "SaaS",
      "rebilling": "Genfakturering",
      "marketplaceApps": "Marketplace-apps",
      "advancedEmailSettings": "Avancerede indstillinger",
      "calendarSettings": "Kalenderindstillinger"
    },
    "advancedEmailSettings": {
      "controlLocationSettings": "Administrer adresseindstillingerne",
      "disableAddEmailService": "Deaktiver knappen Tilføj e-mailservice i underkontoens indstillinger for e-mailservicer",
      "disableAddSmtp": "Deaktiver knappen Tilføj e-mailservice i underkontoens indstillinger for e-mailservicer",
      "restrictSubAccountEmailProvider": "Begræns underkonto-brugere i forhold til at indbefatte deres egen e-mailserviceudbyder",
      "disableAddSmtpDescription": "Begræns underkonto-brugere i forhold til at indbefatte deres egen e-mailserviceudbyder",
      "enableReVerification": "Aktivér genbekræftelse i 90 dage",
      "locationNoLeadConnector": "Placeringen har ikke LeadConnector som standard e-mailudbyder",
      "lcEmailNotEnabled": "Placeringen har ikke LeadConnector som standard-e-mailudbyder",
      "onlyForAgency": "Du kan kun se disse indstillinger aktiveret for et agentur",
      "onlyVisibleForAgency": "Du kan kun se disse indstillinger aktiveret for et agentur",
      "reVerificationDescription": "Hver e-mailbekræftelsesstatus vil blive tilbagekaldt efter 90 dage (beskyt dit afsenderomdømme, og sørg for maksimal leveringsdygtighed i indbakken)."
    }
  },
  "attributes": {
    "addAttribute": "Tilføj attribut",
    "attributeName": "Attributnavn",
    "enterAttributeName": "Indtast attributnavn",
    "number": "Nummer",
    "selectAttributeType": "Vælg attributtype"
  },
  "audit": {
    "changeModal": {
      "additionalMetaData": "Yderligere metadata",
      "title": "Tilføjede/opdaterede felter"
    }
  },
  "bulkActions": {
    "additionalDetails": "Yderligere oplysninger",
    "allOnGivenDate": "Alt på den givne dato",
    "attempted": "Forsøgt",
    "batchQuantity": "Batchmængde",
    "bulkActionProcessing": "Massehandlingsbehandling",
    "bulkActionTitle": "Massehandling",
    "campaignRequired": "Kampagne er påkrævet",
    "currentStatus": "Aktuel status",
    "delayBetweenBatches": "Forsinkelse mellem batches",
    "dispatchMode": "Forsendelsestilstand: {mode}",
    "editBatchQuantity": "Rediger batchmængde",
    "emailStats": "E-mailstatistik",
    "enterBatchSprintLimit": "Angiv en grænse for batch-sprint",
    "hideStats": "Skjul statistikker",
    "mode": "Tilstand",
    "nextProcessingOn": "Næste behandling den",
    "noStatsFound": "Ingen statistik fundet",
    "parentBulkActionID": "Overordnet massehandling-ID",
    "pleaseEnterQuantity": "Indtast en mængde",
    "processAllAsSoonAsPossible": "Behandl alle så hurtigt som muligt",
    "processAllOnGivenDate": "Behandl alle på en given dato",
    "processDuring": "Behandl under",
    "processGraduallyDrip": "Behandl gradvist (dryp)",
    "processingAllowedOn": "Behandling tilladt på",
    "restoredBulkActionId": "Gendannet massehandlings-ID:",
    "revert": "Fortryd",
    "revertedBulkActionId": "Tilbageført massehandlings-ID:",
    "saveChanges": "Gem ændringer",
    "scheduledStart": "Planlagt start",
    "showErrorLog": "Vis fejllog",
    "showImported": "Vis importeret",
    "showStats": "Vis statistik",
    "skipped": "Sprunget over",
    "statistics": "Statistik",
    "statuses": {
      "complete": "Gennemfør",
      "next-drip": "Næste dryp",
      "notStarted": "Ikke startet",
      "processing": "Behandler",
      "queueing": "Står i kø",
      "reading": "Læsning",
      "resumed": "Genoptaget",
      "reverted": "tilbageført",
      "waiting": "Venter"
    },
    "successful": "Vellykket",
    "tagsAdded": "Tags tilføjet",
    "tagsRemoved": "Tags slettet",
    "tagsRestored": "Tags gendannet",
    "timeElapsed": "Forløbet tid",
    "totalExported": "Eksporteret i alt",
    "totalMerge": "Flettet sammen i alt",
    "unknownError": "Ukendt fejl",
    "updateBatchQuantity": "Opdatere batchmængde",
    "updated": "Opdateret",
    "usesDynamicList": "** Bruger dynamisk liste",
    "workflowRequired": "Arbejdsgang er påkrævet"
  },
  "business": {
    "addedToCompany": "Kontakter blev tilføjet til virksomheden",
    "cantAddMoreContacts": "Kan ikke tilføje mere end 50 kontakter ad gangen",
    "cleanerUi": "En renere brugergrænseflade",
    "common": {
      "addContact": "Tilføj kontakt",
      "internalServerError": "Intern serverfejl",
      "to": "til"
    },
    "companiesNowHave": "Virksomheder har nu",
    "companyNoteLabsText": "Firmanotater er en laboratoriefunktion",
    "contactRemoveCompany": "Er du sikker på, at du vil fjerne denne kontakt fra virksomheden?",
    "moreFunctionalUx": "Mere funktionel brugeroplevelse",
    "newCompanyUpdate": "Ny virksomhedsopdatering!",
    "tabs": "Faner",
    "tasks": {
      "assignTask": "Tildel opgave",
      "assignee": "Ansvarlig part",
      "deleteTask": "Slet opgave",
      "editTask": "Rediger opgave",
      "markAsComplete": "Markér som gennemført",
      "markAsPending": "Markér som afventende",
      "nameAndDescription": "Navn og beskrivelse",
      "noTasksAvailable": "Ingen tilgængelige opgaver"
    },
    "visitLabs": "Besøg laboratoriet"
  },
  "calendar": {
    "googleCalendar": "Google Kalender",
    "noSync": "Ingen synkronisering",
    "outlookCalendar": "Outlook-kalender"
  },
  "common": {
    "topBar": {
      "toggleFrontendDebugger": "Slå frontend-debugger til/fra"
    },
    "icons": {
      "star": ""
    },
    "errorOccurred": "Der opstod en fejl. Prøv igen.",
    "tabs": "Faner",
    "showPassword": "Vis adgangskode",
    "hidePassword": "Skjul adgangskode",
    "goToHomepage": "Gå til startsiden",
    "leadConnectorHqLogo": "Lead Connector HQ logo",
    "companyLogo": "Firmalogo",
    "countries": {
      "australia": "Australien",
      "austria": "Østrig",
      "czechRepublic": "Tjekkiet",
      "belgium": "Belgien",
      "brazil": "Brasilien",
      "canada": "Canada",
      "chile": "Chile",
      "denmark": "Danmark",
      "switzerland": "Schweiz",
      "germany": "Tyskland",
      "estonia": "Estland",
      "spain": "Spanien",
      "finland": "Finland",
      "france": "Frankrig",
      "uk": "Storbritannien",
      "hongKong": "Hongkong",
      "hungary": "Ungarn",
      "ireland": "Irland",
      "italy": "Italien",
      "japan": "Japan",
      "kenya": "Kenya",
      "lithuania": "Litauen",
      "mexico": "Mexico",
      "netherlands": "Holland",
      "newZealand": "New Zealand",
      "norway": "Norge",
      "philippines": "Filippinerne",
      "puertoRico": "Puerto Rico",
      "poland": "Polen",
      "portugal": "Portugal",
      "sweden": "Sverige",
      "singapore": "Singapore",
      "unitedStates": "USA",
      "vietnam": "Vietnam",
      "southAfrica": "Sydafrika"
    },
    "countryshortcodes": {
      "ca": "CA",
      "eu": "EU",
      "in": "IN",
      "na": "Ikke relevant",
      "us": "US"
    },
    "misc": {
      "0": "0",
      "1": "1",
      "10": "10",
      "10x": "10x",
      "1 (555) 987-6543": "+1 (555) 987-6543",
      "1x": "1x",
      "3x": "3x",
      "720_x_720_px": " 720 x 720 px",
      "x": "x",
      "g": "G",
      "m": "/M",
      "s": "s",
      "k": " K",
      "esc": "ESC",
      "fb": "fb",
      "ghl": "GHL",
      "mrr": "MRR",
      "dnd": "DND",
      "gbp": "GBP",
      "sms": "SMS",
      "api": "API",
      "otp": "Engangsadgangskode",
      "tcr": "TCR",
      "ein": "EIN",
      "acn": "ACN",
      "cbn": "CBN",
      "vat": "moms",
      "cvv": "CVV",
      "amex": "AMEX",
      "visa": "VISA",
      "mastercard": "MasterCard",
      "dinersClub": "Diners Club",
      "2fa": "2FA",
      "ivr": "IVR",
      "ppc": "PPC",
      "cpaas": "CPaaS",
      "lc": "LC",
      "a2p": "A2P",
      "sha": "SHA",
      "_frameborder0_scrollingauto_width100_height500ifra": "&quot; frameborder=&quot;0&quot; scrolling=&quot;auto&quot; width=&quot;100%&quot; height=&quot;500&quot;&gt;</iframe>",
      "iframe_src": "<iframe src=\"",
      "editNumberPoolStrongnamestrong": "Rediger nummerpulje - <strong>{name}</strong>",
      "displayphonenumber": "Telefonnummer",
      "js_heap_memory": "JS Heap-hukommelse",
      "vuex_store_modules": "Vuex Store-moduler",
      "vuex_store_size": "Vuex Store-størrelse",
      "admanagerlogo": "ad-manager-logo",
      "seosearchatlaslogo": "seo-search-atlas-logo",
      "modelimage": "model-image",
      "tipaltiiframe": "tipalti-iframe",
      "fileimage": "billedfil",
      "urlimage": "url-image",
      "msgsndr8": "msgsndr8",
      "testmaindomaincom": "testmain{'@'}domain.com",
      "webdevexamplecom": "web-dev{'@'}example.com",
      "httpexamplecom": "http://example.com",
      "smtpgmailcom": "smtp.gmail.com",
      "xyzcomOrUtmcampaignxyz": "xyz.com eller utm_campaign=xyz",
      "websitecom": "website.com",
      "strongshakenstirstrongVerifica": "<strong>SHAKEN/STIR</strong> -bekræftelsen er fuldført for din underkonto. Opbyg tillid hos dine kunder gennem verificerede opkald.",
      "mp3wavfile": "mp3/wav-fil",
      "usd": "$",
      "1_555_9876543": "+1 (555) 987-6543"
    },
    "stepProgress": "Trin {currentStep} af {totalSteps}",
    "loadMore": "Indlæs mere",
    "1_segment_is_equal_to_a_sms_of_160_characters_clic": "1 segment svarer til en SMS på 160 tegn. Klik på ikonet for at få flere oplysninger om prissætning.",
    "1_segment_is_equal_to_an_sms_of_160_characters_cli": "1 segment svarer til en SMS på 160 tegn. Klik på ikonet for at få flere oplysninger om prissætning.",
    "_email": "/e-mail",
    "_ip": "/IP",
    "_min": " /min.",
    "_of_total": "% af total",
    "_please_add_a_payment_method_for": "Tilføj en betalingsmetode til ",
    "_segment": " /segment",
    "_used": "% brugt",
    "a_new_twilio_account_needs_to_be_created_before_we": "En ny Twilio-konto skal oprettes, før vi kan begynde at genfakturere",
    "a_sub_account_can_have_up_to_10_custom_objects_if_": "En underkonto kan have op til 10 brugerdefinerede objekter. Hvis grænsen overskrides, oprettes der ingen brugerdefinerede elementer ud fra dette øjebliksbillede.",
    "a_twilio_account_is_already_setup_for_this_location": "En Twilio-konto er allerede oprettet til denne placering",
    "accountName": "Kontonavn",
    "account_sid": "Konto-SID:",
    "action": "Handling",
    "actions": "Handlinger",
    "activate": "Aktivér",
    "active": "Aktiv",
    "active_listeners": "Aktive lyttere",
    "active_subscriptions": "Aktive abonnementer",
    "ad_manager": " Annonceadministrator",
    "add": "Tilføj",
    "addAction": "Tilføj handling",
    "add_eliza": "Tilføj Eliza",
    "add_image": "Tilføj billede",
    "add_payment_method": "Tilføj betalingsmetode",
    "add_to_account": "Tilføj til konto",
    "add_user_icon": "Tilføj brugerikon",
    "add_your_first_email": "Tilføj din første e-mail.",
    "address": "Adresse",
    "adwords_reporting": "Adwords-rapportering",
    "affiliate_manager": "Tilknyttet enheds-manager",
    "agency": "Agentur",
    "agency_logo": "agentur-logo",
    "agency_settings": "Agenturindstillinger",
    "agent_reporting": "Agentrapportering",
    "ai_employee": " AI Employee ",
    "all": "Alle",
    "allow_subaccounts_to_cancel_their_subscription": "Tillad underkonti at opsige deres abonnement",
    "allow_subaccounts_to_upgrade_to_a_higher_plan": "Tillad underkonti at opgradere til en højere plan",
    "allowed_format": "Tilladt format:",
    "am": "AM",
    "announcements_click_to_open_in_new_tab": "Meddelelser - klik for at åbne i en ny fane",
    "answers": "Besvaret",
    "app_name": "App-navn",
    "appointments": "Aftaler",
    "apps": " apps",
    "ask_ai": "Ask AI",
    "ask_anything": "Spørg om hvad som helst ...",
    "assigned_to_another_user": "(Tildelt til en anden bruger)",
    "at_least_one_location_is_required": "Mindst én placering er påkrævet",
    "attach_snapshot": "Vedhæft øjebliksbillede",
    "attribution_reporting": "Attributionsrapportering",
    "authorized_representative": "Autoriseret repræsentant",
    "automation_type": "Automatiseringstype",
    "available_hours": "Tilgængelige timer",
    "avg_memoryinstance": "Gns. hukommelse/instans",
    "back": "Tilbage",
    "base_url": "Grundlæggende URL",
    "between_10_kb_and_5_mb": " Mellem 10 KB og 5 MB",
    "birthday_sms": "Fødselsdags-SMS",
    "birthday_sms_with_image": "Fødselsdags-SMS med billede",
    "blogging": "Blogging",
    "bounced": "Afvist",
    "bulk_requests": "Masseanmodninger",
    "business_email": "Virksomhedsmail",
    "business_hours_configurations": "Konfigurationer af arbejdstider",
    "business_industry": "Virksomhedens branche",
    "business_information": "Virksomhedsoplysninger",
    "business_logo": "Virksomhedslogo",
    "business_niche": "Virksomhedens niche",
    "business_phone": "Virksomhedens telefon",
    "business_physical_address": "Virksomhedens fysiske adresse",
    "business_regions_of_operations": "Forretningsområder for aktiviteter",
    "business_registration_id_type": "ID-type for virksomhedsregistrering",
    "business_registration_number": "Virksomhedsregistreringsnummer",
    "business_type": "Virksomhedstype",
    "business_website": "Virksomhedens website",
    "busy": "Optaget",
    "buttons": {
      "cancel": "Annuller",
      "confirm": "Bekræft",
      "deleteAll": "Slet alle",
      "view": "Vis",
      "close": "Luk",
      "previous": "Forrige",
      "next": "Næste",
      "clear": "Ryd",
      "save": "Gem",
      "edit": "Rediger",
      "delete": "Slet",
      "reset": "Nulstil",
      "refresh": "Opdater",
      "nextLoading": "Næste ...",
      "copied": "Kopieret",
      "notNow": "Ikke nu",
      "send": "Send",
      "send1": "Send",
      "download": "Download",
      "sendNow": "Send nu",
      "saved": "Gemt",
      "back": "Tilbage",
      "update": "Opdater",
      "add": "Tilføj",
      "submit": "Indsend",
      "submitting": "Indsender",
      "done": "Færdig",
      "manageUsers": "Administrer brugere",
      "no": "Nej",
      "yes": "Ja"
    },
    "calendar": "Kalender",
    "calendar_groups": "Kalendergrupper",
    "call": "Opkald",
    "call_reporting": "Opkaldsrapportering",
    "call_tracking_is_disabled": "Opkaldssporing er deaktiveret.",
    "call_voicemail_settings": "Indstillinger for opkald og talebeskeder",
    "calls": " opkald",
    "campaign": "Kampagne",
    "campaigns": "Kampagner",
    "cancel": " Annuller ",
    "cancel_subscription": "Annuller abonnement",
    "cancelled": "Annulleret",
    "certificates": "Certifikater",
    "change": "Skift",
    "changed_data": "Ændrede data",
    "charge": " Opkræv",
    "charged_to_customer": "Opkrævet fra kunden",
    "chat": "Snak",
    "chat_user": "Chatbruger",
    "chat_widget_icon": "Chat-widget-ikon",
    "chats_will_be_saved_for_2_days": "Chats vil blive gemt i 2 dage",
    "check": "kontrol",
    "check_number_validity_before_first_sms_block_incom": "Tjek nummerets gyldighed før første SMS, bloker indgående spamopkald og slå navne på ukendte opkaldere op, før du tager telefonen. Der pålægges yderligere gebyrer",
    "cinque_terre": "Cinque Terre",
    "city": "By",
    "clear_history": "Ryd historik",
    "click_here": "Klik her",
    "click_on_create_new_snapshot_to_add_one": " Klik på Opret nyt øjebliksbillede for at tilføje et.",
    "click_to_access_the_highlevel_welcome_course": "Klik for at få adgang til HighLevel-velkomstkurset",
    "click_to_upgrade": "Klik for at opgradere",
    "clicked": "Klikket",
    "clio": "Clio",
    "cloning": "Kloning",
    "close_debugger": "Luk debugger",
    "close_whatsapp_template_creator": "Luk WhatsApp-skabelonværktøj",
    "collection": "Samling",
    "columns": "Kolonner",
    "coming_soon": "Kommer snart",
    "company_email_": "Virksomhedens e-mail (",
    "complete_component_data": "Komplette komponentdata",
    "complete_event_data": "Komplette hændelsesdata",
    "complete_query_data": "Komplette forespørgselsdata",
    "completed": "Fuldført",
    "complimentary_credits": "Gratis kreditter",
    "component": "Komponent",
    "component_name": "Komponentnavn",
    "component_type": "Komponenttype",
    "components": " komponenter",
    "condition": "Betingelse",
    "confirm": "BEKRÆFT",
    "confirmation_message": "Bekræftelsesbesked",
    "confirmed": "Bekræftet",
    "connect_with_a_certified_admin_click_to_open_in_ne": "Forbind med en certificeret administrator - klik for at åbne i en ny fane",
    "connect_with_us_start_live_chat": "Kontakt os - start livechat",
    "connect_your_stripe_account": "Tilslut din Stripe-konto ",
    "connect_zoom": "Forbind Zoom",
    "consider_leaving_it_blank_should_you_choose_to_use": "Overvej at lade det stå tomt, hvis du vælger at bruge det forudkonfigurerede mødested",
    "contact": "Kontakt",
    "contact_support": "kontakt support",
    "contact_us_call_highlevel_at_18887324197": "Kontakt os - ring til HighLevel på +1(888)732-4197",
    "contacts": "Kontakter",
    "content_ai": "Content AI",
    "controls": "Kontrolelementer",
    "conversations": "Samtaler",
    "copied": "Kopieret",
    "cost_borne_by_you": " omkostninger, som du selv skal afholde.",
    "count": "Optælling",
    "country": "Land",
    "createNewFolder": "Opret ny mappe",
    "credit_balance": "Kreditsaldo",
    "current_location_id": "Aktuelt lokations-ID",
    "custom": "Tilpasset",
    "custom_email": "Tilpasset e-mail",
    "custom_niche": "Tilpasset niche",
    "customer_notifications": "Kundemeddelelser",
    "customize": "Tilpas",
    "customize_chat_widget": "Tilpas chat-widget",
    "dashboard_stats": "Dashboard-statistik",
    "data_keys": "Datanøgler",
    "date": "Dato",
    "days": "Dage",
    "dedicated_ip": "Dedikeret IP ",
    "default": "Standard",
    "default_snapshots": "Standardøjebliksbilleder",
    "delete": "Slet",
    "deleted": "slettet",
    "delivered": "Leveret",
    "description": "Beskrivelse",
    "details": "Oplysninger",
    "disable_gbp_messaging_not_recommended": "deaktiver GBP-beskeder (ikke anbefalet)",
    "disable_tracking": "Deaktiver sporing",
    "disabled": "Deaktiveret",
    "dismiss": "Afvis",
    "display_name": "Visningsnavn",
    "do_not_delete": "må ikke slettes",
    "do_something": "Gør noget",
    "do_you_want_to_keep_the_same_or_create_a_new_one": "Vil du beholde den samme eller oprette en ny?",
    "download_application_icon": "Download applikationsikon",
    "draft": "Kladde",
    "dropdown_icon": "rullemenuikon",
    "duplicate": "Dupliker",
    "duration": "Varighed",
    "eliza": "Eliza",
    "eliza_bypass_tag_optional": "Eliza Bypass-tag (valgfrit)",
    "eliza_is_required": "Eliza er påkrævet.",
    "eliza_service": "Eliza-service",
    "email": "E-mail",
    "email_resell_settings": "Indstillinger for videresalg af e-mail",
    "email_sending": "Afsendelse af e-mail",
    "email_signature": "E-mailsignatur",
    "enable": "Aktivér",
    "enable_beta": " Aktivér betaversion",
    "enable_company_automation": "Aktivér virksomhedsautomatisering",
    "enable_disable_deprecated_features": "Aktiver/deaktiver forældede funktioner",
    "enable_gbp_call_tracking": " Aktivér GBP-opkaldssporing ",
    "enable_gbp_messaging": "aktivér GBP-beskeder",
    "enable_signature_on_all_outgoing_messages": "Aktivér signatur på alle udgående meddelelser",
    "enabled": "Aktiveret",
    "notEnabled": "Ikke aktiveret",
    "enter_a_logical_name": "Indtast et logisk navn",
    "enter_the_exact_business_address_as_it_appears_in_": "Indtast den præcise virksomhedsadresse, som den fremgår af EIN-listen.",
    "enter_the_exact_legal_business_name_as_registered_": "Indtast det nøjagtige juridiske virksomhedsnavn, som er registreret hos EIN.",
    "enter_the_full_street_address_as_it_appears_in_the": "Indtast den fulde gadeadresse, som den fremgår af EIN-listen.",
    "enter_user_email": "Indtast brugerens e-mailadresse",
    "enter_user_phone_number": "Indtast brugerens telefonnummer",
    "enter_your_business_registration_id_type": "Indtast din virksomheds registrerings-ID-type",
    "enter_your_business_vertical_eg_travel": "Indtast din virksomhedsbranche (f.eks.: Rejser)",
    "error_code": "Fejlkode",
    "error_code_chart": "Diagram over fejlkoder",
    "error_while_copying_api_key": "Fejl ved kopiering af API-nøgle!",
    "event": "Begivenhed",
    "event_bus_listeners": "Eventbus-lyttere",
    "events": " begivenheder",
    "everything_in": "Alt i ",
    "exact": "Præcis",
    "execute_this_action_if_the_current_time_falls_in_t": "Udfør handlingen, hvis det aktuelle tidspunkt falder inden for dette vindue. Ellers vent til det næste vindue for at udføre handlingen.",
    "extension": "Forlængelse",
    "facebook": "Facebook",
    "facebook_ads": "Facebook-annoncer",
    "facebook_ads_reporting": "Facebook-annoncerapportering",
    "facebook_adsets": "Facebook AdSets",
    "facebook_campaigns": "Facebook-kampagner",
    "facebook_icon": "Facebook-ikon",
    "facebook_page": "Facebook-side",
    "feature_image": "Fremhævet billede",
    "features": "Funktioner:",
    "feedback": "Feedback: ",
    "file_path": "Filsti",
    "firestore_listeners": "Firestore-lyttere",
    "forms": "Formularer",
    "free": "Gratis",
    "fri": "Fre",
    "friendly_business_name": "Venligt firmanavn",
    "from": " fra ",
    "funnels": "Tragter",
    "gbp_call_tracking": "GBP Call Tracking",
    "gbp_configuration": "GBP-konfiguration",
    "general": "Generelt",
    "general_information": "Generelle oplysninger",
    "generating_link_please_wait": "Genererer link, vent et øjeblik ...",
    "google_ads_adgroups": "Google Ads AdGroups",
    "google_ads_ads": "Google Ads-annoncer",
    "google_ads_campaigns": "Google Ads-kampagner",
    "google_ads_keywords": "Google Ads-nøgleord",
    "google_business_messaging": "Google Business Messaging",
    "google_business_profile": "Google Business-profil",
    "google_my_business_icon": "Google My Business-ikon",
    "hello": "Hej ",
    "here": "her",
    "hhmm_a": "tt:mm A",
    "hi": "Hej ",
    "hide": "Skjul",
    "highlevel_events_click_to_open_in_new_tab": "Highlevel Events - klik for at åbne i en ny fane",
    "how_can_i_help_you_today": "Hvordan kan jeg hjælpe dig i dag?",
    "how_did_the_call_go": "Hvordan gik opkaldet?",
    "how_do_i_calculate_my_email_cost_click_on_the_icon": "Hvordan beregner jeg min e-mailpris? Klik på ikonet for at få mere at vide",
    "how_does_it_work": "Hvordan fungerer det?",
    "htmlElement": "HTML-element (TODO):",
    "html_element_todo": "HTML-element (TODO): ",
    "id": "ID: ",
    "if": "Hvis",
    "if_activated_the_sender_information_will_be_automa": "Hvis den er aktiveret, vil afsenderoplysningerne automatisk blive tilføjet til den første SMS-besked i alle massebeskeder for at sikre overholdelse og øge leveringsraterne.",
    "if_activated_we_will_insert_unsubscribe_links_in_y": "Hvis det er aktiveret, vil vi indsætte afmeldingslinks i sidefoden af dine e-mails, så modtagerne kan afmelde sig uden at markere e-mailen som en klage/spam.",
    "ignore_this_update": "Ignorer denne opdatering",
    "image": "billede",
    "image_turned_on": "Billede aktiveret",
    "imported_date": "Importeret dato",
    "imported_snapshots": "Importerede øjebliksbilleder",
    "inbound": "Indgående",
    "inbound_number": "Indgående nummer",
    "incoming_call_timeout": "Timeout for indgående opkald",
    "instance_id": "Instans-ID",
    "instances": "Eksempler: ",
    "instructions_mentioned_in_this_page": "instruktionerne nævnt på denne side",
    "internal": "Intern",
    "intro_message": "Introbesked",
    "intro_question": "Introspørgsmål",
    "invalid": "Ugyldig",
    "invoicing": "Fakturering",
    "is_scheduled_for_deletion_on": " er planlagt til at blive slettet den ",
    "job_position": "Jobposition",
    "job_title": "Jobtitel",
    "join_our_facebook_group_click_to_open_in_new_tab": "Bliv medlem af vores Facebook-gruppe – klik for at åbne i en ny fane",
    "jpg_or_png": " JPG eller PNG ",
    "just_one_sec": "Et øjeblik ...",
    "key_sizes": "Vigtige størrelser",
    "label": "etiket",
    "labels": {
      "sortDirection": "Sorteringsretning",
      "tableStyling": "Tabelstil",
      "loadingMore": "Indlæser mere ...",
      "loading": "Indlæser ...",
      "filter": "Filtrer",
      "search": "Søg ...",
      "sortBy": "Sortér efter",
      "perPage": "Pr. side",
      "date": "Dato",
      "time": "Tidspunkt",
      "readMore": "Læs mere",
      "day": "Dag",
      "slot": "Tidsrum",
      "template": "Skabelon",
      "city": "By",
      "country": "Land",
      "state": "Stat",
      "customerName": "Kundenavn",
      "friendlyName": "Venligt navn",
      "required": "* påkrævet",
      "addressLine1": "Adresselinje 1",
      "addressLine2": "Adresselinje 2",
      "postalCode": "Postnummer",
      "searchUsers": "Søg efter brugere",
      "unknown": "Ukendt",
      "businessName": "Firmanavn"
    },
    "last_updated": "Senest opdateret",
    "launchpad_icon": "Launchpad-ikon",
    "lead": "Kundeemne",
    "leadconnector": "LeadConnector",
    "learn_how": "(Lær hvordan?)",
    "legal_business_name": "Juridisk virksomhedsnavn",
    "limit_updated_from": " grænse opdateret fra ",
    "listeners": " lyttere",
    "loading_your_conversation_history": "Indlæser din samtalehistorik ...",
    "location": "Placering",
    "locations": " placeringer",
    "logical_name": "Logisk navn",
    "logical_name_is_required": "Logisk navn er påkrævet.",
    "logo": "Logo",
    "mailgun": "MailGun",
    "making_calls": "Foretag opkald",
    "manage_custom_email": "Administrer tilpasset e-mail",
    "marketing": "Markedsføring",
    "maximize": "Maksimer",
    "me_": "Mig (",
    "member_since": "Medlem siden",
    "membership": "Medlemskab",
    "memory_analysis": "Hukommelsesanalyse",
    "memory_api_not_available": "Hukommelses-API ikke tilgængelig",
    "message": "Besked",
    "minimize": "Minimer",
    "minimum_must_be": " Minimum skal være ",
    "miscellaneous_charges": "Diverse gebyrer",
    "missed_call_text_back": "Send sms ved ubesvaret opkald",
    "missed_text_back_call_message": "SMS om manglende opkald tilbage",
    "model": "Model",
    "module": "Modul",
    "modules": " moduler",
    "mon": "Man",
    "month": "/måneden",
    "monthly": "månedligt",
    "more_emails_in_thread": " flere e-mails i tråd",
    "mount_count": "Monteringsantal",
    "mount_time": "Monteringstid",
    "moved_to_calendar_settings": "Flyttet til kalenderindstillinger",
    "multiple_locations_using_same_twilio_account": "Flere lokationer bruger den samme Twilio-konto",
    "must_be_in_range_of_0": " Skal være inden for intervallet 0-",
    "must_be_less_than_monthly_plan_12": " Skal være mindre end den månedlige plan * 12 ",
    "my_business_is": "Min virksomhed er ",
    "my_snapshots": "Mine øjebliksbilleder",
    "name": "Navn",
    "name_of_other_registration_id_type": "Navn på anden registrerings-ID-type",
    "newFolder": "Ny mappe",
    "new_task_update": "Ny opgaveopdatering!",
    "next": "Næste",
    "no_answer": "Intet svar",
    "no_bigger_than_25mb": "ikke større end 2,5 MB",
    "no_customer_selected": "Ingen kunde valgt",
    "no_error_data_found": "Der blev ikke fundet nogen data",
    "no_payment_method_available": "Ingen betalingsmetode tilgængelig",
    "no_provider_found": "Ingen udbyder blev fundet",
    "no_snapshots_found": "Ingen øjebliksbilleder fundet.",
    "noshow": "Udeblevet",
    "not": "Ikke",
    "not_now": "Ikke nu",
    "not_saved": "Ikke gemt",
    "notes": "Noter",
    "notifications": "Notifikationer",
    "now": "Nu",
    "numbers_and": " nummer/numre og ",
    "objective": "Målsætning:",
    "of": "af",
    "onboarding_video_tutorials_click_to_open_in_new_ta": "Onboarding-videovejledninger - klik for at åbne i en ny fane",
    "online_listings": "Onlineannoncer",
    "only_assigned_data": "Kun tildelte data",
    "open_performance_debugger": "Åbn ydeevnedebugger",
    "opened": "Åbnet",
    "opportunities": "Muligheder",
    "options": {
      "ascending": "Stigende",
      "descending": "Faldende",
      "none": "-- Ingen --"
    },
    "or_drag_and_drop": "eller træk og slip",
    "outbound": "Udgående",
    "pagination": "Sideinddeling",
    "pass_body_content_here": " Send brødtekstindhold her ",
    "password": "Adgangskode",
    "paused": "Sat på pause",
    "payment_links": "Betalingslinks",
    "payment_methods": "Betalingsmetoder",
    "payment_refund": "Tilbagebetaling",
    "payment_settings_navigation": "Navigering til betalingsindstillinger",
    "payments": "Betalinger",
    "payments_integration": "Betalingsintegration",
    "pending": "Afventer",
    "per_page": "Pr. side",
    "percentage": "Procentdel",
    "permanently_delete_this_email": "Slet denne e-mail permanent",
    "personal_logo": "Personligt logo",
    "phone": "Telefon",
    "phone_number_with_country_code": "Telefonnummer (med landekode)",
    "pick_a_niche": "Vælg en niche",
    "pick_a_snapshot": "Vælg et øjebliksbillede",
    "pick_business_industry": "Vælg branche",
    "pick_business_registration_id_type": "Vælg virksomhedens registrerings-ID-type",
    "pick_business_type": "Vælg virksomhedstype",
    "pick_job_position": "Vælg en jobposition",
    "plans_pricing": "Planer og priser",
    "please_enter_a_value_greater_than_20": "Indtast en værdi over 20.",
    "pm": "PM",
    "points": "Point",
    "postalzip_code": "Postnummer",
    "previous": "Tidligere",
    "privacy_policy_url": "Privatlivspolitik-URL",
    "privacy_policy_url_will_be_shown_on_your_google_ag": "URL'en til privatlivspolitikken vil blive vist i dine Google Agent-oplysninger.",
    "process_your_payment": "Behandl din betaling",
    "profile_picture": "Profilbillede",
    "profit": "Fortjeneste",
    "prospecting": " Prospektering ",
    "provide_prebuild_snapshots_to_the_new_accounts": "Giv forudbyggede snapshots til de nye konti.",
    "queries": " forespørgsler",
    "questions": "Spørgsmål",
    "quick_actions_icon": "Ikon for hurtige handlinger",
    "re_generate_key": "Generér nøgle igen",
    "read_only": "Skrivebeskyttet",
    "receipts_settings": "Indstillinger for kvitteringer",
    "receiving_calls": "Modtag opkald",
    "recent_events": "Seneste begivenheder",
    "recommended": "Anbefalet",
    "recommended_resolution": "Anbefalet opløsning:",
    "reconnect": "Opret forbindelse igen ",
    "record_payment": "Registrer betaling",
    "registered": " registreret.",
    "renameFolder": "Omdøb mappe",
    "replied": "Besvaret",
    "representative_email": "Repræsentantens e-mail",
    "resell_settings": " Indstillinger for videresalg",
    "reset": "Nulstil",
    "resolve_now": "Løs nu",
    "resource_counts": "Ressourceantal",
    "restore": "Gendan",
    "results": "Resultater",
    "reviews": "Anmeldelser",
    "rollover_unused_credits_to_next_month": "Overfør ubrugte kreditter til næste måned",
    "row": " række",
    "runNow": "Kør nu",
    "sample_data": "(Eksempeldata)",
    "sat": "Lør",
    "save": "Gem",
    "save_missed_call_text_settings": "Gem indstillinger for ubesvarede opkaldstekster",
    "save_staging_url": "Gem iscenesættelses-URL",
    "saved": "Gemt",
    "saving": "Gemmer ...",
    "search": "Søg",
    "search_active_apps": "Søg efter aktive apps ...",
    "search_components": "Søg efter komponenter ...",
    "search_customer": "Søg efter kunde",
    "search_email": "Søg efter e-mail",
    "search_history": "Søg i historik ...",
    "search_icon": "søgeikon",
    "search_listeners": "Søg efter lyttere ...",
    "search_modules": "Søg i moduler ...",
    "search_queries": "Søgeforespørgsler ...",
    "see_this_review_on_gbp": "Se denne anmeldelse på GBP ",
    "segments": " segmenter",
    "select": "Vælg",
    "select_a_snapshot": "Vælg et øjebliksbillede",
    "monetary": "MONETÆR",
    "pleaseSelectAValue": "Vælg en værdi",
    "select_account": "Vælg konto",
    "select_an_account": "Vælg en konto",
    "select_eliza_bypass_tag": "Vælg Eliza Bypass-nøgleord",
    "select_phone_number": "Vælg telefonnummer",
    "select_send_to_eliza_tag": "Vælg 'Send til Eliza'-nøgleord",
    "select_snapshot": " Vælg øjebliksbillede",
    "select_upto": "Vælg op til ",
    "selected": "Valgt: ",
    "send": "Send",
    "send_to_eliza_tag_optional": "Send til Eliza-tag (valgfrit) ",
    "seo": " SEO ",
    "settings": "Indstillinger",
    "setup_pending": "Opsætning venter",
    "share": "Del",
    "shared_snapshots": "Delte øjebliksbilleder",
    "shared_type": "Delt type",
    "shipping_and_delivery": "Forsendelse og levering",
    "shipping_origin": "Forsendelsens oprindelse",
    "show": "Vis",
    "showed": "Fremmødt",
    "signin_with_single_signon": "Log ind med enkeltlogon",
    "size": "Størrelse",
    "sms_message_sent_to_customer": "SMS-besked sendt til kunden",
    "snapshot_date": "Dato for øjebliksbillede",
    "snapshot_name": "Navn på øjebliksbillede",
    "social_planner": "Social planlægger",
    "sortBy": "Sortér efter",
    "sortOptions": {
      "createdDate": "Oprettelsesdato"
    },
    "source": "Kilde",
    "sources": "Kilder:",
    "spent": "Brugt",
    "staging_url_settings_for_db_event": "Indstillinger for staging-URL (for Db-hændelse)",
    "state": "Stat",
    "state_prov_region_": "Stat/provins/region",
    "states": {
      "alabama": "Alabama",
      "alaska": "Alaska",
      "arizona": "Arizona",
      "arkansas": "Arkansas",
      "california": "Californien",
      "colorado": "Colorado",
      "connecticut": "Connecticut",
      "delaware": "Delaware",
      "district_of_columbia": "District af Columbia",
      "florida": "Florida",
      "georgia": "Georgia",
      "hawaii": "Hawaii",
      "idaho": "Idaho",
      "illinois": "Illinois",
      "indiana": "Indiana",
      "iowa": "Iowa",
      "kansas": "Kansas",
      "kentucky": "Kentucky",
      "louisiana": "Louisiana",
      "maine": "Maine",
      "maryland": "Maryland",
      "massachusetts": "Massachusetts",
      "michigan": "Michigan",
      "minnesota": "Minnesota",
      "mississippi": "Mississippi",
      "missouri": "Missouri",
      "montana": "Montana",
      "nebraska": "Nebraska",
      "nevada": "Nevada",
      "new_hampshire": "New Hampshire",
      "new_jersey": "New Jersey",
      "new_mexico": "New Mexico",
      "new_york": "Aarhus",
      "north_carolina": "North Carolina",
      "north_dakota": "North Dakota",
      "ohio": "Ohio",
      "oklahoma": "Oklahoma",
      "oregon": "Oregon",
      "pennsylvania": "Pennsylvania",
      "rhode_island": "Rhode Island",
      "south_carolina": "South Carolina",
      "south_dakota": "South Dakota",
      "tennessee": "Tennessee",
      "texas": "Texas",
      "utah": "Utah",
      "vermont": "Vermont",
      "virginia": "Virginia",
      "washington": "Washington",
      "west_virginia": "West Virginia",
      "wisconsin": "Wisconsin",
      "wyoming": "Wyoming",
      "noRecordsFound": "Ingen poster fundet",
      "noEntriesToShow": "Ingen poster at vise",
      "unsuccessful": "Mislykket",
      "pending": "Afventer",
      "noUsersFound": "Der blev ikke fundet nogen brugere"
    },
    "status": "Status",
    "stop_delete_operation": "Stop sletning",
    "street_address": "Gade og nummer",
    "street_address_as_it_appears_in_the_ein_listing": "Gadeadresse, som den fremgår af EIN-listen.",
    "stripe_icon": "Stripe-ikon",
    "stripe_integration": "Stripe-integration",
    "stripe_secret_key": "Stripe Secret-nøgle",
    "subscriptions": "Abonnementer",
    "sun": "Søn",
    "surveys": "Undersøgelser",
    "suspend_subaccount_when_their_saas_subscription_fa": "Suspender underkontoen, når deres SaaS-abonnement fejler.",
    "switchAccount": "Skift konto",
    "switch_off_sections_below_to_disable": "Deaktiver sektionerne nedenfor for at slå dem fra",
    "tags": "Nøgleord",
    "tax_settings": "Momsindstillinger",
    "team_management": "Teamledelse",
    "team_notifications": "Teammeddelelser",
    "template": "Skabelon",
    "terms_and_conditions": "Vilkår og betingelser",
    "test_mobile_no": "Test mobilnummer",
    "text_messages": "SMS-beskeder",
    "the_proposed_size_is_350px_180px": "Den foreslåede størrelse er 350px * 180px.",
    "the_proposed_size_is_512512px": "Den foreslåede størrelse er 512*512 px",
    "the_selected_language_will_be_used_by_the_system_a": "Det valgte sprog vil som standard blive brugt af systemet.",
    "the_welcome_message_automatically_appears_after_a_": "Velkomstbeskeden vises automatisk, efter at en bruger har startet en ny samtale.",
    "these_are_margins_that_are_billed_to_your_clients_": "Det er marginer, der faktureres til dine kunder i forhold til de ",
    "this_data_will_be_used_for_future_compliance_regis": "Disse data vil blive anvendt til fremtidig overholdelsesregistrering.",
    "this_is_my_twilio_use_same": "Dette er min Twilio, brug den samme",
    "this_is_visible_to_both_agency_and_location": "Dette er synligt både for myndigheden og stedet",
    "this_name_will_be_visible_to_leads_chatting_with_y": "Dette navn vil være synligt for leads, der chatter med din virksomhed",
    "this_setting_is_applicable_with_only_team_calendar": "Denne indstilling er kun anvendelig med teamkalendere.",
    "this_stripe_customer_is_already_connected_to_anoth": "Denne Stripe-kunde er allerede tilsluttet en anden underkonto.",
    "thu": "Tor",
    "tiktok": "Tiktok",
    "time_signed": " Tidspunkt for underskrift: ",
    "time_zone_": "Tidszone *",
    "timestamp": "Tidsstempel",
    "title": "Titel",
    "to_resolve_this_problem_follow_the": "For at løse dette problem skal du følge ",
    "token": "Token:",
    "total": "Total: ",
    "trigger_link": "Udløserlink",
    "triggers": "Udløsere",
    "tue": "Tir",
    "twilio": "Twilio",
    "twilio_setup_pending": "Twilio-opsætning afventer",
    "type": "Type",
    "type_campaign_objective": "Indtast kampagnemål",
    "type_message": "Skriv en besked",
    "unsavedChangesWarning": "Dine ændringer vil ikke blive gemt. Er du sikker på, at du vil forlade siden?",
    "unsaved_changes": "Ikke-gemte ændringer",
    "unsubscribed": "Afmeldt",
    "unsuccessful": "Mislykket",
    "update_business_profile_details": "Opdater oplysningerne om virksomhedsprofilen",
    "update_is_inprogress_visit_integrations_page_to_fi": "Opdatering er i gang, besøg integrationssiden for at finde mere.",
    "update_url": "Opdater URL",
    "updated_date": "Opdateret dato",
    "updates": " opdateringer",
    "updating": "Opdaterer ...",
    "upgrade_to_agency_pro": "opgrader til Agency Pro ",
    "upload": "Upload",
    "upload_a_file": "Upload en fil,",
    "usd": " USD",
    "use_this_for_zapier_and_api_integration": "Brug dette til Zapier og API-integration.",
    "user_email": "Din e-mailadresse",
    "user_permissions": "Brugertilladelser",
    "user_role": "Brugerrolle",
    "user_type": "Brugertype",
    "valid": "Gyldig",
    "verification_status": "Bekræftelsesstatus",
    "verify": "Bekræft",
    "verify_email_using_otp": "Bekræft e-mail med OTP",
    "view_less": " Se mindre ",
    "visiblehidden": "Synlig/skjult",
    "visit_our_help_center_click_to_open_in_new_tab": "Besøg vores hjælpecenter - klik for at åbne i en ny fane",
    "voicemail": "Talebesked",
    "wave_integration": "Wave-integration",
    "we_have_found_some_errors_in_your_contact_fields_c": "Vi har fundet nogle fejl i dine kontaktfelter. Klik på mappen for at se og løse dem.",
    "websites": "Websites",
    "wed": "Ons",
    "welcome_message": "Velkomstbesked",
    "whatsapp": " WhatsApp",
    "whatsapp_icon": "WhatsApp-ikon",
    "when": "Når",
    "when_selected_calls_will_be_routed_to_your_mobile_": "Når det er valgt, vil opkald blive dirigeret til din mobilapp. (Understøttet i både iOS og Android)",
    "when_selected_calls_will_be_routed_to_your_web_app": "Når det er valgt, vil opkald blive dirigeret til din webapp.",
    "which_business_do_you_want_to_link_to_this_locatio": "Hvilken virksomhed ønsker du at linke til denne placering?",
    "widget_code": "Widget-kode",
    "will_give_you_about": " vil give dig omkring",
    "wordpress": "WordPress",
    "wordpress_icon": "WordPress-ikon",
    "workflows": "Arbejdsgange",
    "xero_integration": "Xero-integration",
    "you_need_to_complete_few_easy_steps_to_delete_this": "Du skal udføre et par enkle trin for at slette denne placering",
    "you_are_not_authorized_to_perform_this_action_only": "Du er ikke autoriseret til at udføre denne handling. Kun bureauadministratorer kan slette underkonti.",
    "your_email_cost": "Dine e-mailomkostninger",
    "your_facebook_page_has_been_integrated_however_the": "Din Facebook-side er blevet integreret. Dog vil de følgende funktioner ikke fungere, da LeadConnector ikke har de nødvendige tilladelser: ",
    "your_outlook_connection_has_expired_please_disconn": "Din Outlook-forbindelse er udløbet. Afbryd og genopret derefter forbindelsen til kontoen for at oprette forbindelsen.",
    "zip_code": "Postnummer",
    "zoom_connected_please_close_this_modal": "Zoom tilsluttet, luk dette modalvindue",
    "hidden": "Skjult",
    "messageDetails": "Beskedoplysninger",
    "openOptions": "Åbn indstillinger",
    "progress": "Fremskridt",
    "close": "Luk",
    "loading": "Indlæser",
    "fullName": "Fulde navn",
    "languages": "Sprog",
    "phoneNumber": "Telefonnummer",
    "phoneNumberWithCountry": "Telefonnummer med landekode",
    "sendMessage": "Send besked",
    "services": "Serviceydelser",
    "servicesProvided": "Leverede serviceydelser",
    "pleaseProvideAValid": "Angiv et gyldigt telefonnummer.",
    "copy": "Kopiér",
    "editApiKey": "Rediger API-nøgle",
    "confirmPay": "Bekræft og betal",
    "contactUs": "Kontakte os",
    "decline": "Afvis",
    "deleteSubaccount": "Slet underkonto",
    "disabled1": "deaktiveret",
    "purchaseSummary": "Købsoversigt",
    "subscriptionPlan": "Abonnementsplan",
    "businessName": "Virksomhedsnavn",
    "chooseOne": "Vælg en ...",
    "stateProvRegion": "Stat/provins/region",
    "streetAddress": "Gade/vej/nummer",
    "timeZone": "Tidszone",
    "website": "Hjemmeside",
    "zipPostalCode": "Postnummer",
    "apiKey": "API-nøgle",
    "createdAt": "Oprettet kl.",
    "deleteAllLocationApi": "Slet alle API-nøgler til placering",
    "deleteApiKey": "Slet API-nøgle",
    "generatedBy": "Genereret af",
    "lastUsedAt": "Sidste brugt den",
    "pageNavigation": "Sidenavigation",
    "somethingWentWrong": "Der opstod en fejl.",
    "clickHere": "Klik her",
    "emailRebillingActive": "Genfakturering via e-mail er aktiv",
    "saasSubscriptionActive": "SaaS-abonnementet er aktivt",
    "scheduledForDeletion": "Planlagt til sletning",
    "twilioRebillingActive": "Twilio-genfakturering er aktiv",
    "iAcknowledgeThisIs": "Jeg bekræfter, at dette er en gyldig underkonto, og jeg har verificeret brugsscenariet for at sende mere end {limit} {type}/dag",
    "iAcknowledgeThisIs1": "Jeg bekræfter, at dette er en gyldig underkonto, og jeg har verificeret brugsformålet for afsendelse, hvorved jeg har justeret den daglige SMS-grænse.",
    "emailSentByLocation": "E-mail sendt via adresse indtil videre i dag.",
    "goToSmsLimit": "Gå til indstillingerne for SMS-begrænsninger",
    "toIncreaseTheLimit": "Kontakt supportteamet for at øge grænsen yderligere.",
    "newLimitOfLimit": "Den nye grænse på {limit} er ugyldig. Angiv en værdi mellem {min} og {max}",
    "typeLimitUpdatedSuccessfully": "{type} grænse opdateret",
    "locationsCurrentLimitIs": "Placeringens nuværende grænse er {current}. Du kan kun opdatere grænsen mellem {min} og {max} herfra. For enhver opdatering af grænser ud over {maxAllowed} bedes du kontakte supportteamet.",
    "notNow": "Ikke nu",
    "smsSentByLocation": "SMS sendt via adresse indtil videre i dag.",
    "youHaveSuccessfullyUpdated": "Du har opdateret grænsen",
    "willAutoUnlockIn": "Låser automatisk op om",
    "contactType": "Kontakttype",
    "createdBy": "Oprettet af:",
    "createdOn": "Oprettet den:",
    "dateOfBirth": "Fødselsdato",
    "emailAddress": "E-mailadresse",
    "firstName": "Fornavn",
    "lastName": "Efternavn",
    "twilioLookupMarkedThis": "Twilio Lookup markerede dette telefonnummer som ugyldigt.",
    "twilioLookupStatedThis": "Twilio Lookup oplyste, at dette er et {type}-nummer, så det ikke vil modtage SMS'er.",
    "accountSnapshot": "Øjebliksbillede af konto",
    "auditLogs": "Audit-logfiler",
    "account": "Konto",
    "selectAccount": "Vælg konto",
    "facebookUrl": "Facebook-URL",
    "instagram": "Instagram",
    "linkedin": "LinkedIn",
    "twitter": "Twitter",
    "twitterUrl": "Twitter-URL",
    "youtubeUrl": "YouTube-URL",
    "text": "Tekst",
    "allTagsLinkedTo": "Alle tags, der er tilknyttet de valgte kontakter, skal slettes",
    "automation": "Automatisering",
    "bulkOperation": "Massehandling",
    "campaign1": "Kampagne",
    "created": "Oprettet",
    "dateTime": "Dato og tid",
    "description1": "Beskrivelse",
    "drip": "Drypvist",
    "edit": "Rediger",
    "someStatsAreNot": "Nogle statistikker er ikke tilgængelige, hvis udbyderen er SMTP. Nøjagtigheden af metrikker afhænger af modtagerens domæne.",
    "error": "Fejl",
    "from1": "Fra",
    "immediately": "Straks",
    "pause": "Pause",
    "processed": "Behandlet",
    "queued": "I kø",
    "restored": "Gendannet",
    "resume": "Genoptag",
    "sent": "Sendt",
    "scheduled": "Planlagt",
    "success": "Gennemført",
    "templateName": "Skabelonnavn",
    "total1": "I alt",
    "totalAttempted": "Forsøg i alt",
    "user": "Bruger",
    "viewDetails": "Vis oplysninger",
    "workflow": "Arbejdsgang",
    "company": "Virksomhed",
    "note": "Note",
    "perPage": "per side",
    "showing": "Viser",
    "task": "Opgave",
    "tasks": "Opgaver",
    "customFields": "Tilpassede felter",
    "dueDate": "Forfaldsdato",
    "tryNow": "Prøv nu!",
    "archive": "Arkiv",
    "markAsRead": "Markér som læst",
    "markAsUnread": "Markér som ulæst",
    "youNeedToAdd": "Du skal tilføje en kalender for at begynde at planlægge aftaler.",
    "additionalNotes": "Yderligere bemærkninger",
    "appointmentStatus": "Aftalestatus",
    "appointmentTitle": "Aftalens titel",
    "contactName": "Navn på kontaktperson",
    "contactTimezoneUsedFor": "Kontakttidszone (bruges til påmindelse)",
    "day": "Dag",
    "editAppointment": "Rediger aftale",
    "nameRequired": "Navn er påkrævet",
    "slotRequired": "Tidsrum er påkrævet",
    "teamMemberIsRequired": "Teammedlem er påkrævet.",
    "meetingLocation": "Mødested",
    "pickTeamMember": "Vælg teammedlem",
    "phoneNumbers": "Telefonnumre",
    "roundRobin": "Automatisk tildeling af aftaler",
    "selectCalendar": "Vælg kalender",
    "selectTeamMember": "Vælg teammedlem",
    "actionRequired": "Handling påkrævet",
    "scheduleAppointment": "Planlæg aftale",
    "considerLeavingItBlank": "Overvej at lade det stå tomt, hvis du vælger at bruge den forudkonfigurerede aftaletitel",
    "assignedTo": "Tildelt til",
    "download": "Download",
    "loadingTranscription": "Indlæser transskription ...",
    "mute": "Slå lyden fra",
    "playpause": "Afspil/pause",
    "playbackSpeed": "Afspilningshastighed",
    "remove": "Ryd",
    "stop": "Stop",
    "timePlayedTotalTime": "Spilletid : Samlet tid",
    "viewTranscript": "Vis transskription",
    "below": "under",
    "calls1": "Opkald",
    "liveChat": "Livechat",
    "whatsapp1": "WhatsApp",
    "chatConversationAssigned": "Chatsamtale tildelt",
    "youAreChoosingNot": "Du vælger ikke at slette og lukke LC Phone-underkontoen, hvilket betyder, at du stadig vil blive opkrævet for al brug, uanset om adressen faktureres eller ej.",
    "thingsAreJustGetting": "Det er lige begyndt. Lad os udforske, hvordan GHL kan hjælpe med at opbygge din virksomhed.<br />I mellemtiden kan du fortsætte med at sende beskeder, så meget du vil",
    "wohooConversationsAreFlowing": "Wow! Samtalerne flyder nu",
    "conversationBegan": "Samtalen begyndte",
    "fetchOlderMessages": "Hent gamle beskeder",
    "inboundDndHasBeen": "Indgående DND er aktiveret for denne kontakt",
    "internalComment": "Intern kommentar",
    "confirmByTyping": "Bekræft ved at skrive",
    "iConfirmToDisconnect": "Jeg bekræfter, at LC Phone-kontoen skal afbrydes og lukkes for denne adresse. Jeg er klar over, at dette vil betyde, at alle numre og A2P-kampagner vil blive slettet og ikke kan genoprettes.",
    "iConfirmThatI": "Jeg bekræfter, at jeg har drøftet dette med min kunde, og at kunden har autoriseret mig til at foretage denne handling.",
    "connect": "Forbind",
    "disputeThisReview": "Bestrid denne anmeldelse",
    "dndIsActiveFor": "DND er aktiv for opkald",
    "off": "FRA",
    "done": "Færdig",
    "downloadFile": "Download fil",
    "AddAccount": "+ Tilføj konto",
    "attachFile": "Vedhæft fil",
    "clickHereToAdd": "Klik her for at tilføje én.",
    "customerName": "Kundenavn",
    "customerPhone": "Kundens telefon",
    "orEnterAMessage": "Eller indtast en besked",
    "fromEmail": "Fra e-mail",
    "fromName": "Fra navn",
    "youDontHaveAny": "Du har ikke nogen skabeloner endnu.",
    "requestPayment": "Betalingsanmodning",
    "schedule": "Planlæg",
    "selectATemplate": "Klik en skabelon",
    "sendNow": "Send nu",
    "smtpProvidersHasSome": "SMTP-udbyderne har nogle begrænsninger. Klik her for at få mere at vide.",
    "subject": "Emne",
    "useATemplateSnippet": "Brug en skabelon (uddrag)",
    "deliveredtotalDelivered": "{delivered}/{total} sendt",
    "countMoreEmailsIn": "{count} flere e-mails in tråden",
    "primary": "(Primær)",
    "reply": "Svar",
    "respond": "Besvar",
    "retry": "Prøv igen",
    "to": "Til:",
    "fbCommentReplyDm": "FB kommentar, svar - DM",
    "fbMessage": "FB-besked",
    "theseAttachmentsMayNot": "Disse vedhæftede filer understøttes muligvis ikke længere.",
    "urlCannotBeFound": "URL kan ikke findes",
    "activity": "Aktivitet",
    "filters": "Filtre",
    "goToPost": "Gå til opslaget",
    "inboundCall": "Indgående opkald",
    "instagramDm": "Instagram DM",
    "internalChat": "Intern chat",
    "search2": "Søg ...",
    "starred": "Stjernemarkeret",
    "leftAVoicemail": "Efterlod en talebesked",
    "manual": "Manuel",
    "mergeFields": "Flet felter",
    "addToDocuments": "Tilføj til dokumenter",
    "failedToAddAttachments": "Kunne ikke tilføje vedhæftede filer til dokumenterne",
    "attachmentsAddedToDocuments": "Vedhæftede filer blev tilføjet til dokumenterne",
    "newCommentOnPagename": "Ny kommentar til indlægget {pageName}.",
    "outboundCall": "Udgående opkald",
    "replyAsDm": "Svar som DM",
    "replyingAsAPrivate": "Det er ikke muligt at svare som privat DM for kommentarer, der er ældre end 7 dage.",
    "reportFeedbackForAi": "Giv feedback for AI",
    "storyMention": "Story-omtale",
    "storyReply": "Svar på story",
    "bulkRequest": "Masseanmodning",
    "eventsAreCurrentlyCaptured": "Hændelser registreres i øjeblikket kun for kontaktens e-mailadresse.",
    "failed": "Mislykkedes",
    "gbpMessage": "GBP-besked",
    "pageName": "Sidenavn",
    "unknown": "Ukendt",
    "typeAMessage": "Skriv en besked",
    "new": "Ny",
    "newAppointmentBookedBy": "Ny aftale booket af",
    "customerNameRequired": "Kundens navn er påkrævet",
    "messageIsRequired": "Besked er påkrævet",
    "pickATemplateTo": "Vælg en skabelon at bruge.",
    "newMessage": "Ny besked",
    "newTask": "Ny opgave",
    "toMakeACall": "For at foretage et opkald skal du indtaste et telefonnummer i dette felt.",
    "primary1": "Primær",
    "provider": "Udbyder",
    "refresh": "Opdater",
    "resetPassword": "Nulstil adgangskode",
    "thisReviewHasAlready": "Denne anmeldelse er allerede blevet offentliggjort på {network}. Er du sikker på, at du vil genposte det?",
    "seeThisReviewOn": "Se denne anmeldelse på GBP",
    "reviewResponse": "Svar på anmeldelse",
    "searchUsers": "Søg efter brugere",
    "sendEmail": "Send e-mail",
    "sending": "Sender ...",
    "thisSubaccountHasPhonenumberco": "Denne underkonto har {phoneNumberCount} numre og {campaignsCount} A2P-kampagne(r). Sletning af denne konto vil stadig medføre gebyrer, hvis LC Phone System-kontoen ikke afbrydes og lukkes.",
    "thisSubaccountDoesNot": "Denne underkonto har ikke nogen numre eller nogen A2P-kampagner. Det vil ikke medføre nogen omkostninger at sætte denne konto på pause, men vi foreslår, at du afbryder og lukker LC Phone-kontoen.",
    "summary": "Oversigt",
    "unassigned": "Ikke tildelt",
    "viewSubmission": "Se indsendelse",
    "contactSupport": "Kontakt support",
    "create": "Opret",
    "illDoThisLater": "Jeg gør det senere",
    "enterBusinessName": "Indtast virksomhedens navn",
    "firstNameOfThe": "Virksomhedsejerens fornavn",
    "mobileBusinessPhone": "Mobil-/arbejdstelefon",
    "iDontHaveA": "Jeg har ikke et website",
    "clientName": "Kundenavn",
    "letUsSetupYour": "Lad os oprette din egen konto eller din første klient",
    "clientNameIsRequired": "Klientnavn er påkrævet",
    "pleaseEnterAValid": "Indtast en gyldig e-mailadresse",
    "emailAddressIsRequired": "E-mailadresse er påkrævet",
    "firstNameIsRequired": "Fornavn er påkrævet",
    "lastNameIsRequired": "Efternavn er påkrævet",
    "phoneNumberIsRequired": "Telefonnummer er påkrævet",
    "copyOfName": "Kopi af {name}",
    "goToDashboard": "Gå til kontrolpanel",
    "permissionsNotEnabled": "Tilladelser er ikke aktiveret!",
    "createAndSellCustom": "Generér og sælg tilpassede produkter med print-on-demand dropshipping",
    "viewApp": "Vis appen",
    "seamlessFulfillmentRealtimeShi": "Problemfri levering og leveringspriser i realtid til dine e-handelsbutikker",
    "learnMore": "Få mere at vide",
    "activateFormMapping": "Aktivér kortlægning af formular",
    "avatarName": "Avatarnavn",
    "formFields": "Formularfelter",
    "formName": "Formular navn",
    "mapFields": "Kortlæg felter",
    "update": "Opdater",
    "pauseSubaccount": "Sæt underkonto på pause",
    "pausing": "Sætter på pause ...",
    "subaccount": "underkonto",
    "howItWorks": "Sådan fungerer det",
    "uponCompletingThisAction": "Når denne handling er blevet gennemført, sendes overførselsforespørgslen til det modtagende agentur ({relNo}). Underkontoen overføres, så snart agenturet har accepteret den. Bemærk, at denne handling er irreversibel.",
    "ejectSubaccount": "Fjern underkonto",
    "newAgencyCreationMail": "En e-mail om oprettelse af nyt agentur er blevet sendt til den valgte bruger. Brugeren kan oprette et nyt agentur ved at klikke på linket i e-mailen.",
    "unableToTransferSubaccount": "Kan ikke overføre underkontoen til dette bureau.",
    "nominateAccountOwnerFor": "Nominer en kontoejer for den nye konto",
    "pleaseConfirmOwnershipWill": "Bekræft, at ejerskabet vil blive overført til",
    "scheduledDate": "Planlagt dato",
    "thisDateIsBased": "Denne dato er baseret på denne virksomheds tidszone, som er {timezone}",
    "campaignName": "Kampagnenavn",
    "copyCampaign": "Kopiér kampagne",
    "endTime": "Sluttid",
    "event10xEmail4": "Begivenhed: 10X Email 4 (fordeling af annoncer) ",
    "10xEmail1Reviews": "10X e-mail 1 (anmeldelser)",
    "fromAddress": "Fra-adresse",
    "leadValue": "Kundeemnets værdi",
    "option1": "Valgmulighed 1",
    "option2": "Valgmulighed 2",
    "option3": "Valgmulighed 3",
    "preview": "Forhåndsvisning",
    "selectCampaign": "Vælg kampagne",
    "startTime": "Starttid",
    "time": "Tidspunkt",
    "users": "Brugere",
    "noRecordsFound": "Ingen poster fundet",
    "pageDetail": "Sidedetaljer",
    "selectAll": "Vælg alle",
    "submission": "Indsendelse",
    "addProduct": "Tilføj produkt",
    "visitors": "besøgende",
    "By": " af",
    "conversions": "Konverteringsrate ",
    "liveReviews": "Liveanmeldelser",
    "liveVisitors": "Livebesøgende",
    "pageVisits": "Sidebesøg",
    "stream": "Stream",
    "addOneOrMore": "Indtast en eller flere side-URL'er, eller kopiér dem direkte fra din webbrowser.",
    "WeWillAutomatically": " Vi sporer automatisk dine besøgende på hjemmesiden i realtid. ",
    "connectYourLocationsFacebook": "Forbind din placerings Facebook-konto",
    "connected": "Forbundet!",
    "Contains": " indeholder ",
    "expression": "Udtryk",
    "facebookAccount": "Facebook-konto",
    "wowYouDontNeed": "Wow! Du behøver ikke at konfigurere noget her, du kan gå videre.",
    "Regex": " regex ",
    "selectUrlMatchType": "Vælg URL-matchtype",
    "Simple": " enkel ",
    "LivePreview": " Liveforhåndsvisning",
    "seconds": "sekunder",
    "launch": "Lancer ",
    "decorativeVector1": "Dekorativ vektor 1",
    "showingFromToTo": "Viser {from} til {to} af {total} poster",
    "cloneProduct": "Klon produkt",
    "connectFacebookInstagram": "Forbind Facebook og Instagram",
    "connectPage": "Forbind side!",
    "everythingIn": "Alt i",
    "agentChat25": "Chat med agent (~ 2-5 min. ventetid)",
    "aiSupportChat": "AI-supportchat",
    "startChat": "Start chat",
    "locations1": "placeringer",
    "phone1": "telefon",
    "slack": "Slack",
    "segments1": "segmenter",
    "areYouSureYou": "Er du sikker på, at du vil slette denne mappe?",
    "verified": "Verificeret",
    "highlevelPrice": "HighLevel-pris",
    "howDoesItWork": "Hvordan fungerer det?",
    "payNow": "Betal nu",
    "priceMustBeMore": "Prisen skal være højere end eller lig med HighLevel-prisen",
    "saving2": "Gemmer",
    "yourPrice": "Din pris",
    "yourProfit": "Dit overskud",
    "youNeedToComplete": "Du skal gennemføre et par enkle overholdelsestrin for at deaktivere SaaS-tilstanden for denne placering",
    "youAreNotAuthorized": "Du er ikke autoriseret til at udføre denne handling. Kun agenturadministratorer kan udføre den.",
    "disableSaasModeFor": "Deaktiver SaaS-tilstand for {name}",
    "companyBilling": "Virksomhedsfakturering",
    "bccEmailsCommaDelimited": "BCC (kommasepareret)",
    "unableToDeleteMailgun": "Kan ikke slette Mailgun-kontoen. Kontakt support.",
    "forwardingAddress": "Videresendelsesadresse",
    "forwardingAddressesCommaDelimi": "Videresendelsesadresser (kommasepareret)",
    "amount": "Beløb",
    "billingDate": "Fakturadato",
    "debugWalletTransactionsTotal": "DEBUG tegnebogstransaktioner, i alt: {count}",
    "detailedTransactions": "Detaljerede transaktioner",
    "transactionsOnlyAfter26th": "Transaktioner, der kun er foretaget efter den 26. april 2022, er angivet og tilgængelige til eksport.",
    "someRecordsMayTake": "Nogle poster kan tage 24 timer at blive opdateret her.",
    "totalBalance": "Saldo i alt",
    "walletTransactions": "Tegnebogstransaktioner",
    "walletTransactionsAllDate": "Tegnebogstransaktioner – Alle – {date}",
    "enterMessage": "Indtast en besked",
    "applyThisChangeTo": "Anvend denne ændring på alle underkonti.",
    "characters": "Tegn",
    "iConfirmThatI1": "Jeg bekræfter, at jeg har drøftet dette med min kunde, og jeg har deres godkendelse.",
    "iConfirmThatI2": "Jeg bekræfter, at jeg vil sikre, at alle SMS-beskeder, der sendes fra denne konto, er i overensstemmelse med den gældende politik.",
    "theContentsOfThis": "Indholdet af denne besked vil automatisk blive tilføjet til den første SMS, der sendes via massebeskeder.",
    "iConfirmThatSms": "Jeg bekræfter, at der kun sendes SMS-beskeder til de kontakter, der har givet samtykke til at modtage SMS.",
    "quickTip": "Hurtigt tip",
    "messageWillBeAppended": "Beskeden vil blive tilføjet i den første sms af en konvertering, hvis den ikke indeholder fravalgssprog",
    "readMore": "Læs mere",
    "noncompliantActivityMayLead": "Ikke-overensstemmende aktivitet kan føre til suspension af din kontos SMS- og stemme-relaterede funktioner.",
    "typeConfirmBelowTo": "Skriv Bekræft for at fortsætte",
    "products": "Produkter",
    "chooseCountry": "Vælg land ...",
    "email2": "E-mail*",
    "firstName1": "Fornavn*",
    "lastName1": "Efternavn*",
    "brandDetails": "Branddetaljer",
    "brandName": "Brandnavn*",
    "useEitherLegalName": "Brug enten det juridiske navn på den organisation, der sender beskederne, eller dit eget navn, hvis dette brand ikke er for en organisation.",
    "businessIndustry": "Virksomhedens branche*",
    "chooseVertical": "Vælg branche ...",
    "mobileNumberForOtp": "Mobilnummer til OTP-verifikation (med landekode)*",
    "pleaseProvideAMobile": "Angiv et mobilnummer, du har adgang til, så du kan bekræfte OTP-verifikation. Kun amerikanske/canadiske telefonnumre vil blive accepteret. Du må ikke bruge et CPaaS-telefonnummer, f.eks. et, du har fået fra LeadConnector. Du kan ikke bruge det samme mobilnummer til at registrere mere end 3 enkeltmandsvirksomhedsmærker. Denne grænse administreres via TCR.",
    "increasedDeliveryRate": "Øget leveringsrate",
    "sendUpto3000Segments": "Send op til 3000 segmenter om dagen",
    "businessDetails": "Virksomhedsoplysninger",
    "thereWasSomeIssue": "Der opstod et problem under indsendelse af profilen.",
    "yourProfileSubmissionFailed": "Din profilindsendelse mislykkedes.",
    "endUserConsent": "Slutbrugersamtykke",
    "minLength40Characters": "Min. længde: 40 tegn. Maks. længde: 2048 tegn.",
    "closeExamples": "Luk eksempler",
    "sampleMessage1": "Eksempelbesked #1*",
    "seeExamples": "Se eksempler",
    "enterCampaignDetails": "Indtast kampagneoplysninger",
    "youWillReceiveAn": "Du vil modtage en besked med en engangskode fra TCR på dit angivne mobilnummer, som du skal bekræfte. Svar Yes inden for 24 timer efter modtagelse af SMS'en.",
    "brandNameIsRequired": "Brandnavn er påkrævet.",
    "businessVerticalIsRequired": "Forretningsområde er påkrævet.",
    "mobileNumberIsRequired": "Mobilnummer er påkrævet.",
    "hideDetail": "Skjul detalje",
    "showDetail": "Vis detalje",
    "people": "mennesker",
    "person": "person",
    "after": "efter",
    "before": "før",
    "hour": "time",
    "hours": "timer",
    "minute": "minut",
    "minutes": "minutter",
    "triggerLinksEmbeddedIn": "Aktiveringslinks (indlejret i beskeden) klikket som % af sendte beskeder",
    "addNewEvent": "Tilføj ny begivenhed",
    "addTask": "Tilføj opgave",
    "manualCall": "Manuelt opkald",
    "manualSms": "Manuel SMS",
    "messenger": "Messenger",
    "wait": "Vent",
    "webhook": "Webhook",
    "about": "Om",
    "accessRestricted": "Adgang begrænset",
    "addPartner": "Tilføj partner",
    "addPartnerForm": "Tilføj partnerformular",
    "affiliatePortal": "Tilknyttet portal",
    "badges": "Badges",
    "aBriefBio": "En kort biografi",
    "dashboard": "Kontrolpanel",
    "experience": "Oplevelse",
    "industryServed": "Tilbudte brancher",
    "instagramAccount": "Instagram-konto",
    "invoiceHistory": "Fakturahistorik",
    "englishGermanHindi": "English, German, Hindi",
    "linkToWebsite": "link til website",
    "linkedinAccount": "LinkedIn-konto",
    "locationId": "Lokations-id",
    "partnerName": "Partnernavn",
    "partnerStatus": "Partnerstatus",
    "paymentDetails": "Betalingsoplysninger",
    "paymentHistory": "Betalingshistorik",
    "profilePhoto": "Profilfoto",
    "profilePhotoUrl": "url til profilfoto",
    "promoterReports": "Promoterrapporter",
    "searchPartner": "Søg partner",
    "twitterAccount": "Twitter-konto",
    "updatePartner": "Opdater partner",
    "updatePartnerForm": "Opdater partnerformular",
    "yearOfExperience": "års erfaring",
    "youtubeAccount": "YouTube-konto",
    "serviceProvided": "Leverede tjenester",
    "controlTheSubaccountSettings": "Administrer indstillingerne for underkontoen",
    "generalInfo": "Generelle oplysninger",
    "okay": "Okay",
    "proceed": "Fortsæt",
    "addCard": "Tilføj kort",
    "makeThisCardPrimary": "Gør dette kort til det primære",
    "nameOnCard": "Navn til kort",
    "chargedToCustomer": "Opkrævet fra kunden",
    "clientBillingPage": "Kunde-faktureringsside",
    "companyStripeIntegrationPage": "virksomhedens Stripes-integrationsside",
    "enableRebilling": "Aktivér genfakturering",
    "enabling": "Aktiverer ...",
    "forMoreDetails": "for at få flere oplysninger.",
    "youreOnTheFreelancer": "Du er på Freelancer-abonnementet, som begrænser dig til 1,05x avancen.",
    "minimumAmountShouldBe": "Minimumsbeløbet skal være mellem ${min} og ${max}",
    "beforeEnablingThisFeature1": "Før du aktiverer denne funktion, skal du forbinde din Stripe-konto på",
    "planToSetYour": "planlæg at hæve dine avancemargener.",
    "rebillAmount": "Genfaktureringsbeløb",
    "supportDoc": "supportdokument",
    "10WillGiveYou": "10 USD vil give dig ca.",
    "minimumMustBeBetween": "Minimum skal være mellem 0,0001 og 0,005",
    "sorryYouCannotRebillAtTheMarkup": "Beklager! Du kan ikke genfakturere med tillægget på Freelancer-abonnementet",
    "modifyingTheseSettingsWillChange": "Ændring af disse indstillinger vil ændre de omkostninger, som dine kunder pådrager sig fremover.",
    "pleaseDoNotModifyThese": "Undlad at ændre disse, hvis du ikke er sikker på deres indvirkninger.",
    "theseSettingsWillApply": "Disse indstillinger vil gælde for dine nye kunder fremover",
    "congratulationsYourDedicatedIp": "Tillykke! Din dedikerede IP-gensalgsværdi er blevet gemt.",
    "youHaveAgreedToProvide": "Du har accepteret at give dedikerede IP'er direkte til en underkonto. Agenturet vil dække omkostningerne på vegne af underkontoen.",
    "youHaveDiscontinuedToProvide": "Du har ophørt med at levere dedikerede IP'er direkte til en underkonto. Agenturet vil ikke længere dække omkostningerne på vegne af underkontoen.",
    "oopsSomethingWentWrongAndWeCouldnt": "Ups! Noget gik galt, og vi kunne ikke redde din dedikerede IP-videresalgskonfiguration. Prøv igen senere.",
    "pleaseAgreeToTheTerms": "Acceptér vilkårene",
    "errorWhileFetchingDomains": "Fejl under hentning af domæner",
    "sameStripeCustomerProfileCantBeMapped": "Samme Stripe-kundeprofil kan ikke tilknyttes mere end én underkonto.",
    "pleasePickADifferentStripeCustomer": "Vælg en anden Stripe-kundeprofil, eller brug funktionen \"Del et link\", så vi kan oprette en ny Stripe-kundeprofil til denne underkonto.",
    "clickNextToChooseAPlan": "Klik på 'Næste' for at vælge en plan og oprette et nyt abonnement.",
    "youDontHaveAnyActiveSubscriptions": "Du har ingen aktive abonnementer",
    "youCanEitherSelectAnExistingSubscription": "Du kan enten vælge et eksisterende abonnement eller oprette et nyt abonnement i næste trin.",
    "useCommasToSeparateMultipleEmails": "Brug kommaer til at adskille flere e-mails.",
    "useCommasToSeparateMultiplePhoneNumbers": "Brug kommaer til at adskille flere telefonnumre.",
    "noUserFoundInThisLocation": "Ingen bruger fundet på dette sted",
    "noPhoneNumberAttached": "Intet telefonnummer er vedhæftet",
    "pleaseUseTheFollowingLinkToAttachYourPaymentMethod": "Brug følgende link til at tilknytte din betalingsmetode.",
    "allowDuplicateContact": "Tillad duplikerede kontakter",
    "allowDuplicateOpportunity": "Tillad duplikerede muligheder",
    "mergeFacebookContactsByName": "Flet Facebook-kontakter efter navn",
    "onlyIncomingMessagesFromFacebookWillBeMerged": "Kun indgående beskeder fra Facebook vil blive flettet, hvis de matcher en eksisterende kontakts navn. Navne skelner mellem store og små bogstaver.",
    "disableContactTimezone": "Deaktiver kontaktens tidszone",
    "markEmailsAsInvalidDueToHardBounce": "Markér e-mails som ugyldige på grund af permanent afvisning.",
    "contactsEmailsWillBeMarkedAsInvalid": "Kontaktens e-mails vil automatisk blive markeret som ugyldige, når de bliver permanent afvist. E-mail-aktiviteter i Automatiseringer vil blive sprunget over for kontakter med ugyldige e-mails.",
    "gatherIntelligenceOnUnknownPhoneNumbers": "Indhent oplysninger om ukendte telefonnumre",
    "makeSmsCompliantByAddingAnOptOutMessage": "Gør SMS overensstemmende ved at tilføje en fravalgsbesked.",
    "ifActivatedTheOptOutMessageWillBeAutomaticallyAdded": "Hvis den er aktiveret, vil fravalgsmeddelelsen automatisk blive tilføjet til den første sms, der sendes via massebeskeder for at sikre overholdelse og øge leveringsraterne.",
    "platformLanguage": "Platformssprog",
    "outboundCommunicationLanguageForCustomValues": "Udgående kommunikationssprog for tilpassede værdier",
    "updateInformation": "Opdater oplysninger",
    "upgradeToTheAgency": "Opgrader til Agency Pro",
    "yourCost": "Dine omkostninger",
    "addACalendarTo": "Tilføj en kalender for at begynde at booke aftaler.",
    "addselectAContactTo": "Tilføj/vælg en kontakt for at planlægge aftaler",
    "appointmentSlotIsNot": "Tidsrum for aftale er endnu ikke valgt",
    "loading1": "Indlæser ...",
    "teamMemberIsRequired1": "Teammedlem er påkrævet",
    "currentPlan": "Nuværende plan",
    "features1": "Funktioner",
    "upgrade": "Opgrader",
    "viewLess": "Se mindre",
    "viewMoreCount": "Se mere (+{count})",
    "cardNumber": "Kortnummer",
    "expiryDate": "Udløbsdato",
    "paymentMethods": "Betalingsmetoder",
    "primaryCard": "Primært kort",
    "removeCurrentCard": "Fjern det aktuelle kort",
    "AddBalance": "+ Tilføj Saldo",
    "complimentaryCredits": "Gratis kreditter",
    "expiringOnDate": "Udløber den {date}.",
    "apiVersion": "API-version",
    "application": "Applikation",
    "ipAddress": "IP-adresse",
    "related": "Relateret",
    "request": "Forespørgsel",
    "yourAccountIncludingAll": "Din konto, inklusive al udgående aktivitet som planlagte beskeder og e-mails, vil blive stoppet med det samme.",
    "yourAccountIncludingAll1": "Din konto, inklusive al udgående aktivitet som planlagte beskeder og e-mails, vil blive stoppet med det samme.",
    "nextBillingDateDate": "Næste faktureringsdato: {date}",
    "scheduledForCancellation": "Planlagt til annullering",
    "abandoned": "Forladt",
    "add1": "Tilføj",
    "addOpportunity": "Tilføj mulighed --",
    "addOpportunityName": "Tilføj muligheds navn",
    "Task": "+ Opgave",
    "bookupdateAppointment": "Book/opdater aftale",
    "companyName": "Firmanavn",
    "areYouSureYou1": "Er du sikker på, at du vil slette denne mulighed?",
    "contactInfo": "Kontaktoplysninger",
    "editOpportunity": "Rediger mulighed --",
    "enterValue": "Indtast værdi",
    "goToContactDetail": "Gå til side med kontaktoplysninger",
    "leads": "Kundeemner",
    "lost": "Tabt",
    "nameIsRequired": "Navnet er påkrævet.",
    "youreNotAllowedTo": "Du har ikke tilladelse til at ændre kundens navn. Tjek dine tilladelser med agenturadministratoren.",
    "open": "Åbn",
    "opportunity": "Kundeemne",
    "opportunityAlreadyExistsIn": "Muligheden findes allerede i denne proces",
    "opportunityInfo": "Oplysninger om kundeemnet",
    "opportunityName": "Muligheds navn",
    "opportunitySource": "Mulighedskilde",
    "owner": "Ejer",
    "pipeline": "Proces",
    "removeOwner": "Fjern ejeren",
    "selectPipeline": "Vælg proces",
    "selectStage": "Vælg trin",
    "stage": "Trin",
    "countTasks": "{count} opgaver",
    "won": "Vundet",
    "and": "og ",
    "addASubscription": "Tilføj et abonnement",
    "noSaasPlanEnabled": "Ingen SaaS-abonnement aktiveret",
    "per": "pr.",
    "assignTo": "Tildel til",
    "assignedTo1": "Tildelt til:",
    "areYouSureYou2": "Er du sikker på, at du vil slette denne opgave?",
    "due": "Forfalder:",
    "dueDateIsRequired": "Forfaldsdato er påkrævet",
    "dueIn": "Forfalder om",
    "dueToday": "Forfalder i dag",
    "late": "Sent",
    "notAssigned": "Ikke tildelt",
    "taskDescription": "Opgavebeskrivelse",
    "taskTitle": "Opgavens titel",
    "annually": "årligt",
    "attachments": "Vedhæftede filer",
    "areYouSureYou3": "Er du sikker på, at du vil slette denne masseanmodning?",
    "startImmediately": "Start øjeblikkeligt",
    "customers": "Kunder",
    "tag": "Tag",
    "pickType": "Vælg type",
    "whoShouldItRun": "Hvem skal den køre for?",
    "addBulkRequest": "Tilføj masseanmodning",
    "editBulkRequest": "Rediger anmodning om større mængder",
    "scheduledDateIsRequired": "Planlagt dato er påkrævet",
    "newCampaignName": "Nyt kampagnenavn",
    "areYouSureYou4": "Er du sikker på, at du vil slette denne kampagne?",
    "moveToFolder": "Flyt til mappe",
    "pleaseRename": "omdøb",
    "removeFromFolder": "Fjern fra mappen",
    "photoPreview": "Forhåndsvisning af foto",
    "pleaseWait": "Vent ...",
    "customValues": "Brugerdefinerede værdier",
    "whatActionShouldWe": "Hvilken handling skal vi udføre?",
    "entitynameName": "Navnet på {entityName}",
    "useLcEmail": "Brug LC Email",
    "21Jun2018": "21. juni 2018",
    "930Am": "09.30",
    "Via": " via ",
    "createdTrackingNumbers": "Oprettede sporingsnumre",
    "iUnderstandImBuyingadding": "Jeg forstår, at jeg køber/tilføjer {count} nye telefonnumre.",
    "forwardCallsTo": "Viderestil opkald til",
    "numberName": "Nummernavn",
    "numberPoolName": "Navn på nummerpulje",
    "numberToSwap": "Nummer, der skal byttes",
    "sameAsForwardingNumber": "Samme som viderestillingsnummer",
    "callFromSource": "Opkald fra [Kilde].",
    "callRecording": "Optagelse af opkald",
    "84Complete": "84 % gennemført",
    "thisCallWillBe": "Dette opkald vil blive optaget af hensyn til kvalitetssikring.",
    "whisperMessage": "Kort, privat besked",
    "allExceptDirect": "Alle undtagen direkte",
    "allExceptDirectOrganic": "Alle undtagen direkte og organiske",
    "allSearch": "Al søgning",
    "allVisitorsRecommended": "Alle besøgende (anbefales)",
    "bing": "Bing",
    "direct": "Direkte",
    "visitorsWithoutAReferring": "Besøgende uden et henvisende website",
    "for": "for",
    "google": "Google",
    "landingPageOrUrl": "Landingsside eller URL-parameter",
    "organic": "Organisk",
    "paid": "Betalt",
    "pickOneYouCan": "Vælg én – du kan altid ændre dette senere.",
    "ppcSearch": "PPC-søgning",
    "visitorsFromGoogleBing": "Besøgende fra Google, Bing og Yahoo PPC-søgning",
    "referringPage": "Henvisningsside",
    "visitorsFrom": "Besøgende fra",
    "visitorsFromGoogleAds": "Besøgende fra Google Ads",
    "visitorsWhoAreReferred": "Besøgende, der henvises fra",
    "visitorsWhoLandOn": "Besøgende, der henvises fra",
    "whichVisitorsDoYou": "Hvilke besøgende vil du spore?",
    "yahoo": "Yahoo",
    "17Complete": "17 % gennemført",
    "callTimeoutS": "Opkaldstimeout",
    "callWhisper": "Call whisper",
    "disableVoicemailDetect": "Deaktiver registrering af talebesked",
    "eventName": "Begivenhedsnavn",
    "timeoutSeconds": "Timeout (sekunder)",
    "editCall": "Rediger opkald",
    "callWillPatchInstantly": "Opkaldet opdateres med det samme. Vi lytter ikke for at se, om telefonsvareren blev besvaret på kundeemne-siden. Det betyder, at kampagnen markeres som besvaret, selvom der er blevet indtalt en telefonsvarerbesked.",
    "thisIsTheMessage": "Dette er den besked, du ønsker, at den person, der tager telefonen, skal høre. Du kan bruge brugerdefinerede variabler til at tilpasse dette.",
    "pleaseCheckTheLinks": "Tjek de links, hvor du har en brugerdefineret værdi. Der er en ekstra '%20' mellem {{ og custom_values.",
    "anErrorOcurredPlease": "Der opstod en fejl. Prøv igen.",
    "pleaseInsertATo": "Indtast en til-adresse.",
    "pickEmailTemplate": "Vælg e-mailskabelon",
    "sendTest": "Send test",
    "composeEmail": "Skriv e-mail",
    "composeEmailTemplate": "Skriv e-mailskabelon",
    "toAddress": "Til adresse",
    "addFileThroughUrl": "Tilføj fil via URL",
    "appCharacters": "App-tegn:",
    "approximateCost": "Omtrentlig omkostning:",
    "estimatedCostForUs": "Anslået pris kun for SMS inden for USA.",
    "mobilePhoneNumber": "Mobilnummer",
    "numSegments": "Antal segmenter",
    "pickMessageTemplate": "Vælg beskedskabelon",
    "pleaseProvideAPhone": "Angiv et telefonnummer, som testen kan sendes til.",
    "composeEventtype": "Skriv {eventType}",
    "composeEventtypeTextTemplate": "Skriv {eventType} tekstskabelon",
    "unsupportedSmsContentType": "Ikke-understøttet SMS-indholdstype {fileType}",
    "countOfTheProvided": "{count} af de angivne URL-vedhæftninger {plural} er ikke et billede. Dette kan forårsage fejl i Twilio. Vil du gerne gemme alligevel?",
    "dropFileHereOr": "Slip filen her, eller klik for at uploade",
    "ifYouHaveAdditional": "Hvis du har yderligere spørgsmål, kan du se ofte stillede spørgsmål om telefonsvarerbeskeder i hjælpesektionen.",
    "editVoicemail": "Rediger telefonsvarerbesked",
    "selectAMp3Or": "Vælg en mp3- eller wav-fil, vi understøtter ikke andre formater.",
    "voicemailFile": "Talebeskedfil",
    "warningVoicemailDropsAre": "Advarsel: Opkald mod telefonsvarer er et bedst forsøgs-system og fungerer cirka 70 % af tiden.",
    "youNeedToPick": "Du skal vælge mindst 1 dag",
    "editWait": "Rediger Vent",
    "url": "URL",
    "customTime": "Tilpasset tidspunkt",
    "executeThisActionIf": "Udfør denne handling, hvis det aktuelle tidspunkt falder inden for dette vindue. Hvis det aktuelle tidspunkt er uden for dette vindue, skal du springe dette trin over og fortsætte til den næste handling.",
    "pickDays": "Vælg dage",
    "pickTime": "Vælg tid",
    "noRecordsFound1": "Ingen poster fundet.",
    "formAnalyze": "Formularanalyse",
    "totalSubmission": "Samlet indsendelse",
    "forgotPassword": "Glemt adgangskode?",
    "orContinueWith": "Eller fortsæt med",
    "signIn": "Log ind",
    "signIntoYourAccount": "Log ind på din konto",
    "thePasswordYouPicked": "Den adgangskode, du valgte",
    "yourEmailAddress": "Din e-mailadresse",
    "newEmailFrom": "Ny e-mail fra",
    "newMessageFrom": "Ny besked fra",
    "hasLeftANew": "har lavet en ny anmeldelse.",
    "repliedToTheReview": "svarede på anmeldelsen.",
    "loaded": "Indlæst",
    "snapshot": "Øjebliksbillede",
    "appointment": "Aftale",
    "appointmentDueInMinutes": "Aftale forfalder om {minutes} min for {contactName}",
    "appointmentReminder": "Aftalepåmindelse",
    "completedCount": "Færdig: {count}",
    "conversation": "Samtale",
    "facebookReview": "Facebook-anmeldelse",
    "failedCount": "Mislykkedes: {count}",
    "googleReview": "Google-anmeldelse",
    "internalChatMessage": "Intern chatbesked",
    "usernameMentionedYouIn": "{userName} nævnte dig i en samtale med {contactName}",
    "newAppointmentAssigned": "Ny aftale tildelt",
    "aNewAppointmentWith": "En ny aftale med {contactName} er blevet tildelt til dig.",
    "newAppointmentBooked": "Ny aftale booket",
    "youHaveNewAppointment": "Du har booket en ny aftale med {contactName}",
    "newCall": "Nyt opkald",
    "aNewChatWith": "En ny chat med {contactName} er blevet tildelt til dig.",
    "newEmail": "Ny e-mail",
    "newMention": "Ny omtale",
    "newReviewReceivedFrom": "Ny anmeldelse modtaget fra {contactName}",
    "aNewTypeIs": "En ny {type} er modtaget fra {contactName}",
    "notification": {
      "noRecentActivity": "Ingen nylig aktivitet"
    },
    "subAccount": "Underkonto",
    "subaccount1": "Underkonto:",
    "titleOnDateAt": "{title} den {date} kl. {time} i {contactName}",
    "titleDueInDuetime": "{title} forfalder om {dueTime} {unitOfTime} for {contactName}",
    "taskReminder": "Påmindelse om opgave",
    "youHaveCountTasks": "Du har {count} opgaver, der skal afleveres i dag",
    "youHaveCountTasks1": "Du har {count} opgaver, der skulle have været afleveret allerede",
    "droppedVoicemailTo": "Slog telefonsvarerbesked til",
    "errorWhileCloningProduct": "Fejl under kloning af produktet!",
    "productName": "Produktnavn",
    "selectLocations": "Vælg placeringer",
    "selectUptoMaxselectablelocatio": "Vælg op til {maxSelectableLocations} placeringer",
    "highlevelInc": "HighLevel Inc.",
    "CountMore": "+ {count} flere",
    "emails": "E-mails",
    "accountNotification": "Kontomeddelelse",
    "customerCare": "Kundeservice",
    "deliveryNotification": "Leveringsmeddelelse",
    "fraudAlertMessaging": "Beskeder om svindelalarm",
    "higherEducation": "Videregående uddannelse",
    "lowVolumeMixedRecommended": "Lav volumen blandet (anbefales)",
    "mixed": "Blandet",
    "pollingAndVoting": "Afstemning og stemmeafgivning",
    "publicServiceAnnouncement": "Offentlig servicemeddelelse",
    "securityAlert": "Sikkerhedsadvarsel",
    "mixedRecommended": "Blandet (anbefales)",
    "australiaCompanyNumberFrom": "Australien: Virksomhedsnummer fra ASIC (ACN)",
    "canadaCanadianBusinessNumber": "Canada: Canadian Business Number (CBN)",
    "indiaCorporateIdentityNumber": "Indien: Virksomhedsidentifikationsnummer",
    "greatBritainCompanyNumber": "Storbritannien: Virksomhedsnummer",
    "usaEmployerIdentificationNumbe": "USA: Employer Identification Number (EIN)",
    "other": "Andet",
    "israelRegistrationNumber": "Israel: Registreringsnummer",
    "estoniaVatNumber": "Estland: Momsnummer",
    "cooperative": "Kooperativ",
    "corporation": "Virksomhed",
    "limitedLiabilityCompanyOr": "Aktieselskab eller enkeltmandsvirksomhed",
    "nonprofitCorporation": "Nonprofitorganisation",
    "partnership": "Partnerskab",
    "ceo": "CEO",
    "cfo": "CFO",
    "director": "Direktør",
    "generalCounsel": "Juridisk chef",
    "onlineTrainingEducation": "Onlinetræning og -uddannelse",
    "financialServices": "Finansielle tjenester",
    "fitnessLifestyle": "Fitness og livsstil",
    "healthMedical": "Sundhed og medicin",
    "homeServices": "Håndværkerydelser",
    "legalServices": "Juridiske tjenester",
    "marketingAdvertising": "Markedsføring og reklame",
    "others": "Andre",
    "realEstate": "Fast ejendom",
    "restaurants": "Restauranter",
    "retailEcommerce": "Detailhandel og e-handel",
    "yourInformationHasBeen": "Dine oplysninger er blevet indsendt.",
    "somethingWentWrong1": "Der opstod en fejl",
    "newPassword": "Ny adgangskode",
    "proceedToLogin": "Fortsæt til login",
    "anyTime": "til enhver tid.",
    "callUsHighlevelSupport": "Ring til os hos HighLevel-support på",
    "troubleLoggingIn": "Har du problemer med at logge ind?",
    "sendSecurityCode": "Send sikkerhedskode",
    "sendCodeToEmail": "Send kode til e-mail",
    "verifySecurityCode": "Bekræft sikkerhedskode",
    "privacyPolicy": "Privatlivspolitik",
    "businessProfile": "Virksomhedsprofil",
    "reserveWithGoogleIntegration": "Book med Google-integration",
    "friendlyName": "Venligt navn",
    "updateCallerId": "Opdater opkalds-ID",
    "internationalFormat": "Internationalt format",
    "localFormat": "Lokalt format",
    "poolNumbers": "Nummerpulje",
    "swappingNumbers": "Ombytning af numre",
    "selectField": "Vælg felt",
    "surveyAnalyze": "Undersøgelsesanalyse",
    "locationIsRequired": "Placering er påkrævet.",
    "newSurveyName": "Nyt undersøgelsesnavn",
    "copySurvey": "Kopiér undersøgelse",
    "primaryCalendar": "Primær kalender",
    "cloneEntityname": "Klon {entityName}",
    "youHaveSuccessfullySubmitted": "Du har indsendt dokumenter",
    "addCustomValue": "Tilføj brugerdefineret værdi",
    "value": "Værdi",
    "youHaveSuccessfullyDeleted": "Du har slettet pakken.",
    "bundleDeletedSuccessfully": "Pakken blev slettet",
    "thereIsAnIssue": "Der er et problem med et af dine bilag. Gennemgå bilagene og årsagen/årsagerne til afvisningen.",
    "connect1": "Forbind!",
    "itSeemsEitherThe": "Det ser ud til, at Google-forbindelsen enten er brudt, eller den ikke er tilsluttet på den aktuelle placering. Tjek integrationsindstillingerne og integrer igen, hvis forbindelsen allerede eksisterer.",
    "selectPage": "Vælge Side",
    "somethingWentWrongPlease": "Der opstod en fejl. Prøv igen",
    "accept": "Accepter",
    "moreThan1Phone": "Mere end 1 telefonnummer tilladt",
    "byContinuingToUse": "Ved fortsat at bruge HighLevel-platformen accepterer du disse nye {termsLink} og {privacyLink}.",
    "byContinuingToUse1": "Ved fortsat at bruge HighLevel-platformen accepterer du disse nye",
    "termsOfService": "Servicevilkår",
    "weHaveUpdatedOur": "Vi har opdateret vores servicevilkår og privatlivspolitik – sørg for at tjekke dem ud!",
    "newTriggerName": "Nyt udløsernavn",
    "triggerName": "Triggernavn",
    "disableDndForSpecific": "Deaktiver DND for specifikke kanaler",
    "selectAdAccount": "Vælg reklamekonto",
    "selectAppointmentStatus": "Vælg aftalestatus",
    "below1": "nedenfor.",
    "Required": "* påkrævet",
    "whenYouGetA": "Når du modtager en ny anmeldelse, vil vi automatisk lægge den på din Facebook-side. Husk, at bedste praksis er at sende højst 3 anmeldelser om dagen til din konto.",
    "skip": "Spring over",
    "copyShareLink": "Kopiér delingslink",
    "agencyRelationshipNumbers": "Agenturrelationsnumre",
    "alteast1AgencyRelationship": "Der kræves mindst 1 agenturrelationsnummer.",
    "alteast1SubaccountId": "Mindst 1 underkonto-ID er påkrævet.",
    "somethingWentWrongWhile": "Der opstod en fejl ved lagring. Prøv igen senere.",
    "5PerPage": "5 pr. side",
    "10PerPage": "10 pr. side",
    "amountMustGreaterOr": "Beløbet skal være større end eller lig med 1 AUD.",
    "regions": {
      "africa": "Afrika",
      "asia_pacific": "Asien/Stillehavsområdet",
      "europe": "Europa",
      "latin_america": "Latinamerika",
      "usa_and_canada": "USA og Canada",
      "asia": "Asien",
      "latinAmerica": "Latinamerika",
      "usaCanada": "USA og Canada"
    },
    "expandIcon": "►",
    "noEntriesToShow": "Ingen poster at vise",
    "clear": "Ryd",
    "filter": "Filtrer",
    "test": "Test",
    "createNewTwilioSubAccountText": "Du skal oprette en ny twilio-konto, opdatere legitimationsoplysningerne for denne konto under Twilio-indstillinger og flytte telefonnumre, før du aktiverer genfakturering.",
    "viewing": "Visning",
    "makeSmsCompliantByAddingASenderInformation": "Gør SMS'en kompatibel ved at tilføje afsenderinformation.",
    "makeEmailCompliantByAddingAnUnsubscribeLinkInYourEmail": "Gør e-mail kompatibel ved at tilføje et afmeldingslink i din e-mail",
    "enableMissedCallTextBack": "Aktivér tekstbesked ved manglende opkald",
    "productInventory": "Produktbeholdning",
    "viewProductVariants": "Vis produktvarianter",
    "smtpSettings": "SMTP-indstillinger",
    "locationOPMTrafficStatis": "OPM-trafikstatistik for placering",
    "locationGPMTrafficStatis": "GPM-trafikstatistik for placering",
    "blacklistMonitorReports": "Rapport om overvågning af sortliste",
    "twoFactorAuthentication": "Tofaktorgodkendelse (2FA)",
    "recent": "Seneste",
    "noPermission": "Du har ikke tilladelse til at administrere skabeloner til dette produkt. Omdirigerer til kontrolpanelet.",
    "tasksNowHave": "Opgaver har nu",
    "option": "Valgmulighed",
    "facebookAdsReporting": "Rapportering af Facebook-annoncer",
    "googleAdsReporting": "Google Ads-rapportering",
    "adsDatePicker": "Ads-datovælger",
    "feedbackSubmitBtn": "Knap til indsendelse af feedback",
    "ifYouThinkMistakePleaseContact": "Hvis du mener, at dette er en fejl, bedes du kontakte",
    "forResolution": "for at få hjælp.",
    "live": "Live",
    "payouts": "Udbetalinger",
    "greatChoice": "Godt valg!",
    "toNavigate": "Navigere",
    "teams": "Teams",
    "role": "Rolle",
    "searchAccounts": "Søg efter konti",
    "searchByNameEmailPhone": "Søg på navn, e-mail eller telefon",
    "addEmployee": "Tilføj medarbejder",
    "removeFromLocation": "Fjern fra placering",
    "knowMore": "Få mere at vide",
    "usingNumberPool": "Brug af nummerpulje",
    "numbers": {
      "zero": "0",
      "one": "1"
    },
    "multiplier": "x",
    "reviewer": "Anmelder",
    "cancel1": "Annuller",
    "delete1": "Slet",
    "call1": "Opkald",
    "message1": "Besked",
    "name1": "Navn",
    "voicemail1": "Talebesked",
    "title1": "Titel",
    "choose_one": "Vælg en",
    "select_page": "Vælg side",
    "confirm1": "Bekræft",
    "conversations1": "Samtaler",
    "copied1": "Kopieret",
    "timeOfDay": {
      "am": "AM",
      "pm": "PM"
    },
    "back1": "Tilbage",
    "details1": "Oplysninger",
    "month1": "/måneden",
    "select1": "Vælg",
    "share1": "Del",
    "facebook1": "Facebook",
    "sidebar": {
      "blacklistMonitorReports": "Rapporter om overvågning af sortliste",
      "domainPurchase": "Domænekøb"
    },
    "confirmDelete": "Er du sikker på, at du vil slette {name}?",
    "clicked1": "Klikket",
    "delivered1": "Leveret",
    "invalid1": "Ugyldig",
    "open_options": "Åbn indstillinger",
    "_add_account": "Tilføj konto",
    "setTimezoneWarning": "Indstil tidszonen for din placering for at få de rigtige ledige tidsrum.",
    "save1": "Gem",
    "action1": "Handling",
    "actions1": "Handlinger",
    "all1": "hver",
    "previous1": "Tidligere",
    "results1": "Resultater",
    "next1": "Næste",
    "payments1": "Betalinger",
    "settings1": "Indstillinger",
    "total_js_heap": "Total JS Heap",
    "table": {
      "pagination": {
        "previous": "Forrige",
        "next": "Næste"
      },
      "rowsSelected": "{count} rækker valgt",
      "cantRearrange": "{type} kan ikke omarrangeres"
    },
    "ivrCall": "IVR-opkald",
    "sms": "SMS",
    "username": "Brugernavn",
    "stay": "Bliv",
    "placeholders": {
      "selectCountry": "Vælg dit land",
      "nameOfBusiness": "Virksomhedens navn",
      "line1": "Adresselinje 1",
      "line2": "Adresselinje 2",
      "enterState": "Indtast stat",
      "enterCity": "Indtast by",
      "enterPostalCode": "Indtast postnummer",
      "chooseCountry": "Vælg land ..."
    },
    "addressLine1": "Adresselinje 1",
    "addressLine2": "Adresselinje 2",
    "postalCode": "Postnummer",
    "nameOfBusiness": "Virksomhedens navn",
    "dispute_this_review": "Bestrid denne anmeldelse",
    "story_mention": "Story-omtale",
    "story_reply": "Svar på story",
    "no": "Nej",
    "yes": "Ja",
    "annual": "årlig",
    "plan": "Plan",
    "errors": {
      "somethingWrong": "Der opstod en fejl"
    },
    "zero": "0",
    "perMonth": "pr. måned",
    "emailCheckLinks": "Tjek de links, hvor du har en brugerdefineret værdi. Der er en ekstra \"%20\" mellem {{ og custom_values.",
    "fileSizeTooLarge": "Filstørrelsen er større end 5 MB",
    "fileSizeTooLargeDescription": "Den fil, du forsøger at uploade, er for stor. Prøv med en mindre fil.",
    "minMaxLength40Characters2048Characters": "Min. længde: 40 tegn. Maks. længde: 2048 tegn.",
    "sampleMessage2": "Eksempelbesked #2*",
    "pleaseSelectWorkflow": "Vælg en arbejdsgang",
    "childrens": "Underordnede",
    "brandAndCampaignRegistration": "Der opkræves et engangsbeløb på 20,95 USD for registrering af brand og kampagne. Yderligere kampagnegebyr på op til 2,25 USD pr. måned vil blive pålagt i overensstemmelse med TCR-reglerne.",
    "einRequiredForRegistration": "EIN er påkrævet for registrering",
    "changed_props": "Ændrede egenskaber",
    "total_memory": "Total hukommelse",
    "total_store_size": "Samlet butikstørrelse",
    "total_watchers": "Samlet antal seere",
    "update_count": "Opdateringsantal"
  },
  "contacts": {
    "bulkRequests": {
      "bulkActions": "Massehandlinger",
      "clickHere": "Klik her for at se listen over massehandlinger.",
      "mergedMessage": "Denne side er blevet flettet sammen med listen over massehandlinger.",
      "title": "Kontaktanmodninger"
    }
  },
  "conversations": {
    "noConversationsFound": "Der blev ikke fundet nogen {status} samtaler",
    "create_new": "Opret ny besked​",
    "validations": {
      "minCharsRequired": "Min. 3 tegn er påkrævet",
      "twoMoreCharsRequired": "2 tegn mere kræves",
      "oneMoreCharRequired": "1 tegn mere kræves"
    },
    "sortLabels": {
      "latestAllMessages": "Seneste - alle beskeder",
      "oldestAllMessages": "Ældste - alle beskeder",
      "latestManualMessages": "Seneste - manuelle beskeder",
      "oldestManualMessages": "Ældste - manuelle beskeder",
      "latestAll": "Seneste-Alle",
      "oldestAll": "Ældste-Alle",
      "latestManual": "Seneste-Manuel",
      "oldestManual": "Ældste-Manuel",
      "highToLow": "{name} (høj til lav)",
      "manualMessagesTooltip": "Sorteringsmuligheden vil være gældende for beskeder slået op den 18. maj 2023."
    },
    "deleteConversation": {
      "title": "Bekræftelse",
      "confirmWithName": "Er du sikker på, at du vil slette samtalen med {name} for altid? Dette kan ikke fortrydes.",
      "confirmWithoutName": "Er du sikker på, at du vil slette denne samtale for altid? Dette kan ikke fortrydes."
    },
    "makeCall": {
      "enterPhoneNumber": "For at foretage et opkald skal du indtaste et telefonnummer i dette felt.",
      "invalidPhoneNumber": "Twilio Lookup markerede dette telefonnummer som ugyldigt."
    },
    "actions": {
      "markAsStarred": "Markér med stjerne",
      "unarchive": "Fjern arkivering",
      "unmarkAsStarred": "Fjern markering med stjerne"
    },
    "send": {
      "perMonthPerIp": "/måned/IP",
      "perIp": "/IP",
      "replyingTo": "Svarer på",
      "requestClientsPaymentDetails": "Anmod om kunders betalingsoplysninger",
      "saasModeCreditCardRequired": "SaaS-tilstand kræver et kreditkort registreret på klientens konto.",
      "please": "Du skal",
      "firstBeforeEnablingSaaS": "først, før du aktiverer SaaS-tilstand.",
      "shareALink": "Del et link",
      "shareLinkInstructions": "Del et link med din kunde for at indsamle deres betalingsoplysninger",
      "requestViaEmail": "Anmodning via e-mail",
      "twilioRebillingDescription": "Omfakturér Twilio-omkostninger ({twilioCopy}) til dine kunder og inkluder et tillæg",
      "seeHow": "Se hvordan",
      "phoneRebillingCardInfoRequired": "Genfakturering af telefon kræver, at der er kortoplysninger registreret for klienten.",
      "clientsCompanyBillingPage": "klientens virksomheds faktureringsside",
      "ifYouPayForTwilioKeepUsing": "Hvis du betaler for Twilio, så bliv ved med at bruge den samme Twilio-konto",
      "ifClientPaysForTwilioCreateNew": "Hvis klienten betaler for Twilio, skal du oprette en ny Twilio-konto",
      "learnHow": "Lær hvordan",
      "createNewTwilioAccountInstructions": "Opret en ny Twilio-konto til denne placering",
      "learnHowToMovePhoneNumbers": "Lær at flytte telefonnumre",
      "thisIsMyClientsTwilioCreateNew": "Dette er min klients Twilio, opret en ny konto",
      "featureUnderDevelopment": "Denne funktion er under udvikling",
      "emailRebillingDescription": "Genfakturer e-mailomkostninger til dine klienter og inkluder en avance",
      "emailRebillingCardInfoRequired": "E-mail-genfakturering kræver, at der er kortoplysninger registreret for klienten.",
      "emailRebillingMarginsDescription": "Dette er marginer, der faktureres til jeres kunder ud over e-mailomkostningerne.",
      "provider": "Udbyder",
      "morePlanCustomizationsAvailable": "Flere abonnementstilpasninger tilgængelige",
      "plansAndPricing": "Planer og priser",
      "connectYourStripeAccountFirst": "Forbind først din Stripe-konto",
      "createRecommendedPlansOnStripe": "Opret anbefalede planer på Stripe",
      "createdPlanInStripe": "Oprettet plan i Stripe",
      "customizeYourSaasPlans": "Tilpas dine SaaS-abonnementer",
      "youCanOfferRecommendedPlansOrBuildYourOwn": "De kan tilbyde anbefalede planer eller bygge deres egne",
      "trialPeriod": "Prøveperiode",
      "enterNumberOfDaysForTrial": "Indtast antal dage til prøveperiode",
      "nameCantBeEmpty": "Navnet må ikke være tomt.",
      "showStripeProductDetails": "Vis Stripe-produktdetaljer",
      "addEmail": "Tilføj e-mail",
      "resetMountCounts": "Nulstil monteringsoptællinger",
      "connectReconnectGoogleForGbp": "Opret eller genopret forbindelsen til Google for GBP",
      "downloadFile": "Download fil",
      "showOnlySlowQueries": "Vis kun langsomme forespørgsler",
      "gmbMessagingAvailable": "GMB-beskeder er nu tilgængelige",
      "reconnectGbpPageToEnable": "Genopret forbindelse til din GBP-side for at aktivere beskeder",
      "failedPaymentsCheckBilling": "Fejl i betalinger registreret. Tjek din fakturering.",
      "onlyAgencyAdminsCanSeeWarning": "Kun agenturadministratorer kan se denne advarsel.",
      "filter": "Filtrer",
      "stopDeleteOperation": "Stop sletning",
      "summary": "Oversigt",
      "enableTracking": "Aktivér sporing",
      "exportAll": "Eksportér alle",
      "newConversationStarted": "En ny samtale er startet.",
      "startNewConversation": "Start en ny samtale",
      "subAccountScheduledForDeletion": "Underkonto planlagt til sletning",
      "deleteSubAccountOnScheduledTime": "Slet underkonto på planlagt tid",
      "componentUpdatesDebuggerAlpha": "Debugger for komponentopdateringer (Alpha)",
      "componentUpdateTrackingDisabled": "Sporing af komponentopdateringer er deaktiveret",
      "deleteSubAccount": "Slet underkontoen",
      "subAccountHasNumbersAndCampaigns": "Denne underkonto har {phoneNumberCount} telefonnummer/-numre og {campaignsCount} kampagne(r).",
      "subAccountNoNumbersOrCampaigns": "Denne underkonto har ingen telefonnumre eller kampagner.",
      "areYouSureDeleteSubAccount": "Er du sikker på, at du vil slette denne underkonto?",
      "confirmDiscussedWithClient": "Jeg bekræfter, at jeg har drøftet dette med min klient.",
      "understandActionIrreversible": "Jeg forstår, at denne handling er irreversibel.",
      "confirmDisconnectCloseLcPhone": "Jeg bekræfter, at jeg ønsker at afbryde og lukke LC Phone-kontoen.",
      "choosingNotDeleteLcPhoneWarning": "Advarsel: Hvis du vælger ikke at slette LC Phone-kontoen, vil du fortsat blive opkrævet for de telefonnumre, der er knyttet til denne underkonto.",
      "deleteAccount": "Slet konto",
      "send": "Send",
      "typeMessage": "Skriv en besked",
      "requestPayment": "Anmod om betaling",
      "reply": "Svar",
      "retry": "Prøv igen",
      "analyzeMemory": "Analyser hukommelse",
      "memoryAnalysisApproximate": "🚧 Hukommelsesanalyse er omtrentlig og ikke 100 % præcis.",
      "subAccountScheduledForDeletionItWillBeDeleted": "Denne underkonto er blevet udvalgt til sletning. Den vil blive slettet den",
      "youCanChangeYourMindBeforeThisTime": "Du kan skifte mening før dette tidspunkt.",
      "sms": {
        "errors": {
          "skipStayPrompt": "Spring over",
          "cannotIdentifyContact": "Kan ikke identificere kontakten og dens placering.",
          "contactNotSelected": "Kontakt er ikke valgt.",
          "messageRequired": "Sørg for, at du har indtastet en besked eller valgt en skabelon.",
          "noPhoneNumber": "Kontakten har ikke et telefonnummer.",
          "genericError": "{message}",
          "stayPrompt": "Bliv"
        },
        "scheduledSuccess": "E-mail planlagt",
        "confirmDelete": "Er du sikker på, at du vil slette {name}?"
      },
      "clear": "Ryd",
      "edit": "Rediger",
      "sendNow": "Send nu",
      "schedule": "Planlæg",
      "useTemplate": "Brug en skabelon (uddrag)",
      "mergeFields": "Flet felter",
      "customVariablesError": "Der er problemer i dine tilpassede variabler. Løs dem, før du sender.",
      "sendLater": "Send senere",
      "scheduledFor": "Planlagt til {date}",
      "call": "Opkald",
      "leftVoicemail": "Efterlod en talebesked",
      "pleaseSelectCampaign": "Vælg en kampagne",
      "whatsapp": {
        "no24HourMessage": "Du kan kun sende skabelonbeskeder uden for 24-timersvinduet. Vælg en skabelon, der skal sendes."
      },
      "attachFile": "Vedhæft fil",
      "email": {
        "fromEmail": "Fra e-mail",
        "fromName": "Fra navn",
        "smtpWarning": "SMTP-udbyderne har nogle begrænsninger. Klik her for at få mere at vide.",
        "subject": "Emne",
        "errors": {
          "cannotIdentifyContact": "Kan ikke identificere kontakten og dens placering.",
          "contactNotSelected": "Kontakt er ikke valgt.",
          "genericError": "{message}",
          "bodyRequired": "E-mailen kræver en brødtekst for at blive sendt.",
          "noEmailAddress": "Kontaktpersonen har ikke en e-mailadresse."
        },
        "scheduledSuccess": "E-mail planlagt"
      },
      "addCalendarToSchedule": "Du skal tilføje en kalender for at begynde at planlægge aftaler.",
      "slotRequired": "Tidsrum er påkrævet",
      "teamMemberRequired": "Teammedlem er påkrævet."
    },
    "added": "tilføjet",
    "loadMore": "Indlæs mere",
    "admin": "Administrator",
    "aiEmployee": {
      "popupBlockedAlert": "Du har deaktiveret pop op-vinduer. Tillad pop op-vinduer, så dette website automatisk viderestiller til Zoom-opkald. Klik på \"Deltag nu\" for at blive omdirigeret direkte til Zoom-opkaldet."
    },
    "alsoCloseAssociatedSubAccount": "Luk også tilknyttet",
    "analyzeMemory": "Analysér hukommelse",
    "announcements": "Meddelelser",
    "apply": "Anvend",
    "appointment": {
      "pickDay": "Vælg en dag",
      "pickSlot": "Vælg et aftaletidsrum",
      "selectDate": "Vælg dato",
      "selectSlot": "Vælg tidsrum",
      "slot": "Tidsrum",
      "day": "Dag"
    },
    "areYouReallySureDeleteSubAccount": "Er du virkelig sikker på, at du vil slette denne underkonto?",
    "areYouSureDeleteSubAccount": "Er du sikker på, at du vil slette denne underkonto?",
    "assignedContactOwner": "Tildelt ({contact} ejer)",
    "assignedToMe": "Tildelt til mig",
    "audio": {
      "browserNotSupported": "Din browser understøtter ikke lydelementet.",
      "loadingTranscription": "Indlæser transskription ...",
      "viewTranscript": "Vis transskription",
      "stop": "Stop",
      "playPause": "Afspil/pause",
      "timePlayed": "Spilletid : Samlet tid",
      "mute": "Slå lyden fra",
      "playbackSpeed": "Afspilningshastighed",
      "download": "Download",
      "remove": "Ryd"
    },
    "automated": "Automatiseret",
    "avatar": {
      "aiGenerated": "Denne besked blev genereret af Conversation AI",
      "messengerAutomation": "Messenger-automatisering",
      "workflowGenerated": "Denne besked blev genereret af Conversation AI Workflow Action",
      "messageByAI": "Denne besked blev genereret af Conversation AI",
      "messageByWorkflow": "Denne besked blev genereret af Conversation AI Workflow Action",
      "agentPrefix": "E-",
      "unknownFallback": "?"
    },
    "bePartOfFastestGrowingCommunity": "Bliv en del af det hurtigst voksende fællesskab.",
    "callHighlevelAt": "Ring til HighLevel på +1(888)732-4197",
    "callQueueTooltip": "Dette opkald er i brugerens opkaldskø og venter på at blive aktiveret.",
    "callTranscript": "Opkaldstransskription",
    "clearFilters": "Ryd filtre",
    "clientsCompanyBillingPage": "klientens virksomheds faktureringsside",
    "closeChat": "Luk chatten",
    "closeConversation": "Luk samtalen",
    "component": {
      "dismissMessage": "AFVIS DENNE BESKED",
      "unblock": "Fjern blokering",
      "inboundDndActive": "Indgående DND er aktiveret for denne kontakt",
      "fetchOlderMessages": "Hent gamle beskeder",
      "conversationBegan": "Snakken begyndte",
      "celebrationTitle": "Hurra! Samtalerne flyder nu.",
      "celebrationBody": "Det er lige begyndt, lad os udforske, hvordan GHL kan hjælpe med at opbygge din virksomhed.<br />I mellemtiden kan du fortsætte med at sende beskeder, så meget du vil"
    },
    "componentUpdateTrackingDisabled": "Opdateringssporing af komponenter er i øjeblikket deaktiveret",
    "componentUpdatesDebuggerAlpha": "🚧 Fejlfindingsprogram til komponentopdateringer (Alpha) - Igangværende arbejde",
    "confirmDelete": "Slet samtale(r)?",
    "confirmDeleteTextLine11": "Er du sikker på, at du vil slette denne samtale? Denne handling kan ikke fortrydes.",
    "confirmDeleteTextLine12": "samtaler valgt",
    "confirmDeleteTextLine21": "Denne handling er uigenkaldelig. Vil du stadig fortsætte?",
    "confirmDisconnectedAllIntegrations": "Jeg bekræfter, at jeg har afbrudt alle integrationer såsom Twilio, Mailgun, GMB, domæner, Facebook, Zoom osv.",
    "confirmStoppedAllAutomations": "Jeg bekræfter, at jeg har stoppet alle automatiseringer i denne underkonto.",
    "connectReconnectGoogleForGbp": "Forbind/genforbind din Google for at få GBP-beskeder!",
    "connectWithCertifiedAdmin": "Forbind med en certificeret administrator",
    "connectWithTeamForHelp": "Kontakt vores team for at få hjælp via et livevideoopkald!",
    "connectWithUs": "Kontakt os",
    "connectZoomAccount": "Forbind Zoom-konto",
    "contactEngagementScore": "Engagementsscore for {contact}",
    "dailyBrainstormingSessions": "Daglige brainstorming-sessioner med HighLevel",
    "deleteAccount": "Slet konto",
    "deleteSubAccountOnScheduledTime": "Slet underkontoen på det planlagte tidspunkt",
    "disableSaasMode": "Deaktiver SaaS-tilstand",
    "dnd": {
      "configure": "KONFIGURER",
      "status": {
        "on": "TIL",
        "partial": "Delvist"
      }
    },
    "editAppointment": {
      "updateButton": "Opdater aftale",
      "scheduleAppointment": "Planlæg aftale",
      "editAppointment": "Rediger aftale",
      "calendar": "Kalender",
      "selectCalendar": "Vælg kalender",
      "roundRobin": "Automatisk tildeling af aftaler",
      "pickTeamMember": "Vælg et teammedlem",
      "selectTeamMember": "Vælg teammedlem",
      "teamMemberRequired": "Teammedlem er påkrævet.",
      "slotRequired": "Tidsrum påkrævet",
      "appointmentTitle": "Aftalens titel",
      "appointmentTitleTooltip": "Overvej at lade det stå tomt, hvis du vælger at bruge den forudkonfigurerede aftaletitel",
      "contactName": "Navn på kontaktperson",
      "name": "Navn",
      "nameRequired": "Navn er påkrævet",
      "emailAddress": "E-mailadresse",
      "phoneNumber": "Telefonnummer",
      "phoneNumbers": "Telefonnumre",
      "dateOfBirth": "Fødselsdato",
      "contactTimezone": "Kontakttidszone (bruges til påmindelse)",
      "chooseOne": "Vælg en ...",
      "meetingLocation": "Mødested",
      "meetingLocationTooltip": "Overvej at lade det stå tomt, hvis du vælger at bruge det forudkonfigurerede mødested",
      "status": "Status",
      "appointmentStatus": "Aftalestatus",
      "additionalNotes": "Yderligere bemærkninger",
      "notes": "Noter",
      "actionRequired": "Handling påkrævet",
      "confirmed": "Bekræftet",
      "invalid": "Ugyldig",
      "cancelled": "Annulleret",
      "showed": "Fremmødt",
      "noShow": "Udeblevet",
      "busy": "Optaget",
      "free": "Gratis",
      "noCalendarMessage": "Du skal tilføje en kalender for at begynde at planlægge aftaler."
    },
    "email": {
      "errors": {
        "bodyRequired": "E-mailen kræver en brødtekst for at blive sendt.",
        "cannotIdentifyContact": "Kan ikke identificere kontakt og dens placering.",
        "contactNotSelected": "Den kontakt er ikke valgt.",
        "noEmailAddress": "Kontakten har ikke en e-mailadresse."
      },
      "thread": {
        "failedToFetch": "E-mailindholdet kunne ikke hentes",
        "forward": "Videresend"
      },
      "reply": "Svar",
      "share": "Del",
      "facebook": "Facebook",
      "twitter": "Twitter",
      "addAccount": "+ Tilføj konto",
      "respond": "Besvar",
      "retry": "Prøv igen",
      "moreEmailsInThread": "{count} flere e-mails i tråden",
      "fromName": "Fra navn",
      "fromEmail": "Fra e-mail",
      "subject": "Emne",
      "attachFile": "Vedhæft fil",
      "useTemplate": "Brug en skabelon (uddrag)",
      "requestPayment": "Betalingsanmodning",
      "clear": "Ryd",
      "sendNow": "Upload nu",
      "schedule": "Planlæg",
      "send": "Send",
      "smtpWarning": "SMTP-udbyderne har nogle begrænsninger. Klik her for at få mere at vide.",
      "chooseOne": "Vælg en ...",
      "deliveredCount": "{delivered}/{total} sendt",
      "typeMessage": "Skriv en besked",
      "sendLater": "Send senere",
      "scheduledFor": "Planlagt til {date}"
    },
    "emailRebillingCardInfoRequired": "For at aktivere e-mailgenfakturering skal du indtaste din klients kortoplysninger på",
    "emailRebillingDescription": "Dette giver dig mulighed for at genfakturere e-mailomkostninger til dine kunder og inkludere en avance.",
    "emailRebillingMarginsDescription": "Dette er margener, der faktureres til dine kunder ud over de e-mailomkostninger, du selv afholder.",
    "enableTracking": "Aktivér sporing",
    "exploreHighlevelExperts": "Udforsk HighLevel-eksperter, der kan hjælpe med at konfigurere dit system, automatisere arbejdsgange eller tilpasse dit projekt.",
    "exportAll": "Eksportér alle",
    "facebook": {
      "errors": {
        "generalError": "Der er opstået en fejl. Prøv igen, eller tjek Facebook-integrationen. Fejlmeddelelse:",
        "noFacebookId": "Kontakten har ikke et Facebook-ID."
      }
    },
    "failedPaymentsCheckBilling": "Du har en eller flere mislykkede betalinger. Tjek din faktureringshistorik.",
    "fbMessengerDM": "FB Messenger DM",
    "filters": {
      "above": "Over",
      "aiActionLogs": "AI-handlingslogfiler",
      "inRange": "Inden for området",
      "invoice": "Faktura",
      "messageDirectionTooltip": "Filteret vil være gældende for beskeder slået op den 9. maj 2023",
      "appointments": "Aftaler"
    },
    "followed": "Fulgt af",
    "followedByMe": "Fulgt af mig",
    "followedBySpecificUser": "Fulgt af en specifik bruger",
    "follower": "Følgere",
    "followerAssignmentContact": "Følger ({contact} tildeling)",
    "gbp": {
      "errors": {
        "generalError": "Der er opstået en fejl. Prøv igen, eller tjek integrationen af Google Business Profile. Fejlmeddelelse:",
        "noGBPId": "Kontakten har ikke et GBP-ID."
      }
    },
    "gbpChatNoLongerAvailable": "Google Business Profile Chat er ikke længere tilgængelig",
    "getAccessToHighlevelWelcomeCourse": "Få adgang til HighLevel-velkomstkurset",
    "getPriorityTroubleshooting": "Få prioriteret fejlfinding, ekspertvejledning og direkte adgang til vores tekniske team via Slack.",
    "gmbMessagingAvailable": "Google Business Messaging er tilgængelig for din konto.",
    "googleMeet": "Google Meet",
    "googleReview": {
      "rating": "Bedømmelse:",
      "replyDate": "Svardato:",
      "replyFrom": "Svar fra:",
      "review": "Gennemgå",
      "reviewDate": "Anmeldelsesdato:",
      "reviewFrom": "Anmeldelse fra:"
    },
    "highlevelEvents": "Highlevel-events",
    "igMessengerDM": "IG Messenger DM",
    "includeSignatureBeforeQuotedText": "Inkluder denne signatur før citeret tekst i svar.",
    "instagram": {
      "errors": {
        "generalError": "Der er opstået en fejl. Prøv igen, eller tjek Instagram-integrationen. Fejlmeddelelse:",
        "noInstagramId": "Kontakten har ikke et Instagram-ID."
      }
    },
    "joinOurFacebookGroup": "Bliv medlem af vores Facebook-gruppe",
    "keepUpToDateWithLatestNews": "Hold dig opdateret med alle de seneste nyheder og udgivelser.",
    "lastMessageChannel": "Sidste beskedkanal",
    "lastMessageDirection": "Sidste meddelelsesretning",
    "lastOutboundMessageType": "Sidste udgående meddelelsestype",
    "learnHow": "Lær hvordan?",
    "leftComment": "efterlod en kommentar",
    "leftPanel": {
      "recents": "Seneste",
      "unread": "Ulæst",
      "createNewMessage": "Opret ny besked",
      "minCharsRequired": "Min. 3 tegn er påkrævet",
      "twoMoreCharsRequired": "Der kræves 2 tegn mere",
      "oneMoreCharRequired": "1 tegn mere er påkrævet"
    },
    "liveChat": {
      "endLiveChat": "Afslut livechat",
      "errors": {
        "generalError": "Der er opstået en fejl. Prøv igen, eller tjek Google My Business-integrationen. Fejlmeddelelse:"
      },
      "requestContact": "Anmod om kontakt"
    },
    "live_chat_message": "Livechat-besked",
    "made": "lavet",
    "memoryAnalysisApproximate": "🚧 Hukommelsesanalyse er omtrentlig og ikke 100 % præcis.",
    "mentioned": "Nævnt til",
    "mentions": "Omtaler",
    "mentionsOfMe": "Omtaler af mig",
    "mentionsOfSpecificUser": "Omtaler af specifik bruger",
    "message": {
      "replyAll": "Svar alle",
      "details": "Oplysninger",
      "reply": "Svar",
      "unsuccessful": "Mislykket",
      "pending": "Afventer",
      "inboundCall": "Indgående opkald",
      "outboundCall": "Udgående opkald",
      "ivrCall": "IVR-opkald",
      "leftVoicemail": "Efterlod en talebesked",
      "storyReply": "Svar på Story",
      "storyMention": "Story-omtale",
      "replyAsDM": "Svar som DM",
      "newCommentOnPost": "Ny kommentar til indlægget {pageName}.",
      "goToPost": "Gå til opslaget",
      "replyNotAvailable": "Det er ikke muligt at svare som privat DM for kommentarer, der er ældre end 7 dage.",
      "addToDocuments": "Tilføj til dokumenter",
      "attachmentsAddedSuccess": "Vedhæftede filer blev tilføjet til dokumenterne",
      "attachmentsAddedFailed": "Kunne ikke inkludere vedhæftede filer til dokumenterne",
      "reportFeedbackForAI": "Giv feedback for AI",
      "sms": "SMS"
    },
    "messageDetails": {
      "bcc": "BCC",
      "cancelScheduleConfirm": "Er du sikker på, at du vil annullere dette skema?",
      "cancelScheduledMessage": "Vil du annullere den planlagte besked?",
      "cancelSend": "Annuller sendt",
      "cancelScheduledSuccess": "Planlagt besked blev annulleret",
      "cancelScheduledError": "Der opstod en fejl under annullering af den planlagte besked",
      "cc": "CC",
      "channel": "Kanal",
      "createdBy": "Oprettet af",
      "direction": "Retning",
      "emailCampaign": "E-mailkampagne",
      "facebookMessage": "Facebook-besked",
      "instagramMessage": "Instagram-besked",
      "messageId": "Besked-id",
      "messageIdLabel": "Message ID: ",
      "trigger": "Udløser",
      "unanswered": "Ubesvaret",
      "yes": "Ja",
      "messageDetails": "Beskedoplysninger",
      "from": "Fra",
      "fromLabel": "Fra:",
      "to": "Til",
      "toLabel": "Til:",
      "unknown": "Ukendt",
      "unknownFrom": "Ukendt fra",
      "unknownTo": "Ukendt til",
      "unknownDirection": "Ukendt retning",
      "dateUnknown": "Dato ukendt",
      "emailFromUnknown": "E-mail fra ukendt person",
      "smsFromUnknown": "SMS fra ukendt",
      "callFromUnknown": "Opkald fra ukendt person",
      "voicemailFromUnknown": "Talebesked fra ukendt person",
      "emailToUnknown": "E-mail til ukendt person",
      "smsToUnknown": "Sms til ukendt person",
      "callToUnknown": "Opkald til ukendt person",
      "voicemailToUnknown": "Talebesked til ukendt person",
      "failed": "Mislykkedes",
      "datetime": "Dato og tid",
      "manual": "Manuel",
      "automation": "Automatisering",
      "workflow": "Arbejdsgang",
      "campaign": "Kampagne",
      "bulkRequest": "Masseanmodning",
      "delivered": "Leveret",
      "bounced": "Afvist",
      "opened": "Åbnet",
      "sent": "Sendt",
      "scheduled": "Planlagt",
      "pageName": "Sidenavn",
      "gbpMessage": "GBP-besked",
      "no": "Nej",
      "eventsTrackedForContactOnly": "Hændelser registreres i øjeblikket kun for kontaktens e-mailadresse.",
      "completed": "Færdig",
      "voicemail": "Talebesked",
      "busy": "Optaget",
      "pending": "Afventer",
      "read": "Læst",
      "nativeIntegrations": "Indbyggede integrationer",
      "smtp": "SMTP",
      "twilio": "Twilio",
      "leadConnector": "LeadConnector",
      "email": "E-mail",
      "sms": "SMS",
      "phoneCall": "Telefonopkald",
      "voiceMail": "Talebesked",
      "facebookMessenger": "Facebook Messenger",
      "instagramMessenger": "Instagram Messenger",
      "gbpMessenger": "GBP Messenger",
      "reviews": "Anmeldelser",
      "others": "Andre",
      "partialDetailsWarning": "Delvise oplysninger vil være tilgængelige for beskeder før 15. juli 2022.",
      "agencySystem": "Agentursystem",
      "reply": "Svar"
    },
    "multiplePhone": {
      "chooseNumber": "Vælg et nummer for at starte samtalen:",
      "continue": "Fortsæt",
      "noPhones": "Ingen tilgængelige telefonnumre"
    },
    "myChat": "Min chat",
    "myInbox": "Min indbakke",
    "newConversationStarted": "En ny samtale er startet.",
    "newMessage": {
      "title": "Ny besked:",
      "errors": {
        "phoneRequired": "Telefonnummer er påkrævet"
      }
    },
    "noConversationSelected": "Ingen samtale er valgt",
    "noResultsToShow": "Der er ingen resultater at vise",
    "onboardingVideoTutorials": "Videovejledning til onboarding",
    "onlyAgencyAdminsCanSeeWarning": "Kun agenturadministratorer kan se denne advarsel. For mere information",
    "onlyVisibleToUsers": "Kun synlig for brugerne",
    "perMonthPerIp": "/måned/IP",
    "phone": {
      "call": "Ring til {name}",
      "callingOptions": "{count} Valgmuligheder for opkald",
      "phoneNumbers": "Telefonnumre",
      "callOptions": "{count} opkaldsvalgmuligheder",
      "dndActive": "DND er aktiv for opkald",
      "primary": "Primær"
    },
    "pleaseDisableSaasMode": "Deaktiver SaaS-tilstanden for denne underkonto",
    "pleaseSelectCampaign": "Vælg en kampagne",
    "premiumSupport": "Premium-support",
    "quickFilters": "Hurtige filtre",
    "reconnectGbpPageToEnable": "Genopret forbindelse til din GBP-side for at aktivere den.",
    "replyAsDMTooltip": "Svar på denne kommentar som en privat DM.",
    "replyingTo": "Svarer på",
    "resetMountCounts": "Nulstil monteringsoptællinger",
    "review": {
      "errors": {
        "generalError": "Der er opstået en fejl. Fejlmeddelelse:",
        "googleIntegrationError": "Kan ikke svare på den anmeldelse. Der ser ud til at være en fejl i din Google Integration. Opret forbindelse igen under Indstillinger -> Integrationer.",
        "noReviewId": "Snakken har ikke et anmeldelses-ID."
      },
      "reviewPostTo": "Anmeld indlæg på {network}",
      "sharedOn": "Anmeldelse delt på {network}",
      "disputeReview": "Bestrid denne anmeldelse",
      "learnHow": "(Lær hvordan?)",
      "seeOnGBP": "Se denne anmeldelse på GBP",
      "alreadyShared": "Denne anmeldelse er allerede blevet offentliggjort på {network}. Er du sikker på, at du vil genposte det?"
    },
    "reviewId": "Anmeldelses-id",
    "schedule": {
      "sendSchedule": "Send skema",
      "timezone": "Tidszone ({heading})",
      "title": "Planlæg din {type}"
    },
    "scheduling": "Planlægger ...",
    "seeHow": "Se hvordan",
    "selectFilter": "Vælg filter",
    "selected": "udvalgt",
    "sendEmail": {
      "recipientPlaceholder": "modtager@eksempel.com",
      "subject": "Emne:",
      "subjectPlaceholder": "E-mailens emne",
      "to": "Til:",
      "sending": "Sender ...",
      "sendButton": "Send e-mail"
    },
    "setupAccountWithFreeTutorials": "Konfigurer din konto med gratis vejledninger",
    "showOnlySlowQueries": "Vis kun langsomme forespørgsler (>{threshold}ms)",
    "sms": {
      "confirmSending": "Bekræft afsendelse af besked",
      "editModal": {
        "compose": "Opret SMS"
      },
      "errors": {
        "customVariablesIssue": "Der er problemer i dine tilpassede variabler. Løs dem, før du sender.",
        "messageOrTemplateRequired": "Sørg for, at du har indtastet en besked eller valgt en skabelon.",
        "noPhoneNumber": "Kontakten har ikke et telefonnummer."
      },
      "scheduledSuccessfully": "SMS blev planlagt",
      "sendAnyway": "Send alligevel",
      "spamWarning": "Dit sms-indhold kan indeholde referencer til cannabis, SHAFT, vape eller andre forbudte emner. Det er strengt forbudt at sende sådant indhold via sms og kan føre til kontobegrænsninger. Gennemgå dit indhold omhyggeligt, før du fortsætter.",
      "send": "Send"
    },
    "startNewConversation": "Start en ny samtale",
    "subAccountAndDeleteAllPhoneNumbers": "underkonto, og slet alle telefonnumre",
    "subAccountScheduledForDeletion": "Denne underkonto er planlagt til sletning",
    "subAccountScheduledForDeletionItWillBeDeleted": "Denne underkonto er blevet planlagt til sletning. Den vil blive slettet den",
    "teamInbox": "Gruppe-indbakke",
    "threshold": "Bundgrænse",
    "understandActionIrreversible": "Jeg forstår, at denne handling er irreversibel, og at alle data i denne underkonto vil gå tabt.",
    "unstarred": "Ikke-stjernemarkeret",
    "use_a_template": "Brug en skabelon",
    "userAvailability": "Brugertilgængelighed",
    "userCalendarConfiguration": "Brugerkalenderkonfiguration",
    "userInfo": "Brugeroplysninger",
    "userRoles": "Brugerroller",
    "viewSupportTickets": "Se dine supportsager, vores supportartikler og nyttige ofte stillede spørgsmål!",
    "visitOurHelpCenter": "Besøg vores Hjælpecenter",
    "welcomeCourse": "Velkomstkursus",
    "whatsapp_logo": "WhatsApp-logo",
    "youCanChangeYourMindBeforeThisTime": "Du kan skifte mening før dette tidspunkt.",
    "zoomAccount": "Zoom-konto",
    "deleteEmails": "Slet {count} e-mail(s)",
    "fileAttachment": {
      "urlNotFound": "URL kan ikke findes",
      "unsupportedAttachment": "Disse vedhæftede filer understøttes muligvis ikke længere.",
      "downloadFile": "Download fil"
    },
    "composer": {
      "internalComment": "Intern kommentar"
    },
    "dropdown": {
      "openOptions": "Åbn indstillinger",
      "messageDetails": "Beskedoplysninger"
    },
    "respond": "Besvar",
    "selectTemplate": "Vælg en skabelon",
    "settings": {
      "aiEmployeePromo": {
        "popupBlockedMessage": "Du har deaktiveret pop op-vinduer. Tillad pop op-vinduer, så dette website automatisk viderestiller til Zoom-opkald. Klik på \"Deltag nu\" for at blive omdirigeret direkte til Zoom-opkaldet.",
        "helpAndSupport": "Hjælp og support",
        "summerOfAI": "Summer of AI"
      }
    },
    "celebration": {
      "dismiss": "Afvis",
      "body": "Det er lige begyndt, lad os udforske, hvordan GHL kan hjælpe med at opbygge din virksomhed.\nI mellemtiden kan du fortsætte med at sende beskeder, så meget du vil",
      "title": "Wow! Samtalerne flyder nu"
    }
  },
  "cookies": {
    "thirdPartyWarning": {
      "helpArticle": "Hjælpeartikel her",
      "message": "Aktivér tredjepartscookies for at se denne side korrekt. Du kan henvise til vores",
      "ok": "OK",
      "title": "Tredjepartscookies virker ikke"
    }
  },
  "crash": {
    "message": "Vi beklager, der skete noget uventet. Prøv at opdatere siden.",
    "refresh": "Opdater side",
    "title": "Ups! Der opstod en fejl"
  },
  "deleteLocation": {
    "abortModal": {
      "abortingDeletion": "Annullerer sletning for {name}",
      "confirmAbort": "Ja, afbryd",
      "keepDeleting": "Nej, fortsæt med at slette",
      "message": "Er du sikker på, at du ønsker at afbryde?",
      "scheduledForDeletion": "Denne placering er planlagt til at blive slettet den {date}.",
      "title": "Annuller sletning",
      "warning": "Bemærk: Placeringen vil blive slettet på den planlagte dato, medmindre du afbryder sletningen."
    }
  },
  "fileUpload": {
    "dropzone": {
      "defaultMessage": "Slip filer her for at uploade",
      "uploadError": "Netværksfejl: Kunne ikke sende anmodning til AWS. (Måske CORS-fejl)"
    }
  },
  "funnel": {
    "acceptShare": {
      "add": "Tilføj {entityName}",
      "clonedMessage": "{entityName} klonet! Skift til en konto, hvor den blev klonet, og find den under fanen {entityName}.",
      "errorGettingDetails": "Der ser ud til at være en fejl under hentning af {entityName}-oplysninger. Kontrollér webadressen, eller prøv igen.",
      "permissionError": "Tilladelsesfejl: Dette er en beskyttet tragt og kan ikke oprettes her."
    }
  },
  "integrations": {
    "googleCalendar": {
      "logo": "GoogleKalender-logo"
    },
    "printful": {
      "logo": "Printful-logo",
      "title": "Printful: Udskriv efter behov"
    },
    "printify": {
      "logo": "Printify-logo",
      "title": "Printify: POD"
    },
    "shipStation": {
      "logo": "ShipStation-logo",
      "title": "Shipstation"
    },
    "shippo": {
      "logo": "Shippo-logo",
      "title": "Shippo: forsendelsesintegration"
    },
    "tikTok": {
      "accountNotConnected": "Kontoen er ikke forbundet",
      "accountNotConnectedMessage": "Din konto er ikke forbundet med din TikTok-annoncekonto. Fuldfør integration for at se formularer og kortlægge felter.",
      "advertiserId": "Annoncør-ID",
      "companyFields": "{companyName}-felter",
      "editFields": "Rediger felter",
      "errorSubscribing": "Fejl under tilmelding til siden.",
      "formsNotAvailable": "Formularer ikke tilgængelige",
      "mandatoryFieldsNote": "Bemærk: Udfyld et af følgende obligatoriske felter for at modtage kundeemner på din konto. Felter: Fornavn, Efternavn, E-mail, Telefonnummer",
      "noFormsMessage": "Du har i øjeblikket ikke oprettet nogen formular til kundeemnegenerering på din TikTok-annoncekonto. Besøg din TikTok annoncekonto og opret en for at komme i gang.",
      "pageId": "Side-ID",
      "selectAdvertiserAccount": "Vælg reklamekonto"
    }
  },
  "launchpad": {
    "duda": "Duda",
    "joomla": "Joomla",
    "otherOrIDontKnow": "Andet/jeg ved det ikke",
    "shopify": "Shopify",
    "squarespace": "SquareSpace",
    "weebly": "Weebly",
    "wordpress": "WordPress"
  },
  "location": {
    "suspend": {
      "instructionText": "Du skal udføre et par enkle trin for at sætte denne underkonto på pause."
    },
    "transfer": {
      "chooseDescription": "Vælg din overførselsmetode",
      "chooseMethod": "Upload denne underkonto",
      "eject": {
        "description": "Tjen 40 % tilbagevendende provision på den nye kontos abonnement.",
        "title": "Fjern som en ny konto"
      },
      "modal": {
        "confirmDetails": "Bekræft oplysningerne før overførslen",
        "confirmNomineePrefix": "Nominer ejer til",
        "confirmTransfer": "Bekræft overførsel",
        "consentText": "Jeg har læst og forstået ovenstående vejledning og godkender alle begrænsninger",
        "ejectErrorTitle": "Kan ikke fjerne underkontoen.",
        "ejectGenericError": "Den underkonto, du forsøger at slette, kan ikke slettes. Kontakt supporten.",
        "ejectGuidelines": "Retningslinjer for fjernelse af underkonto",
        "ejectSubject": "Fjernelse af underkonto er betinget af, at brugeren accepterer forespørgslen om at oprette et nyt agentur.",
        "ejectSuccessTitle": "Anmodning om at fjerne underkonto sendt til den valgte bruger",
        "enterPassword": "Indtast dit password for at bekræfte",
        "genericError": "Den underkonto, som du forsøger at overføre, kan ikke overføres. Kontakt supporten.",
        "guidelines": "Retningslinjer for overførsel af underkonto",
        "guidelinesConsent": "Læs og godkend",
        "hipaaDisclaimer": "Ansvarsfraskrivelse",
        "hipaaText": "Du kan give denne underkonto besked om, at de i øjeblikket får HIPAA-dækning, men muligvis ikke får den samme dækning under det agentur, de overføres til.",
        "noUsersDescription": "Der er ingen brugere tilknyttet denne underkonto. Tilføj en underkonto-bruger, og fortsæt.",
        "noUsersSearch": "Der blev ikke fundet nogen brugere.",
        "noUsersTitle": "Ingen brugere fundet",
        "nomineeInstructions": "Den nominerede vil modtage et link til tilmelding til HighLevel",
        "passwordError": "Ugyldig adgangskode",
        "passwordErrorDescription": "Den adgangskode, du har indtastet, er forkert. Prøv igen.",
        "relationshipError": "Indtast det korrekte relationsnummer",
        "relationshipNumber": "Modtageragenturets relationsnummer",
        "relationshipPlaceholder": "0-123-456",
        "requestTransfer": "Anmod om overførsel",
        "seeAllRequests": "Se alle forespørgsler",
        "successMessage": "Underkontoen vil blive overført, når det modtagende agentur accepterer din overførselsanmodning.",
        "successTitle": "En overførselsforespørgsel for en underkonto er blevet sendt til det modtagende agentur",
        "title": "Overfør underkonto",
        "transferSubject": "Overførslen af underkontoen kræver, at det modtagende agentur accepterer den i deres konto.",
        "confirmNomineeSuffix": " til "
      },
      "transferExisting": {
        "description": "Overfør hele denne underkonto til en anden konto.",
        "title": "Overfør til en eksisterende konto"
      }
    }
  },
  "marketing": {
    "bulkRequests": {
      "nextExecution": "Næste udførelse",
      "title": "Masseanmodninger"
    },
    "campaign": {
      "account": "Konto",
      "accountBuffer": "Kontobuffer",
      "accountBufferDescription": "Der er ingen grænse for antallet af modtagere, der tilføjes til denne kampagne hver dag (fra en liste).",
      "accounts": "Konti",
      "activity": "Aktivitet",
      "acquire": "Erhverve",
      "acquisitionDescription": "Kundeerhvervelseskampagner hjælper dig med at generere flere \"hotte\" salgskundeemner, der er klar til at engagere sig.",
      "addEvent": "Tilføj begivenhed",
      "addUser": "Tilføj bruger",
      "allMarket": "Alle markeder",
      "allowMultiple": "Tillad flere",
      "assignedToTooltip": "Da denne kampagne startede, blev denne kontakt tildelt denne bruger. Ændringer i kontaktens tildelte til vil afspejle sig i begivenhederne, men vil ikke ændre denne startværdi.",
      "atLeastOneEvent": "Der kræves mindst én begivenhed.",
      "automations": "Automatiseringer",
      "automationsPlaceholder": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quas quaerat pariatur consequatur rerum neque a, id, nam nostrum iure accusantium magnam nemo perferendis eveniet quos perspiciatis molestiae explicabo reprehenderit nesciunt recusandae, quod distinctio vero et quia omnis? Corporis omnis, ipsa in, quae iste libero minus, voluptatem perferendis molestiae consectetur nam odio eligendi enim consequuntur! Quis ratione iure modi eos quaerat facere molestiae. Quaerat voluptatibus distinctio sed nisi aliquam, laboriosam laudantium fugiat dolores. Corporis suscipit modi corrupti. Delectus assumenda perspiciatis asperiores porro ipsam quaerat nesciunt provident sit non distinctio veritatis tempora omnis fugit dicta minima nisi aliquam ducimus rem, nobis cum.",
      "bounced": "Afvist",
      "buffering": "Buffering",
      "campaignActivity": "Kampagneaktivitet",
      "campaignConfiguration": "Kampagnekonfiguration",
      "campaignConfigurationWarning": "Kampagnekonfiguration påvirker alle markeder. Sørg for at du skal foretage ændringer i disse indstillinger.",
      "campaignCreation": "Oprettelse af kampagne",
      "campaignId": "Kampagne-ID",
      "campaignStatusByRecipients": "Kampagnestatus efter modtagere",
      "clickThroughRate": "Klikfrekvens",
      "clickedThrough": "Klikket på",
      "conditionIfExplanation": "Kør denne kampagne eller begivenhed, hvis det aktuelle tidspunkt falder inden for dette vindue. Hvis det aktuelle tidspunkt er uden for dette vindue, kan du springe kampagnen eller begivenheden over og gå videre til den næste.",
      "conditionWhenExplanation": "Kør begivenhederne i denne kampagne, når det aktuelle tidspunkt falder i dette vindue, ellers vent til det næste vindue med at køre begivenhederne.",
      "createCampaign": " Opret kampagne",
      "ctr": "CTR",
      "customerAcquisition": "Kundeerhvervelse",
      "dateAdded": "Dato tilføjet",
      "dateAddedTooltip": "Den nøjagtige dato og det nøjagtige tidspunkt, hvor kontakten blev føjet til denne kampagne. Første starttidspunkt for begivenheden kan variere afhængigt af konfigurationerne.",
      "deletedRestorePrompt": "Denne kampagne er blevet slettet. Ønsker du at gendanne den?",
      "delivered": "Leveret",
      "deliveryRate": "Leveringsprocent",
      "draftMode": "Kladde-tilstand",
      "draftModeDescription": "Denne kampagne er en kladde. Den kan ikke bruges, før den er udgivet.",
      "dropped": "Droppet",
      "emailActivity": "E-mailaktivitet",
      "emailActivityFilterExample": "E-mailaktivitet: Klik på dem",
      "event": "Begivenhed",
      "eventFilterExample": "Begivenhed: 10X Email 4 (fordeling af annoncer)",
      "filters": "Filtre",
      "emailPerformanceByAccount": "E-mail-ydeevne efter konto",
      "emailsNotSentOnDays": "Der sendes ikke e-mails lørdag eller søndag.",
      "emailsSentOnDays": "E-mails vil blive sendt mandag, tirsdag, onsdag, torsdag og fredag.",
      "eventStartDate": "Begivenhedens startdato",
      "exampleAddress": "801 7th Avenue North, Saskatoon, SK",
      "exampleCompanyName": "By Perks Coffehouse",
      "exampleDate": "8. maj 2017 13:27",
      "exampleEmail": "dstumph{'@'}vendasta.com",
      "exampleEmailDescription": "Sørg for, at dataene ikke er ældre end 30 dage",
      "exampleEventName": "10X Email 4 (fordeling af annoncer)",
      "getMoreCustomers": "Få flere kunder",
      "inProgress": "Igangværende",
      "includedDays": "Inkluderede dage",
      "internalSource": "Intern kilde",
      "lastUpdate": "Sidste opdatering",
      "leadValuePlaceholder": "$ kundeemnets værdi",
      "loopDetected": "Denne kampagne er låst i kladdestatus, fordi den forårsager en løkke. Kontakt support for at aktivere denne kampagne.",
      "market": "Marked",
      "moreDetails": "Flere oplysninger",
      "myCampaigns": "Mine Kampagner",
      "na": "Ikke relevant",
      "newFolder": " Ny mappe",
      "nextCampaign": "Næste kampagne",
      "nextExecutionTime": "Næste udførelsestidspunkt",
      "opened": "Åbnet",
      "openRate": "Åbningsfrekvens",
      "option2": "Valgmulighed 2",
      "option3": "Valgmulighed 3",
      "pageNavigation": "Eksempel på sidenavigation",
      "processed": "Behandlet",
      "published": "Udgivet",
      "recipient": "Modtager",
      "recipients": "Modtagere",
      "sampleCampaign": "Eksempel på kampagne ",
      "scheduling": "Planlægger",
      "seeHotLeads": "Se gode kundeemner",
      "selectDateRange": "Vælg datointerval",
      "selectTimeZone": "Vælg tidszone",
      "separator": " / ",
      "showingCount": "Viser {current} af {total}",
      "spamReport": "Spamrapport",
      "startByAddingEvent": "Start med at tilføje en begivenhed til denne kampagne.",
      "stopOnResponse": "Stop ved svar",
      "stopped": "Sat på pause",
      "time": "Tidspunkt",
      "timeConditionNote": "Bemærk: Hvis det første trin i kampagner er indstillet til 'Straks', gælder tidsbetingelsen ikke for det første trin.",
      "timeZoneDescription": "Denne indstilling vil påvirke det tidspunkt, hvor dit indhold sendes.",
      "totalLeads": "Kundeemner i alt",
      "undeliverable": "Kan ikke leveres",
      "unsubscribe": "Afmeld",
      "upNext": "Op Næste",
      "utc": "UTC",
      "window": "Vindue"
    },
    "embed": {
      "copyLinkInstructions": "Kopiér linket nedenfor og del det nemt, hvor som helst du ønsker det.",
      "embed": "Indlejr",
      "iframeEmbed": "Iframe-indlejring",
      "integrateInstructions": "Brug følgende muligheder for at integrere din brugerdefinerede formular på dit website.",
      "integrateYourForm": "Integrer din formular",
      "link": "Forbind",
      "saveAndExit": "Gem og afslut"
    },
    "jotbox": {
      "deleteSubmission": "Slet indsendelse",
      "downloadPdf": "Download PDF",
      "ofSubmissions": " af {total} indsendelser",
      "pages": "sider",
      "records": "poster",
      "searchPlaceholder": "Søg på navn, e-mail, telefon og kontakt-ID",
      "selectYourForm": "Vælg din formular",
      "timeSigned": "Tidspunkt for underskrift:",
      "totals": "I alt:"
    },
    "survey": {
      "createNewSurvey": "Opret ny undersøgelse",
      "integrateYourSurvey": "Integrer din undersøgelse",
      "noSurveysForAnalyze": "Du har endnu ikke nogen undersøgelser. Opret først en undersøgelse for at se analysen her.",
      "noSurveysForSubmission": "Du har endnu ikke nogen undersøgelser. Opret først en undersøgelse for at se dine bidrag her.",
      "noSurveysYet": "Du har endnu ikke nogen undersøgelser.",
      "refreshData": "Opdater data",
      "searchSurveys": "Søg undersøgelser",
      "surveyBuilder": "Undersøgelsesskaber",
      "toCreateFirstSurvey": "for at oprette din første undersøgelse."
    }
  },
  "membership": {
    "acceptShare": {
      "clonedMessage": "Produkt klonet! Skift til en konto, hvor den blev klonet, og find den under fanen Medlemskab > Produkter.",
      "errorGettingDetails": "Der ser ud til at være en fejl under hentning af produktoplysninger. Kontrollér webadressen, eller prøv igen."
    },
    "resetPassword": {
      "title": "Nulstil adgangskode",
      "button": "Nulstil adgangskode",
      "newPassword": "Ny adgangskode",
      "generateStrongPassword": "Generér en stærk adgangskode",
      "sendEmailNotification": "Send også en e-mailbesked.",
      "errorMessage": "Der opstod en fejl under nulstilling af adgangskoden. Prøv igen.",
      "updating": "Opdaterer ..."
    }
  },
  "notifications": {
    "psBubble": {
      "byText": "⚡ af",
      "combo": {
        "signedUp": "tilmeldte sig ProveSource inden for de sidste 24 timer",
        "verifiedBy": "verificeret af "
      },
      "conversions": {
        "recentlyBought": "købte for nylig disse",
        "timeAgo": "i de sidste 16 minutter ",
        "visitorsCount": "50 besøgende"
      },
      "pageVisits": {
        "description": "De ser også ud til at være sultne.",
        "timeAgo": "i de sidste 21 minutter                        ",
        "title": "50 foodies"
      },
      "proveSource": "ProveSource",
      "review": {
        "proofMessage": " ProofMessage",
        "rating": "5-stjernet bedømmelse",
        "recently": "Senest",
        "reviewerName": "Varun Vairavan",
        "starIcon": "⚡"
      },
      "stream": {
        "action": "tilmeldte sig ProveSource",
        "location": "(London, Storbritannien)",
        "name": "Mike ",
        "timeAgo": "For 40 minutter siden                        "
      },
      "visitors": {
        "description": "musikelskere online"
      }
    },
    "step1": {
      "combo": {
        "description": "Vis det samlede antal personer, der har udført en specifik handling i løbet af 24 timer, 7 eller 30 dage.",
        "title": "Kombination"
      },
      "conversions": {
        "description": "Skab social validering ved at vise, hvor mange kunder der foretog en specifik handling."
      },
      "liveReviews": {
        "description": "Vis dine besøgende 4+-stjernede anmeldelser i realtid fra de sidste 6 måneder."
      },
      "liveVisitors": {
        "beta": "Beta",
        "description": "Vis i realtid, hvor mange besøgende der i øjeblikket ser hele dit website."
      },
      "pageVisits": {
        "description": "Vis dine besøgende, at de ikke er de eneste til festen, ved at fremhæve de seneste sidebesøg."
      },
      "stream": {
        "description": "Hvad er bedre end at sætte et ansigt på det sociale bevis? Vis dine seneste kunder og deres handlinger."
      }
    },
    "step2": {
      "captureDescription2": "Hver side-URL skal have et e-mailformularfelt",
      "captureDescription3": " og ProveSource er installeret. ",
      "comboType": "Kombinationstype",
      "connectAccounts": "Sørg for at forbinde de konti, du vil hente anmeldelser fra",
      "connectGoogleAccount": "Forbind din placerings Google-konto",
      "formSubmissions": "Indsendelser af formularer",
      "googleAccount": "Google-konto",
      "howToTrack": "Sådan sporer man",
      "howToTrackDescription": "Hvordan skal vi spore dine konverteringer?",
      "pageUrl": "Side-URL",
      "productPurchase": "Produktkøb",
      "trackAllUrls": "Spor alle side-URL'er, der indeholder følgende udtryk. ",
      "trackVisitors": "Spor besøgende",
      "trackVisits": "Spor besøg",
      "urlTip": " Vi behandler http://, https://, www og ikke-www som separate versioner af URL'en og siden. ",
      "urlValidationError": "Du skal Inkludere mindst én URL. URL'en er ugyldig. Sørg for at tilføje http:// eller https://",
      "userSignup": "Brugertilmelding",
      "visits": " Besøg",
      "webhookDescription": "Ring til følgende slutpunkt for at give os besked om en hændelse eller konvertering, der er sket på din side, og som er relateret til denne notifikation. Vi klarer resten.",
      "webhookRequest": "Webhook-forespørgsler",
      "whatToTrack": "Hvad vil du gerne spore?",
      "whereToCapture": "Hvor skal man indsamle",
      "whereToCaptureDescription": "Hvor registrerer man konverteringer?",
      "whichPagesToTrack": "Hvilke sider ønsker du, at vi skal spore?",
      "yourWebhookUrl": "Din webhook-URL"
    },
    "step3": {
      "allPages": " Alle sider",
      "displayOnAllPages": "Vis på alle side-URL'er, der indeholder følgende udtryk: ",
      "whereToDisplay": "Hvor skal det vises",
      "whereToDisplayActivity": "Hvor vil du gerne have, at vi viser denne aktivitet?"
    },
    "step4": {
      "icons8": "Icons8.com",
      "icons8Instructions": "for flotte ikoner (højreklik på et ikon -> Kopiér billedadresse)",
      "messageSettings": "Beskedindstillinger",
      "messageText": "Beskedtekst",
      "referToVisitorsAs": "Henvis til besøgende som",
      "visitIcons8": "Besøg"
    },
    "step5": {
      "allowUsersToClose": " Tillad brugerne at lukke notifikationen ",
      "behavior": "Adfærd",
      "bottomLeft": "Nederst til venstre",
      "bottomRight": "Nederst til højre",
      "clickableNotification": " Klikbar notifikation ",
      "customizeDescription": "Skift følgende indstillinger for at styre din notifikations funktionalitet og udseende",
      "design": "Styling",
      "displayNotificationFor": "Vis notifikation for",
      "displayRules": "Viser regler",
      "hideOnMobileScreens": " Skjul på mobilskærme ",
      "linkRelativeNote": " Hvis http:// udelades, åbnes linket i forhold til den viste side ",
      "minimumEventsToDisplay": "Min. tilfælde at vise",
      "notificationLink": "Link til notifikation",
      "notificationPosition": "Meddelelsesposition",
      "openLinkInNewTab": "Åbn link i ny fane",
      "selectPosition": "Vælg position",
      "showOnlyOncePerSession": " Vis kun én gang pr. session ",
      "titleBackground": "Titelbaggrund",
      "titleColor": "Titelfarve",
      "topLeft": "Øverst til venstre",
      "topRight": "Øverst til højre",
      "typeUrlHere": "Skriv URL her"
    },
    "step6": {
      "identifyNotification": "Identificer din notifikation",
      "launchMessage": "Vi er ved at lancere. Tag plads, og spænd sikkerhedsselen.",
      "notificationName": "Navn på notifikation",
      "notificationNamePrompt": "Hvad er navnet på din notifikation?",
      "wellDone": "Godt gået."
    },
    "wordpress": {
      "subscriptionCreatedSuccessfully": "Abonnement oprettet",
      "youCanNowSetupWordPress": "Du kan nu opsætte dit WordPress-website",
      "subscriptionFailed": "Abonnement mislykkedes",
      "resubscriptionSuccessful": "Genabonnement gennemført",
      "successfullyReactivated": "Dit WordPress-abonnement er blevet genaktiveret",
      "reactiveSub": "Kan ikke genaktivere abonnement",
      "resubscriptionFailed": "Genabonnement mislykkedes"
    },
    "v2": {
      "viewDetails": "Vis oplysninger",
      "chatConversationAssigned": "Chatsamtale tildelt",
      "internalChat": "Intern chat",
      "newTask": "Ny opgave",
      "appointmentReminder": "Aftalepåmindelse",
      "facebookReview": "Facebook-anmeldelse",
      "googleReview": "Google-anmeldelse",
      "internalChatMessage": "Intern chatbesked",
      "newAppointmentAssigned": "Ny aftale tildelt",
      "newAppointmentBooked": "Ny aftale booket",
      "newCall": "Nyt opkald",
      "newEmail": "Ny e-mail",
      "newMention": "Ny omtale",
      "newReviewReceived": "Ny anmeldelse modtaget fra {contactName}",
      "taskReminder": "Påmindelse om opgave",
      "completed": "fuldført",
      "failed": "mislykkedes",
      "subAccount": "Underkonto",
      "newMessage": "Ny besked",
      "newAppointmentBookedWith": "Ny aftale er blevet booket med {contactName}",
      "newAppointmentAssignedTo": "Ny aftale tildelt til {contactName}",
      "appointmentDueIn": "Aftale forfalder om {minutes} minutter med {contactName}",
      "newTypeReceived": "Nyt {type} er modtaget fra {contactName}",
      "newChatAssigned": "Ny chat er blevet tildelt fra {contactName}",
      "taskDueDate": "Opgave '{title}' forfalder den {date} kl. {time} for {contactName}",
      "tasksDueToday": "{count} opgaver, der forfalder i dag",
      "tasksOverdue": "{count} opgaver forfaldne",
      "taskDueIn": "Opgave '{title}' forfalder om {dueTime} {unitOfTime} for {contactName}",
      "mentionedInConversation": "{userName} nævnte dig i en samtale med {contactName}",
      "now": "nu"
    }
  },
  "onboarding": {
    "landscapeMode": {
      "altTexts": {
        "logo": "Virksomhedslogo"
      },
      "bestExperience": "den bedste oplevelse.",
      "optimizedFor": "Denne side er optimeret til",
      "portraitMode": "portrættilstand",
      "toGiveYou": "for at give dig"
    }
  },
  "pagination": {
    "goToFirstPage": "Gå til første side",
    "goToLastPage": "Gå til den sidste side",
    "goToNextPage": "Gå til næste side",
    "goToPreviousPage": "Gå til forrige side",
    "itemsSelected": "{count} elementer valgt",
    "showingEntries": "Viser {from} til {to} af {total} poster"
  },
  "pmd": {
    "0": "0",
    "10": "10",
    "_min": "/min",
    "_please_add_a_payment_method_for": "Tilføj en betalingsmetode til",
    "_segment": "/segment",
    "ad_manager": "Annonceadministrator",
    "add": "[TILFØJ:",
    "ai_employee": "AI-medarbejder",
    "billing": {
      "incompleteBillingInfo": "Du har ufuldstændige faktureringsoplysninger på denne konto. Opdater dem med det samme.",
      "updateNow": "Opdater nu"
    },
    "charge": "Opkræv",
    "contactLimit": {
      "message": "Du har nået grænsen for dit nuværende abonnement for at tilføje {contact}. For at fortsætte skal du opgradere dit abonnement og frigøre yderligere kapacitet.",
      "upgradeNow": "Opgrader nu",
      "warningMessage": "Du har {current} kontakt(er), mens dit abonnement kun tillader op til {limit}.",
      "warningTitle": "Kontoforbruget er overskredet. Opgrader for at fortsætte arbejdet uden afbrydelser."
    },
    "cost_borne_by_you": "omkostninger, du bærer",
    "dedicated_ip": "Dedikeret IP",
    "electeditem": "valgt element",
    "feedback": "Feedback:",
    "hello": "Hej",
    "helpDrawer": {
      "aiSupportAssistant": "AI-supportassistent",
      "clickToCopy": "Klik for at kopiere relationsnummeret",
      "clickToCopyToClipboard": "Klik for at kopiere relationsnummer til udklipsholderen",
      "companyRelationshipNumber": "Virksomhedens relationsnummer",
      "hiImHighly": "Hej, jeg hedder Highly!",
      "implementation": "Implementering",
      "joinImplementationVideo": "Deltag i implementeringen af videoopkald",
      "joinTrialZoom": "Deltag i prøveopkaldet på Zoom",
      "kickoff": "start",
      "needHelpChatVideo": "Har du brug for hjælp? Start en chat eller et videoopkald med os nu!",
      "openAIAssistant": "Åbn AI-supportassistent",
      "premium": "Premium",
      "priority": "Prioritet",
      "raiseSupportTicket": "Opret en supportsag",
      "raiseTicket": "Åbn billet",
      "relationshipNumber": "Relationsnummer",
      "startAISupportChat": "Start AI-supportchat",
      "startAgentChatWait": "Start agentchat med 2-5 minutters ventetid",
      "startChatChoose": "Start chat – vælg mellem AI-support eller agentchat",
      "startImplementationVideo": "Start implementeringen af videoopkald",
      "startZoom": "Start Zoom",
      "startZoomCall": "Start Zoom-opkald",
      "subtitle": "Uanset om du ønsker at tale med os, fællesskabet eller lære på egen hånd, er vi her for dig!",
      "title": "Hjælp og support",
      "trialExperience": "Prøveoplevelse",
      "useButtonsBelow": "Brug en af knapperne nedenfor for at få hjælp.",
      "videoCallReward": "Deltag i et videoopkald for at oprette din konto – og få {amount} krediteret til din tegnebog, når du deltager.",
      "videoCallType": "Start et videoopkald med mig under dit {type}-opkald.",
      "yourPremiumSupportSpecialist": "Din {type}-supportspecialist",
      "yourSpecialist": "Din {type}-specialist",
      "yourSupportSpecialist": "Din supportspecialist",
      "videoCall": "Videoopkald",
      "active": "Aktiv",
      "announcementsAria": "Meddelelser - klik for at åbne i en ny fane",
      "chat": "Chat",
      "accessWelcomeCourseAria": "Klik for at få adgang til HighLevel-velkomstkurset",
      "clickToUpgrade": "Klik for at opgradere",
      "connectCertifiedAdminAria": "Forbind med en certificeret administrator - klik for at åbne i ny fane",
      "connectWithUsAria": "Forbind med os - start livechat",
      "contactUsAria": "Kontakt os - ring til HighLevel på +1(888)732-4197",
      "copied": "Kopieret",
      "highlevelEventsAria": "Highlevel Events - klik for at åbne i en ny fane",
      "joinFacebookGroupAria": "Bliv medlem af vores Facebook-gruppe – klik for at åbne i en ny fane",
      "onboardingVideoTutorialsAria": "Onboarding-videovejledninger - klik for at åbne i en ny fane.",
      "recommended": "Anbefales",
      "visitHelpCenterAria": "Besøg vores Hjælpecenter - klik for at åbne i en ny fane",
      "contactUs": "Kontakte os",
      "agentChatWaitTime": "Chat med agent (~ 2-5 min. ventetid)",
      "aiSupportChat": "AI-supportchat",
      "startChat": "Start chat",
      "announcements": "Meddelelser",
      "fastestGrowingCommunity": "Bliv en del af det hurtigst voksende fællesskab.",
      "callHighlevelPhone": "Ring til HighLevel på +1(888)732-4197",
      "connectCertifiedAdmin": "Forbind med en certificeret administrator",
      "connectTeamVideoCall": "Kontakt vores team for at få hjælp via et live videoopkald!",
      "connectWithUs": "Kontakt os",
      "dailyBrainstormingSessions": "Daglige brainstorming-sessioner med HighLevel",
      "certifiedAdminDescription": "Udforsk HighLevel-eksperter, der kan hjælpe med at opsætte dit system, automatisere arbejdsgange eller tilpasse dit projekt.",
      "getAccessWelcomeCourse": "Få adgang til HighLevel velkomstkurset",
      "premiumSupportDescription": "Få prioriteret fejlfinding, ekspertvejledning og direkte adgang til vores tekniske team via Slack.",
      "highlevelEvents": "Highlevel-events",
      "joinFacebookGroup": "Bliv medlem af vores Facebook-gruppe",
      "onboardingVideoTutorials": "Videovejledning til onboarding",
      "premiumSupport": "Premium-support",
      "setupAccountFreeTutorials": "Opsæt din konto med gratis vejledninger",
      "viewSupportTicketsArticles": "Se dine supportsager, vores supportartikler og nyttige ofte stillede spørgsmål!",
      "visitHelpCenter": "Besøg vores Hjælpecenter",
      "welcomeCourse": "Velkomstkursus",
      "beta": "Beta",
      "closeHelpSupportDrawer": "Luk Hjælp og support-skuffen",
      "upgradePlanToEnable": "Du skal opgradere din plan for at aktivere denne funktion",
      "premiumSupportActive": "Din premium-support er aktiv",
      "premiumSupportClickUpgrade": "Premium-support – klik for at opgradere dit abonnement",
      "premiumSupportActiveAria": "Premium-upport –din premium-support er aktiv",
      "keepUpToDateNews": "Hold dig opdateret med alle de seneste nyheder og udgivelser!"
    },
    "hi": "Hej",
    "is_scheduled_for_deletion_on": "er planlagt til at blive slettet den",
    "k": "K",
    "limit_updated_from": "Grænse opdateret fra",
    "minimum_must_be": "Min. skal være",
    "more_emails_in_thread": "flere e-mails i tråd",
    "multipleUsers": {
      "chooseAccount": "Vælg en konto for at fortsætte"
    },
    "must_be_in_range_of_0": "Skal være inden for området 0 og .",
    "numbers_and": "antal og",
    "premiumSupport": {
      "assigningManager": "Tildeler teknisk kontoadministrator ...",
      "bookCall": "Book et opkald",
      "hiIm": "Hej, jeg hedder {name}",
      "joinZoomNow": "Deltag i Zoom-opkald nu",
      "quickActions": "Hurtige supporthandlinger",
      "quickLinks": "Hurtige links",
      "raiseFeatureRequest": "Hæv funktionsanmodning",
      "slackChannelCreating": "Hold ud – din Premium Slack-kanal er i fuld gang! 🚀",
      "technicalAccountManager": "Teknisk kundechef",
      "viewRoadmap": "Vis produktkøreplanen"
    },
    "prospecting": "Prospektering",
    "reloadPopup": {
      "message": "Vi har bemærket, at du ikke har opdateret siden i et stykke tid. Opdatere igen for at få den bedste oplevelse fra appen.",
      "refreshNow": "Opdater nu"
    },
    "resell_settings": "Indstillinger for videresalg",
    "row": "række",
    "select_upto": "Vælg op til",
    "seo": "SEO",
    "supportCalendar": {
      "description": "Få dedikeret support på et tidspunkt, der passer dig.",
      "title": "Planlæg et opkald med support på højt niveau"
    },
    "these_are_margins_that_are_billed_to_your_clients_": "Det er marginer, der faktureres til dine kunder i forhold til de",
    "twilioSetup": {
      "autoSetup": {
        "benefit1": "Lad os administrere Twilio for dig uden problemer",
        "benefit2": "Vores supportteam tager sig af dine Twilio-problemer",
        "button": "Gør det for mig",
        "drawback": "Betal {price} ekstra på VAS sammenlignet med at gøre det selv",
        "title": "Vi gør det for dig"
      },
      "lowCreditsMessage": "Du skal oprette forbindelse til en Twilio-konto for at administrere opkald og sms'er, der sendes/modtages på HighLevel.",
      "lowCreditsTitle": "Du er ved at løbe tør for gratis Twilio-kreditter, men vi hjælper dig!",
      "selfSetup": {
        "benefit1": "Administrer dine udgifter",
        "benefit2": "Få mere kontrol over din Twilio-tjeneste",
        "button": "Jeg vil administrere",
        "drawback1": "Ansæt en person til at administrere Twilio-tjenesten",
        "drawback2": "Kontakt Twilio-support, når noget ikke fungerer.",
        "title": "Gør det selv"
      },
      "wip": {
        "button": "Opsæt Twilio nu",
        "fallback": "Indtil videre skal du administrere din egen Twilio-konto.",
        "message": "Tak fordi du valgte os, men vi arbejder stadig på at udvikle denne funktion. Du hører fra os, så snart vi kan implementere dette på din konto.",
        "title": "Vi arbejder stadig på det!"
      }
    },
    "uiComponents": {
      "loadingMoreOptions": "Indlæser flere valgmuligheder ...",
      "noElementsFound": "Ups! Der blev ikke fundet nogen komponenter. Overvej at ændre søgeforespørgslen.",
      "noLocationsFound": "Der blev ikke fundet nogen placeringer. Prøv et andet søgeord.",
      "typeToSearch": "Skriv for at søge",
      "enterUserEmail": "Indtast brugerens e-mailadresse"
    },
    "updating": "Opdaterer",
    "usd": "USD",
    "useTemplate": {
      "useTemplate": "Brug skabelon"
    },
    "validEmail": {
      "andYouCan": "Og du kan",
      "as": "som",
      "canReverify": "Du kan bekræfte din e-mail igen",
      "emailIs": "Denne e-mail er",
      "emailMarkedAs": "Denne e-mail er markeret som",
      "markedAsInvalid": "Denne e-mail er markeret som",
      "notVerified": "Ikke verificeret",
      "reverifyHere": "Bekræft igen her",
      "verifyHere": "Bekræft her"
    },
    "will_give_you_about": "vil give dig omkring",
    "checkout": {
      "confirm": "Bekræft",
      "cardInformation": "Kortoplysninger",
      "cardNumberInvalid": "Dit kortnummer er ugyldigt.",
      "commitment": "forpligtelse",
      "paymentConsent": "Ved at bekræfte giver du LeadConnector tilladelse til at debitere dit kort for denne betaling.",
      "subscriptionConsent": "Ved at bekræfte dit abonnement giver du LeadConnector tilladelse til at debitere dit kort for denne betaling og fremtidige betalinger for dette abonnement",
      "endingIn": "slutter på",
      "month": "Måned",
      "pay": "Betal",
      "payWithCard": "betal med kort",
      "paymentBeingProcessed": "Betalingen er under behandling. Undlad at genindlæse eller trykke på tilbage-knappen",
      "proceedWithExistingCard": "Fortsæt med det eksisterende kort",
      "proceedWithNewCard": "Fortsæt med et nyt kort",
      "purchase": "køb",
      "subscribe": "Abonner",
      "subscribeTo": "Abonner på",
      "pleaseUpdateCardDetails": "Opdater kortoplysningerne",
      "zip": "postnummer",
      "retry": "prøv igen",
      "initialChargesProrated": "De indledende gebyrer er forholdsmæssigt fordelt, og den normale fakturering starter fra",
      "youWillBeChargedFor": "Du vil blive opkrævet for",
      "days": "dage",
      "rightNowForPeriodTill": "lige nu for perioden indtil",
      "startGettingChargedFullAmount": "og begynde at blive opkrævet det fulde beløb",
      "perMonthStartingFrom": "/måned startende fra",
      "nameOnCard": "Navn på kortet",
      "somethingWentWrong": "Der opstod en fejl",
      "errorImg": "fejl img-logo",
      "networkError": "Netværksfejl, prøv igen efter et stykke tid.",
      "paymentCouldNotBeProcessed": "Betalingen kunne ikke behandles. Prøv at tilføje et kort igen."
    },
    "deleteLocation": {
      "back": "Tilbage",
      "delete": "Slet",
      "completeStepsToDelete": "Du skal udføre et par enkle trin for at slette denne adresse",
      "alsoCloseAssociated": "Også tæt forbundet",
      "scheduling": "Planlægger ...",
      "subAccountAndDeletePhoneNumbers": "underkonto og slet alle telefonnumre",
      "somethingWentWrongTryAgain": "Noget gik galt ... Prøv igen senere",
      "deleteSubAccount": "Slet underkonto",
      "scheduleForDeletion": "Planlagt til sletning"
    },
    "productRebilling": {
      "enableRebilling": "Aktivér genfakturering",
      "ratesMayDifferUK": "Priserne kan variere afhængigt af region. De viste beregninger er i henhold til priserne for UK,",
      "examplePricingGpt4oMini": "Eksempel på prissætning - GPT-4o Mini",
      "input": "Input",
      "output": "Output",
      "supportDoc": "supportdokument",
      "unsavedChanges": "Ændringer, der ikke er gemt",
      "to": "til",
      "chargedToCustomerLower": "Opkrævet fra kunden",
      "model": "Model",
      "profit": "Fortjeneste",
      "saving": "Gemmer ...",
      "type": "Type",
      "updating": "Opdaterer ...",
      "clickHere": "Klik her",
      "chargedToCustomer": "Opkrævet fra kunden",
      "enabling": "Aktiverer ...",
      "forMoreDetails": "for at få flere oplysninger.",
      "tenDollarsWillGive": "10 USD vil give dig ca.",
      "yourCost": "Dine omkostninger",
      "seeHow": "Se hvordan",
      "clientCompanyBillingPage": "klientens virksomheds faktureringsside",
      "connectStripeToEnable": "For at slå genfakturering til skal du forbinde din stripe på",
      "companyStripeIntegrationPage": "virksomhedens Stripes integrationsside",
      "enterClientCardInfo": "For at aktivere genfakturering skal du indtaste din klients kortoplysninger på",
      "gpt4oMini": "GPT-4o-mini",
      "for750kWords": "(for 750.000 ord)",
      "words": "ord",
      "yourCostLower": "Dine omkostninger",
      "and": "og",
      "or": "eller",
      "minimumMustBeBetween": "Minimum skal være mellem",
      "upgradeToAgencyPro": "Opgrader til Agency Pro",
      "planToSetMargins": "Planlæg at fastsætte avancer"
    },
    "m": "m",
    "label": "Etiket",
    "company_email_": "Virksomhedens e-mail (",
    "me_": "Me (",
    "automation_type": "Automatiseringstype",
    "calendar_groups": "Kalendergrupper",
    "length_": ".length }}"
  },
  "products": {
    "noProducts": "Ingen produkter er tilgængelige",
    "selectProduct": "Vælg et produkt"
  },
  "reselling": {
    "common": {
      "additionalMessagesInfo": ". Yderligere {product} beskeder vil ikke blive opkrævet for placeringerne. Du skal aktivere SaaS-tilstand og genfakturering for at genfakturere kunden.",
      "agreementPrefix": "Jeg accepterer at aktivere",
      "agreementSuffix": "for denne kunde uden videresalg, og jeg accepterer, at jeg vil blive opkrævet",
      "buildResellerOffer": "Skab dit videresalgstilbud",
      "deployDirectlyDescription": "Brug denne mulighed, hvis du tilbyder {product} som en del af dit tilbud, eller hvis du vil fakturere din kunde eksternt",
      "deployPrefix": "Anvend",
      "directlySuffix": "Direkte",
      "learnMore": "Få mere at vide.",
      "offerPrefix": "Tilbud",
      "resellPrefix": "Videresælg",
      "resellingPrefix": "Videresælger",
      "subscriptionRestriction": "Kan ikke ændre konfigurationen, da placeringen allerede er abonneret",
      "zero": "0",
      "highlevelPrice": "HighLevel-pris",
      "howDoesItWork": "Hvordan fungerer det?",
      "payNowButton": "Betal nu",
      "priceValidationError": "Prisen skal være højere end eller lig med HighLevel-prisen",
      "saving": "Gemmer",
      "yourPrice": "Din pris",
      "yourProfit": "Dit overskud"
    },
    "whatsapp": {
      "inboundMessagesInfo": "Det er gratis at modtage indgående beskeder og besvare dem ved hjælp af en fri tekst i samtalevinduet. Der vil være yderligere gebyrer for videresendelse af udgående skabelonbeskeder, hvis de sendes.",
      "whatsappLocation": "WhatsApp-placering"
    },
    "agencyResellingPage": {
      "seo": {
        "subscriptionRestriction": "Kan ikke ændre konfigurationen, da placeringen allerede er abonneret",
        "offerPrefix": "Tilbud ",
        "poweredByPrefix": " (Leveret af Search Atlas)",
        "toggleTooltipDisable": "Denne handling vil deaktivere SEO-værktøjet for alle underkonti.",
        "toggleTooltipEnable": "Denne handling vil aktivere SEO-værktøjet for alle underkonti.",
        "resellPrefix": "Videresælg ",
        "howDoesItWork": "Hvordan fungerer det?",
        "buildResellerOffer": "Skab dit videresalgstilbud",
        "yourPrice": "Din pris",
        "highlevelPrice": "HighLevel-pris",
        "yourProfit": "Dit overskud",
        "priceValidationError": "Prisen skal være højere end eller lig med HighLevel-prisen",
        "saving": "Gemmer",
        "save": "Gem",
        "deployPrefix": "Anvend ",
        "directlySuffix": "Direkte",
        "deployDirectlyDescription": "Brug denne mulighed, hvis du tilbyder SEO som en del af dit tilbud, eller hvis du vil fakturere din kunde eksternt.",
        "agreementPrefix": "Jeg accepterer at aktivere ",
        "agreementSuffix": " for denne kunde uden videresalg, og jeg accepterer, at jeg vil blive opkrævet",
        "payNowButton": "Betal nu",
        "subscriptionCreating": "Abonnementet er ved at blive oprettet.<br/>Undlad at genindlæse eller trykke på tilbage-knappen",
        "subscriptionCreated": "Abonnementet er blevet oprettet. Vent ...",
        "subscriptionError": "Kan ikke oprette abonnement. Kontakt support."
      },
      "adManager": {
        "subscriptionRestriction": "Kan ikke ændre konfigurationen, da placeringen allerede er abonneret",
        "offerPrefix": "Tilbud ",
        "resellingPrefix": "Videresalg",
        "resellPrefix": "Videresælg ",
        "howDoesItWork": "Hvordan fungerer det?",
        "bookACall": "Book et opkald",
        "bookCallTooltip": "Book et opkald med vores team for at lære mere om Ad Manager",
        "buildResellerOffer": "Skab dit videresalgstilbud",
        "yourPrice": "Din pris",
        "highlevelPrice": "HighLevel-pris",
        "yourProfit": "Dit overskud",
        "priceValidationError": "Prisen skal være højere end eller lig med HighLevel-prisen",
        "loading": "Indlæser ...",
        "save": "Gem",
        "deployPrefix": "Anvend ",
        "directlySuffix": "Direkte",
        "deployDirectlyDescription": "Brug denne mulighed, hvis du tilbyder funktionen annonceadministrator som en del af dit tilbud, eller hvis du vil fakturere din kunde eksternt.",
        "agreementPrefix": "Jeg accepterer at aktivere ",
        "agreementMiddle": " for denne kunde uden videresalg, og jeg accepterer, at jeg vil blive opkrævet",
        "agreementSuffix": " pr. måned",
        "stripeNotConnectedLocationWarning": "Stripe er ikke tilsluttet for denne placering. Forbind Stripe for at aktivere denne funktion.",
        "stripeNotConnectedAgencyWarning": "Stripe er ikke tilsluttet dette agentur. Forbind Stripe for at aktivere denne funktion.",
        "underSubAccountReselling": "pr. måned under videresalg af underkonto"
      },
      "dedicatedIp": {
        "description": "Dette giver dig mulighed for at genfakturere dedikeret IP (anvendes til forsendelse af udgående e-mails) til dine kunder og indbefatte et pristillæg.",
        "numberOfIps": "Antal IP'er:",
        "yourCost": "Din omkostning:",
        "chargedToCustomer": "Opkrævet fra kunden:",
        "profit": "Overskud:",
        "monthlyProfit": "Månedligt overskud:",
        "loading": "Indlæser ...",
        "save": "Gem",
        "revokeDedication": "Tilbagekald dedikation",
        "revokeDescription": "Brug denne mulighed til at holde op med at tilbyde nye IP'er til din kunde uden omkostninger.",
        "existingSubscriptionsNote": "Aktuelle IP-abonnementer vil ikke blive påvirket.",
        "revoke": "Tilbagekald",
        "provideDirectlyTitle": "Tilbyd en dedikeret IP til e-mail direkte",
        "provideDirectlyDescription": "Brug denne mulighed til at tilbyde din kunde en dedikeret IP uden omkostninger.",
        "agreeToProvideText": "Jeg bekræfter, at jeg vil levere IP til denne kunde uden mersalg.",
        "acknowledgeChargeText": "Jeg er bekendt med, at jeg vil blive opkrævet 59 USD/måned/IP.",
        "agree": "Ja",
        "yourMonthlyCost": "Din månedlig IP-pris:",
        "monthlyChargeToCustomer": "Kundens månedlige pris:",
        "resellingSettingsSuffix": " Indstillinger for videresalg",
        "ipRebillingAmount": "IP-genfaktureringsbeløb"
      }
    }
  },
  "saas": {
    "disable": {
      "complianceModal": {
        "clientApproval": "Jeg bekræfter, at jeg har drøftet dette med min kunde, og at kunden har godkendt dette.",
        "confirmQuestion": "Er du sikker på, at du vil deaktivere SaaS-tilstanden for denne konto?",
        "dataLossAck": "Jeg anerkender, at alle genfaktureringsdata, SaaS-abonnementsdata og transaktionsoversigter vil gå tabt.",
        "disableSaas": "Deaktiver SaaS",
        "irreversibleAck": "Jeg forstår, at denne handling er irreversibel."
      },
      "confirmationModal": {
        "cancelSubscription": "Annuller også det tilknyttede SaaS-abonnement",
        "confirmDisable": "Bekræft deaktivering",
        "confirmQuestion": "Er du sikker på, at du vil deaktivere SaaS-tilstanden?",
        "somethingWentWrong": "Noget gik galt ... Prøv igen senere"
      },
      "processingModal": {
        "closeNow": "Luk nu",
        "closeWindowInstructions": "Du kan lukke dette vindue. Vi informerer dig via e-mail, når processen er blevet fuldført.",
        "title": "SaaS vil snart blive deaktiveret for denne placering.",
        "typicalTime": "Dette tager typisk 10 minutter eller derunder."
      }
    }
  },
  "settings": {
    "customFields": {
      "addCustomField": "Tilføj brugerdefineret felt",
      "fieldKey": "Feltnøgle",
      "fieldName": "Feltnavn",
      "idWillBeAdded": "ID vil blive tilføjet, når årsagen til frafald er blevet oprettet",
      "lostReasonID": "ID for årsag til frafald",
      "placeholder": "Pladsholder"
    },
    "locationMailGun": {
      "bccAddress": "BCC-adresse",
      "clearError": "Ryd fejl",
      "deleteConfirmationMessage": "Denne handling medfører fjernelse af Mailgun-forbindelsen.",
      "deleteConnection": "Slet forbindelse",
      "domain": "Domæne",
      "domainsAvailable": "{count} tilgængelig",
      "invalidApiKey": "Ugyldig API-nøgle",
      "selectDomain": "Vælg domæne"
    },
    "locationWallet": {
      "fetchTransactionDetailsError": "Fejl ved hentning af transaktionsoplysninger",
      "transactions": "Transaktioner"
    },
    "noShowSMS": {
      "smsWithImage": "SMS uden fremmøde med billede",
      "title": "Tilpas anmeldelses-SMS"
    },
    "optOut": {
      "addKeywords": "Inkluder et af følgende fravalgsnøgleord: STOP, STOPALL, UNSUBSCRIBE, CANCEL, END eller QUIT.",
      "customizeTitle": "Tilpas fravalgsmeddelelse",
      "disableConfirm": "Er du sikker på, at du vil deaktivere fravalgsbeskeden?",
      "disableOptOut": "Deaktiver fravalgsmulighed",
      "disableTitle": "Deaktiver fravalgsbesked?",
      "optInConfirmClient": "Jeg bekræfter, at jeg vil sikre, at der kun sendes en SMS til de kontakter, der har givet samtykke.",
      "quickTipMessage": "Den første besked, du sender til en person, skal indeholde et af følgende standardnøgleord til framelding: STOP, STOPALL, UNSUBSCRIBE, CANCEL, END eller QUIT.",
      "reallyDisableConfirm": "Er du virkelig sikker på, at du vil deaktivere fravalgsbeskeden?"
    },
    "payments": {
      "logViewer": {
        "requestPostBody": "Forespørgsel om POST-indhold",
        "requestQueryParameters": "Forespørgselsparametre",
        "responseBody": "Svarindhold"
      },
      "logs": "Logfiler",
      "logsPage": {
        "clearAll": "Fjern alt",
        "loadMore": "Indlæs mere",
        "price": "Pris",
        "product": "Produkt",
        "tabsAriaLabel": "Faner til betalingslogfiler"
      }
    },
    "senderInfo": {
      "addGeneralTextAt": "Tilføj generel tekst ved",
      "beginning": "Begyndelse",
      "complianceConfirm": "Jeg bekræfter, at jeg vil sikre, at alle SMS-beskeder, der sendes fra denne konto, er i overensstemmelse med den gældende politik",
      "customizeTitle": "Tilpas generelt indhold",
      "disableConfirm": "Er du sikker på, at du vil deaktivere afsender-ID'et?",
      "disableSenderID": "Deaktiver SenderID",
      "disableTitle": "Deaktiver afsender-ID?",
      "end": "Slutter",
      "pleaseAdd": "Tilføj {text} som nævnt i det hurtige tip.",
      "quickTipMessage": "Den første besked, du sender til en person, skal indeholde oplysninger om afsenderidentifikation. Tilføj {text} i den generelle tekstboks.",
      "reallyDisableConfirm": "Er du virkelig sikker på, at du vil deaktivere SenderID?",
      "senderID": "Afsender-ID"
    },
    "shopify": {
      "adminApiAccessToken": "Admin API-adgangstoken",
      "apiTokenRequired": "API-adgangstoken er påkrævet",
      "checkDocumentation": "Se denne dokumentation for at få mere at vide",
      "checkmark": "✓",
      "cross": "✗",
      "customAppApiAccessToken": "Adgangstoken for brugerdefineret app-API",
      "deleteWarning": "Hvis du sletter denne, fjernes den eksisterende forbindelse.",
      "existStoreAlertTitle": "Shopify-butiksintegration findes allerede",
      "integration": "Shopify-integration",
      "integrationHealth": "Integration",
      "orders": "Bestillinger",
      "scopePermissionsWarning": "Sørg for, at din app har fået tilladelser markeret med et rødt kryds",
      "scopes": "Omfang",
      "scopesDescription": "Autorisationer er nødvendige for at få adgang til Shopify-oplysninger. På grund af de seneste ændringer i Shopify skal read_customers nu indhente alle oplysninger fra kunderne på grund af Shopify-beskyttede kundedata.",
      "storeConnectedMessage": "Shopify-butikken er allerede forbundet med underkontoen {locationName}",
      "storeNameHelp": "Dit butiksnavn er fundet i URL-adressen til din Shopify-konto – efter https:// og før .myshopify.",
      "storeNameLabel": "Navnet på din Shopify-butik",
      "storeNamePlaceholder": "Butiksnavn",
      "storeNameRequired": "Butiksnavn er påkrævet",
      "typeRemoveConfirm": "Skriv 'FJERN' for at bekræfte",
      "webhooks": "Webhooks",
      "webhooksDescription": "For at modtage alle hændelser fra Shopify skal vi registrere disse Shopify-webhooks under integrationsprocessen. Disse webhooks er afgørende for at sikre, at Shopify-funktionerne fungerer korrekt."
    },
    "slack": {
      "accountConnected": "Konto tilsluttet",
      "accountsConnected": "Konti tilsluttet",
      "accountsList": "Liste over alle Slack-konti",
      "added": "Tilføjet {date}",
      "connectChannel": "Tilslut din Slack-kanal",
      "description": "Få øjeblikkelige notifikationer på din Slack-kanal. Klik på 'Forbind' for at tilføje en Slack-kanal.",
      "manage": "Administrer",
      "manageAccounts": "Administrer Slack-konti",
      "noIntegrations": "Ingen Slack-integrationer blev fundet."
    },
    "smtpService": {
      "addFirstService": "Tilføj din første SMTP-service.",
      "addService": "Tilføj serviceydelse",
      "bccEmails": "BCC-e-mails",
      "cannotDeleteDefaultProvider": "Du kan ikke slette standardudbyderen.",
      "contactDeveloper": "Kontakt udvikleren af denne app.",
      "customProvider": "Tilpasset udbyder",
      "defaultProvider": "Standardudbyder",
      "defaultProviderUpdated": "Standardudbyderen blev opdateret.",
      "emailDomain": "E-mail/domæne",
      "emailService": "EMAIL-service",
      "enableReplyTracking": "Aktivér sporing af svar",
      "forwardToAssignedUser": "Videresend til tildelt bruger",
      "providerType": "Udbydertype",
      "smtpConnectionIssue": "Der er et problem med denne SMTP-forbindelse. Genopret forbindelsen til denne integration.",
      "useLcEmailMessage": "Brug LC Email til at sende e-mails til dit agentur og dine kunder."
    },
    "socialPosting": {
      "automaticPostingEnabled": "Automatisk opslag aktiveret",
      "dailyPostLimit": "Daglig grænse for indlæg",
      "directoriesDescription": "Når du får en ny anmeldelse, lægger vi den automatisk op i mere end 80 onlinekataloger, der automatisk hjælper med at styrke dit brand og din SEO.",
      "directoriesTitle": "80+ kataloger og websites",
      "fivePosts": "5 indlæg",
      "fiveStars": "5 stjerner",
      "fourPosts": "4 slå op",
      "fourStars": "4 stjerner",
      "googlePlus": "Google+",
      "manageSettingsDescription": "Tilpas hvordan og hvornår dine anmeldelser automatisk offentliggøres på alle dine sociale netværk.",
      "manageSettingsTitle": "Administrer dine indstillinger for sociale opslag",
      "postReviewsForRating": "Indsend anmeldelser for denne stjernevurdering eller højere.",
      "searchEngines": "Søgemaskiner",
      "threePosts": "3 slå op",
      "threeStars": "3 stjerner",
      "title": "Sociale opslag"
    },
    "tags": {
      "addNewTag": "Tilføj nyt tag",
      "allTags": "Alle tags",
      "deletedTags": "Slettede tags",
      "here": "her.",
      "newTag": "Nyt tag",
      "noTagsYet": "Ingen tags at vise endnu",
      "searchTags": "Søg efter tags",
      "viewDeletedTags": "Du kan se og gendanne slettede tags på siden Revisionslogfiler"
    },
    "templateMessage": {
      "addEmailTemplate": "Brug en skabelon (uddrag)",
      "addTemplate": "Tilføj skabelon (uddrag)",
      "addTextTemplate": "Tilføj tekstskabelon (uddrag)",
      "body": "Indhold",
      "deleteTemplateConfirmation": "Er du sikker på, at du vil slette denne skabelon?",
      "templatesCount": "{count} skabeloner",
      "title": "Beskedskabeloner (snippets)"
    },
    "unsubscribe": {
      "content": "Indhold",
      "contentTooltip": "Indholdet af denne besked vil automatisk blive tilføjet til alle e-mails.",
      "customizeTitle": "Tilpas afmeldingsindhold",
      "disableConfirm": "Er du sikker på, at du vil deaktivere afmeldingslinket fra e-mailen?",
      "disableTitle": "Deaktiver afmeldingslink?",
      "disableUnsubscribe": "Deaktiver afmelding",
      "pleaseAddTag": "Tilføj /*unsubscribe*/-tag",
      "reallyDisableConfirm": "Er du virkelig sikker på, at du vil deaktivere afmeldingslinket fra e-mailen?",
      "subscribedConfirm": "Jeg bekræfter, at der kun vil blive sendt e-mails til kontakter, som har abonneret på at modtage email.",
      "subscribedConfirmClient": "Jeg bekræfter, at jeg vil sikre, at e-mails kun sendes til kontakter, der har abonneret på at modtage e-mails.",
      "suspensionWarning": "Ikke-overensstemmende aktivitet kan føre til suspension af din kontos mailfunktioner.",
      "tagRequirement": "Den første email, du sender til en person, skal indeholde /*unsubscribe*/-tagget."
    },
    "callAndVoicemailSettings": {
      "defaultVoicemailMessage": "Dette er standard telefonsvarerbeskeden for alle Twilio-numre på stedet, medmindre den er tilpasset under",
      "forwardCallsToWebApp": "Viderestil opkald til webapp",
      "forwardCallsToMobileApp": "Viderestil opkald til mobilappen",
      "dedicatedNumberRequiredInfo": "Dette er kun påkrævet, hvis brugerne har brug for et dedikeret nummer. Ikke påkrævet for talebesked eller for at dirigere opkaldet til den tildelte bruger.",
      "voicemailMessageInfo": "Denne telefonsvarerbesked vil blive afspillet i stedet for den fra teleudbyderen. Vi anbefaler en timeout på 20 sekunder eller mindre.",
      "noTimeout": "Ingen timeout",
      "10Secs": "10 sekunder",
      "20Secs": "20 sek.",
      "voicemailMessageDuration": " Vi vil optage en talebesked, hvis opkaldet ikke besvares inden for denne varighed.",
      "saveCallSettings": "Gem opkaldsindstillinger"
    },
    "elizaFAQSetting": {
      "bypassElizaNote": "Når dette tag er til stede på kontakten, vil de pågældende beskeder IKKE blive leveret til Eliza",
      "sendToElizaNote": "Som standard vil alle samtaler blive leveret til Eliza. Hvis dette tag er konfigureret, <br />vil de nye samtaler kun blive sendt til Eliza, når dette tag er til stede på en kontakt.<br /> Hvis både Eliza bypass-tag og Send til Eliza-tag er konfigureret, vil kun Send til Eliza blive respekteret",
      "permissionNote": "Dine brugertilladelser er ikke aktiveret for denne side. <br />Tal med din administrator",
      "addFAQ": "Tilføj FAQ"
    },
    "locationSettings": {
      "ownCardWarning": "Tilføj ikke dit eget kort til underkonti!!",
      "addClientCardWarning": "Tilføj din kundes (underkontos) kort og ikke dit eget, da dette kort vil blive brugt til at fakturere din klient på dine vegne.",
      "stripeConnectMissing": "Stripe connect mangler",
      "pleaseContactAgencyToAddPaymentMethods": "Kontakt agenturet ({email}) for at tilføje betalingsmetoder."
    },
    "integrations": {
      "connectWaveAccount": "Forbind din placerings Wave-konto",
      "connectXeroAccount": "Forbind din placerings Xero-konto"
    },
    "gmbSettings": {
      "gbpCallTrackingEnabledOnAnotherSubAccount": "GBP-opkaldssporing er aktiveret på en anden underkonto. Opkaldssporing kan aktiveres på én underkonto ad gangen.",
      "gbpCallTrackingEnabledOnAnotherPage": "GBP opkaldssporing er aktiveret på en anden side ({pageName}). Opkaldssporing kan aktiveres på en enkelt underkonto og en enkelt side pr. lokation ad gangen.",
      "gbpCallsProperlySetup": "GBP-opkald er korrekt konfigureret, og opkald kommer ind fra",
      "tooManyEditsToPrimaryPhone": "Du har foretaget for mange redigeringer af den primære telefon til denne virksomhed. Prøv igen senere.",
      "setupTwilioToStartCallTracking": "Konfigurer Twilio for at starte opkaldssporing",
      "twoSecondaryNumbersSetupAlready": "Du har allerede opsat 2 sekundære numre, kan ikke bytte nummer",
      "yourAgentIDIs": "Dit agent-ID er"
    },
    "numberPool": {
      "title": "Dette skal du spore",
      "tracking": {
        "percentComplete": "34 % gennemført",
        "searchLower": "søg"
      },
      "create": {
        "title": "Opret sporingsnummer"
      }
    },
    "phoneNumbers": {
      "title": "Dette skal du spore",
      "tracking": {
        "percentComplete": "34 % gennemført",
        "heading": "Opret et sporingsnummer"
      }
    }
  },
  "smartList": {
    "filterMultiInput": {
      "enterValue": "* Indtast en værdi",
      "selectOption": "* Vælg en mulighed"
    },
    "filterMultiSelections": {
      "atLeastOneRequired": "* Mindst ét {filterName} er påkrævet",
      "select": "Vælg {filterName}"
    },
    "newEmailStats": {
      "timeStamp": "Tidsstempel"
    },
    "recordsNav": {
      "clickToReloadList": "Klik for at genindlæse listen"
    },
    "reviewRequestActions": {
      "emailReviewReq": "E-mail gennemgang af anmodning",
      "smsReviewReq": "SMS gennemgang af anmodning",
      "whatsappReviewReq": "WhatsApp gennemgang af anmodning"
    },
    "smartListFilters": {
      "clearAllFilters": "Ryd alle filtre",
      "noneFound": "ingen fundet",
      "saveChangesToList": "Gem filterændringer på denne smarte liste",
      "saveCombinationAsNew": "Gem kombination af filtre, kolonner og sortering som ny smart liste",
      "saveCurrentAsNew": "Gem de aktuelle filtre som en ny smart liste",
      "searchAndAddFilter": "Søg og tilføj et filter",
      "searching": "Søger ...",
      "undoUnsavedChanges": "Fortryd ændringer, der ikke er gemt"
    },
    "smsStatsPanel": {
      "smsStats": "SMS-statistik"
    },
    "manageDuplicates": "Administrer dubletter",
    "emailAction": {
      "attachFiles": "Vedhæft filer",
      "customValues": "Brugerdefinerede værdier",
      "triggerLinks": "Trigger-links"
    },
    "atLeastOneRequired": "* Mindst ét {filterName} er påkrævet",
    "arrayInput": {
      "searchPlaceholder": "Søg efter {filterName}",
      "searching": "Søger ..."
    }
  },
  "snapshots": {
    "common": {
      "errorWhileFetchingSnapshotContents": "Fejl under hentning af indhold af snapshot",
      "overwriteAll": "Overskriv alle",
      "skipAll": "Spring alle over",
      "somethingWentWrongWhileFindingConflicts": "Der opstod en fejl under søgning efter konflikter",
      "step": "Trin"
    },
    "confirmOverwrite": {
      "confirmButton": "Gem overskrivning",
      "description": "Denne handling kan ikke fortrydes og kan ændre konfigurationer af kampagner, muligheder, salgstragte osv. Bekræft din handling ved at skrive følgende i inputfeltet.",
      "title": "Er du sikker på, at du vil overskrive valgte data?"
    },
    "conflicts": {
      "noConflictsDetected": "Ingen konflikter blev opdaget",
      "overwrite": "Overskriv"
    },
    "pushCloneAccount": {
      "assetsFoundLinked": "Tilknyttede aktiver fundet",
      "checkingConflicts": "Kontrollerer for konflikter",
      "chooseSnapshot": "Vælg et øjebliksbillede",
      "copyingDataNotification": "Kopierer data til udvalgte placeringer. Vent ...",
      "linkedLocations": "Tilknyttede steder",
      "noConflictsFound": "Der blev ikke fundet nogen konflikter",
      "notAuthorizedMessage": "Kun agenturadministratorer kan udføre denne handling",
      "overwriteConflicts": "Overskriv konflikter",
      "pickSnapshot": "Vælg et øjebliksbillede",
      "response": "Svar",
      "selectAssetsToPush": "Vælg aktiver, der skal overføres",
      "selectLocationsToUpdate": "Vælg placeringer, der skal opdateres",
      "snapshotNotAuthorized": "Dette øjebliksbillede er ikke godkendt til denne placering",
      "snapshotNotSelected": "Øjebliksbillede ikke valgt"
    },
    "share": {
      "agencyRestrictedLink": "Agenturbegrænset link",
      "deleteShareLink": "Slet delingslink",
      "editShareLink": "Rediger delingslink",
      "permanentLink": "Permanent link",
      "subaccountRestrictedLink": "Begrænset link til underkonto"
    },
    "shareSnapshot": {
      "addCommaAfterEach": "(Tilføj komma (<span class='text-base font-bold'> , </span>) efter hvert relationsnummer)",
      "addCommaAfterEachSubAccount": "(Tilføj komma (<span class='text-base font-bold'> , </span>) efter hvert underkonto-id)",
      "atLeast1EmailRequired": "Mindst én e-mail er påkrævet.",
      "emailShareLink": "Del link via e-mail",
      "enterOnePerLine": "(Indtast én pr. række)",
      "errorGettingLink": "Noget gik galt under hentning af linket. Prøv igen senere.",
      "getAgencyRestrictedLink": "Hent agenturbegrænset link",
      "getLink": "Hent link",
      "getOneTimeLink": "Få et engangsdelingslink",
      "getPermanentLink": "Hent permanent link",
      "getSubAccountRestrictedLink": "Hent begrænset link til underkonto",
      "shareType": "Delingstype",
      "title": "Del øjebliksbillede"
    },
    "snapshot": {
      "copySnapshotID": "Kopiér øjebliksbillede-ID",
      "deleteSnapshot": "Slet øjebliksbillede",
      "editSnapshot": "Rediger øjebliksbillede",
      "pushUpdate": "Skub opdatering til tilknyttede konti",
      "refreshSnapshot": "Opdater øjebliksbillede"
    },
    "updateShareLink": {
      "addCommaAfterEach": "(Tilføj komma efter hvert relationsnummer)",
      "addCommaAfterEachSubAccount": "(Tilføj komma efter hvert underkonto-ID)",
      "title": "Opdater delingslink"
    }
  },
  "socialMedia": {
    "engagement": "Engagement",
    "potentialReach": "Potentiel rækkevidde",
    "storiesCreated": "Stories oprettet",
    "recentPosts": "Seneste indlæg",
    "notConnected": "Ikke forbundet (Opret forbindelse nu!)",
    "totalAudience": "Samlet målgruppe",
    "activeAudience": "Aktivt publikum",
    "socialMediaOverview": "Oversigt over sociale medier"
  },
  "suspendModal": {
    "currentStatus": "Aktuel abonnementstatus: sat på pause",
    "instructions": "Du skal blot afslutte et par enkle trin for at {action} denne underkonto.",
    "nextBillingDate": "Næste faktureringsdato:",
    "noKeepCharging": "Nej, fortsæt med at fakturere kunderne",
    "pauseSubscriptionQuestion": "Ønsker du også at sætte abonnementet på pause sammen med underkontoen?",
    "resumeSubAccount": "Genoptag underkonto",
    "resuming": "Genoptager ...",
    "saasSubscriptionActive": "Denne underkonto har et aktivt SaaS-abonnement.",
    "saasSubscriptionResumed": "SaaS-abonnementet for denne konto vil blive genoptaget.",
    "yesPause": "Ja, sæt abonnementet på pause"
  },
  "table": {
    "perPageOptions": {
      "5": "5 pr. side",
      "10": "10 pr. side",
      "15": "15 pr. side",
      "20": "20 pr. side",
      "25": "25 pr. side",
      "50": "50 pr. side",
      "100": "100 pr. side"
    },
    "filterPlaceholder": "Søg ...",
    "emptyText": "Ingen poster fundet",
    "loading": "Indlæser ...",
    "showingEntries": "Viser {from} til {to} af {total} poster",
    "noEntriesToShow": "Ingen poster at vise"
  },
  "templateLibrary": {
    "public": {
      "loadingAccountData": "Indlæser kontodata …",
      "toContinueWith": "for at fortsætte med"
    },
    "switcherModal": {
      "comingSoon": "Kommer snart.",
      "multiLocationMessage": "Denne funktion er i øjeblikket kun tilgængelig for enkeltkonti. Vi arbejder hårdt på at kunne tilbyde dette til konti med flere adresser snart."
    },
    "importedMessage": "{productName} Importeret! Naviger til skabelonbiblioteket, og find det under fanen {productName}.",
    "permissionErrorMsg": "Denne mulighed er kun tilgængelig på højere planer. Opgrader nu for at låse den op.",
    "errors": {
      "sourceDeleted": "Fejl: Kildeskabelonen er blevet slettet. Det er ikke længere tilgængeligt. Tjek skabelonens status, eller kontakt opretteren for at få hjælp.",
      "sourceDraft": "Fejl: Kildeskabelonen er blevet flyttet til kladde. Tjek skabelonens status, eller kontakt opretteren for at få hjælp.",
      "linkedDeleted": "Fejl: Kildeskabelonen, der er forbundet med den delte skabelon, er blevet slettet. Tjek skabelonens status, eller kontakt opretteren for at få hjælp.",
      "fetchError": "Der ser ud til at være en fejl under hentning af {productName} -oplysninger. Kontrollér webadressen, eller prøv igen.",
      "sameAgency": "Kan ikke dele skabelon inden for den samme agentur"
    }
  },
  "triggers": {
    "addContactTagRequiresTag": "Handlingen Tilføj kontakttag kræver et tag.",
    "addNotesRequiresData": "Handlingen Tilføj noter kræver notedata.",
    "addTaskRequiresFields": "Tilføjelse af opgavehandling kræver titel og forfaldsdato.",
    "addToCampaignRequiresCampaign": "Handlingen Føj til kampagne kræver en kampagne.",
    "addToCustomAudienceRequires": "Handlingen Tilføj til brugerdefineret målgruppe kræver en annoncekonto og en brugerdefineret målgruppe.",
    "addTrigger": "Tilføj udløser",
    "anyAction": "Enhver handling",
    "anyCondition": "Enhver betingelse,",
    "brokenCustomVariables": "Nogle felter indeholder defekte brugerdefinerede variabler. Ret dem, før du gemmer.",
    "conditionCannotBeEmpty": "Betingelsen '{condition} ' må ikke være tom",
    "confirmDeleteTrigger": "Er du sikker på, at du vil slette denne udløser?",
    "customDateFieldRequired": "Filteret \"Brugerdefineret datofelt\" er påkrævet for udløser af brugerdefineret datopåmindelse",
    "detailPage": {
      "chooseTriggerPlaceholder": "Vælg en udløser",
      "lastUpdate": "Sidste opdatering:",
      "loopIdentifiedWarning": "Denne udløser er låst i kladdestatus, fordi den forårsager en løkke. Kontakt support for at aktivere denne udløser.",
      "ruleNotActiveWarning": "Denne regel vil ikke gælde, før du aktiverer den.",
      "triggerCreation": "Oprettelse af udløser:",
      "triggerDeletedPrompt": "Denne udløser er slettet! Ønsker du at gendanne den?",
      "triggerRunDailyTooltip": "Kørsel af udløser kl. 08.00 dagligt",
      "whatTriggersRule": "Hvad bør udløse denne regel?",
      "whichEventTriggersAutomation": "Hvilken hændelse skal udløse denne automatisering?"
    },
    "dndContactRequiresState": "DND-kontakthandlingen kræver, at DND-tilstanden er indstillet.",
    "emptyConditionNotAllowed": "Tom betingelse er ikke tilladt.",
    "emptyFieldNotAllowed": "Tomt felt er ikke tilladt.",
    "executeWebhookRequiresUrl": "Udførelse af webhook-handling kræver webhook-url.",
    "fieldCannotBeEmpty": "{field} kan ikke være tom",
    "fillRequiredFields": "Udfyld alle obligatoriske felter i handlingerne.",
    "googleAdwordsRequiresConversion": "Handlingen Tilføj til Google AdWords kræver konvertering.",
    "googleAnalyticsRequiresFields": "Handlingen Føj til Google Analytics kræver sporings-ID, handlingstype og handlingskategori",
    "membershipGrantOfferRequiresOffer": "Handling vedrørende tilbud om medlemskab kræver tilbud.",
    "membershipRemoveOfferRequiresOffer": "Handlingen \"Fjernelse af medlemskab\" kræver et tilbud.",
    "newBasicRule": "Ny grundlæggende regel",
    "opportunitiesRequirePipeline": "Kundeemne-handlinger kræver, at du vælger en proces.",
    "opportunityLoopWarning": "Denne udløser vil forårsage en løkke til oprettelse af mulighed. Fjern muligheden \"Tillad dubletter\", eller skift den fase, du refererer til.",
    "removeContactTagRequiresTag": "Handlingen Fjern kontakttag kræver tag.",
    "removeFromCampaignRequiresCampaign": "Fjern fra kampagne kræver en kampagne.",
    "removeFromCustomAudienceRequires": "Handlingen Fjern fra brugerdefineret målgruppe kræver en annoncekonto og en brugerdefineret målgruppe.",
    "rulesBasedOn": "regler baseret på",
    "selectUserForNotification": "Vælg bruger til afsendelse af notifikation.",
    "sendEmailRequiresFields": "Handlingen Send e-mail kræver fra, til, emne og besked.",
    "sendNotificationRequiresFields": "Handlingen Send notifikation kræver titel, brødtekst og brugertype for at kunne sende notifikation.",
    "sendSmsRequiresFields": "Handlingen Send sms kræver nummer og besked.",
    "stripeMinAmountUSD": "Beløbet skal være større end eller lig med 50 USD.",
    "stripeRequiresFields": "Engangsbetaling i Stripe kræver kunde-ID, beløb og valuta",
    "thatWillFire": "der vil udløse",
    "triggerCannotBeEmpty": "Udløser kan ikke være tom.",
    "updateContactFieldRequires": "Feltet Opdater kontakt skal have mindst ét felt angivet."
  },
  "workflow": {
    "resellPaywall": {
      "buttonText": "Betal ${amount}, og abonner",
      "commitment": "Ingen binding, opsiges når som helst",
      "features": {
        "billedOnUsage": "Faktureres baseret på forbrug, efter grænsen er overskredet",
        "externalAI": "Ekskluderer eksterne AI-modelhandlinger, som faktureres separat.",
        "leadingPricing": "Branchens førende prissætning!",
        "monthlyPurchase": "Gyldig for ét køb pr. måned",
        "premiumActions": "Gælder for premiumudløsere og -aktiviteter"
      },
      "planDetails": "Oplysninger om plan",
      "subscribeAndSave": "Abonner og spar i dag!",
      "title": "${amount} for {executions} handlinger pr. måned"
    }
  },
  "appointmentWidget": {
    "movedMessage": "Denne indstilling er flyttet til kalendersiden.",
    "toNavigate": "her for at navigere. Denne side vil snart blive fjernet."
  },
  "attribution": {
    "description": "Den første interaktion er blot det første berøringspunkt, en bruger foretager. Så hvis nogen først har fundet dig via en betalt søgereklame (PPC), ville den kanal få kreditten, når det kommer til en konvertering. På den anden side ville den sidste interaktion være den sidste kanal.",
    "firstInteraction": "Første interaktion",
    "lastInteraction": "Sidste interaktion",
    "title": "Attribution"
  },
  "campaign": {
    "addEvent": "Tilføj begivenhed",
    "a2p": {
      "address": {
        "chooseState": "Vælg stat ...",
        "city": "By*",
        "postalCode": "Postnummer*",
        "streetAddress": "Gade/vej/nummer*",
        "streetAddressHelper": "Skal være en gyldig adresse knyttet til din virksomhed.",
        "title": "Virksomhedsadresse"
      },
      "addressError": {
        "title": "Indsendelse af adresse mislykkedes"
      },
      "authorizedRep": {
        "jobPosition": "Stilling*",
        "jobTitle": "Jobtitel*",
        "title": "Detaljer om autoriseret repræsentant"
      },
      "brandDetails": {
        "solePropBrand": {
          "heading": "Enkeltmandsvirksomhedsbrand",
          "point1": "Kun ét telefonnummer er tilladt",
          "point2": "EIN/SSN/DUNS er ikke påkrævet"
        },
        "solePropCampaign": {
          "heading": "Enkeltmandsvirksomhedskampagne",
          "point1": "Kun ét nummer må linkes til en enkeltmandsvirksomhedskampagne.",
          "point2": "Når det er godkendt, vil dit standardnummer automatisk blive tilknyttet",
          "infoText": "Du kan også opdatere antallet efter godkendelse",
          "warningText": "Kun ét nummer må linkes til en enkeltmandsvirksomhedskampagne. Når det er godkendt, vil dit standardnummer automatisk blive tilknyttet. Du kan også opdatere nummeret efter godkendelse."
        },
        "solePropSubtitle": "Brand- og kampagnedetaljer for enkeltmandsvirksomhed",
        "standardBrand": {
          "heading": "4,41 USD – engangsbetaling",
          "point1": "EIN/SSN/DUNS er påkrævet",
          "point2": "Mere end 1 telefonnummer tilladt"
        },
        "standardCampaign": {
          "heading": "16,54 USD – engangsbetaling",
          "point1": "Mere end 1 nummer må tilknyttes en standardkampagne.",
          "point2": "EIN/SSN/DUNS er påkrævet",
          "infoText": "Yderligere kampagnegebyr på op til 12 USD pr. måned vil blive pålagt i overensstemmelse med TCR-reglerne."
        },
        "standardSubtitle": "Standardbrand- og kampagnedetaljer",
        "title": "Brand- og kampagnedetaljer"
      },
      "businessInfo": {
        "soleProp": {
          "contactInfo": "Kontaktoplysninger",
          "contactInfoSubtitle": "Dette kan være enhver person, der kan besvare spørgsmål om dette brand, hvis det er nødvendigt. Bemærk, at du ikke kan genbruge kontaktoplysninger mellem brands. Hvert brand, du opretter, skal have unikke kontaktoplysninger.",
          "emailHelper": "Brug ikke den samme e-mailadresse til mere end 5 brands.",
          "phoneNumberHelper": "Brug ikke det samme telefonnummer til mere end 5 brands.",
          "profileName": "Firmanavn eller dit for- og efternavn*",
          "profileNameHelper": "Brug enten det juridiske navn på den organisation, der sender beskederne, eller dit eget navn, hvis dette brand ikke er for en organisation.",
          "nextLoading": "Næste ...",
          "invalidPhoneNumber": "Ugyldigt telefonnummer",
          "phoneNumberWithCountryCode": "Telefonnummer (med landekode)*",
          "phoneNumberRequired": "Telefonnummer er påkrævet.",
          "emailRequired": "E-mail er påkrævet.",
          "profileNameRequired": "Profilnavn er påkrævet."
        },
        "standard": {
          "businessType": "Virksomhedstype*",
          "legalBusinessName": "Juridisk virksomhedsnavn*",
          "legalBusinessNameHelper": "Indtast det nøjagtige virksomhedsnavn, som det er registreret hos regeringen og nævnt i dine skattedokumenter (CP 575). f.eks. Leadconnector LLC i stedet for Leadconnector.",
          "regionsOfOperations": "Forretningsområder for aktiviteter*",
          "registrationNumber": "Virksomhedsregistreringsnummer*",
          "registrationNumberHelper": "Nummeret, der bruges til at identificere din virksomhed. I tilfælde af et amerikansk EIN skal det være et 9-cifret nummer, f.eks. 12-3456789.",
          "registrationType": "ID-type for virksomhedsregistrering*",
          "website": "Virksomhedens website*"
        }
      },
      "businessProfileRegistration": {
        "stepProgress": "Trin {currentStep} af {businessInfoSteps}"
      },
      "businessProfileSuccess": {
        "message": "Din virksomhedsprofil er blevet indsendt.",
        "startA2P": "Start A2P-registrering",
        "title": "Virksomhedsprofil er blevet indsendt",
        "tooltips": {
          "agency": "Agenturbrugere kan starte A2P-registrering.",
          "location": "Lokationsbrugere kan starte A2P-registrering"
        }
      },
      "campaign": {
        "endUserConsent": {
          "closeExample": "Luk eksempel",
          "optInKeywords": "Tilmeldingsnøgleord*",
          "optInKeywordsHelper": "Maks. længde: 255 tegn.",
          "optInKeywordsPlaceholder": "Nøgleord adskilt af komma, eksempel: ABONNER, START.",
          "optInMessage": "Tilmeldingsbesked*",
          "optInMessageInfo": "Skal indeholde virksomhedsnavn og fravalgssøgeord",
          "optInMessagePlaceholder": "Eksempel: Du har tilmeldt dig modtagelsen af notifikationer og reklame-SMS'er fra company_name. Svar STOP, hvis du har brug for at framelde dig i fremtiden.",
          "placeholder": "Eksempel: Slutbrugere tilmelder sig ved at besøge https://www.mycompany.com/book og udfylde deres oplysninger. Brugere markerer et felt for at modtage notifikationer og reklamebeskeder fra os for at give deres samtykke.\nDerudover kan brugere også sende en sms med teksten Start til +1 (213) 725-2867.",
          "question": "Hvordan giver slutbrugere samtykke til at modtage beskeder?*",
          "seeExample": "Se eksempel"
        },
        "messageDetails": {
          "embeddedLink": "Beskeden vil indeholde et integreret link",
          "phoneNumbers": "Beskederne vil indeholde telefonnumre",
          "sampleMessage1Placeholder": "Model: Hej John! Dette er Jane fra company_name. Vores aftale den 20. juli kl. 11.00 er verificeret. Kontakt +1(213) 725-2867, hvis du har brug for at ændre aftalen. Svar STOP for at afmelde dig.",
          "sampleMessage2Placeholder": "Model: Hej Brian! Dette er Jane fra company_name. Jeg kan se, at du ikke kunne komme til vores aftale. Vil du ændre tiden? - https://www.mycompany.com/book. Svar STOP for at afmelde dig.",
          "sampleMessageInfo": "Skal indeholde leadnavn, dit navn, virksomhedsnavn og fravalgssprog",
          "subtitle": "Tilføj eksempelbeskeder"
        },
        "useCaseDetails": {
          "explainInDetail": "Forklar i detaljer",
          "pickUseCase": "Brugsscenarie for valg af kampagne",
          "solePropLabel": "Enkeltmandsvirksomhed",
          "subtitle": "Indtast kampagneoplysningerne og beskrivelse",
          "useCase": "Kampagnebrugsscenarie*",
          "useCaseDescription": "Beskrivelse af use case*",
          "useCaseDescriptionPlaceholder": "Eksempel: Denne kampagne sender aftaleoplysninger – bekræftelses- og påmindelsesbeskeder til vores kunder, når de har booket en aftale hos os på vores website og tilmeldt sig at modtage salgsfremmende SMS-beskeder og notifikationer fra os."
        }
      },
      "einModal": {
        "disableNoEINText": "Kun virksomheder med gyldige adresser i USA og Canada må registrere et A2P-mærke uden et skatte-ID.",
        "hasEIN": "Ja, den virksomhed, jeg registrerer, har et skatte-ID (f.eks. EIN, CCN osv.).",
        "infoText": "Du kan finde dit amerikanske EIN-nummer på din CP 575-formular.",
        "noEIN": "Nej, den virksomhed, jeg registrerer, har ikke et skatte-ID (f.eks. EIN, CCN osv.).",
        "question": "Har den virksomhed, du registrerer, et skatte-ID (f.eks. EIN, CCN osv.)?*",
        "title": "Fastlæg A2P-brandbehov"
      },
      "exampleModal": {
        "examples": "Eksempler"
      },
      "otpError": {
        "message": "Der opstod et problem under afsendelsen af engangskoden.",
        "title": "Kunne ikke sende engangskode igen"
      },
      "otpSuccess": {
        "title": "Din engangskode er blevet sendt."
      },
      "validation": {
        "cityRequired": "By er påkrævet.",
        "countryRequired": "Land er påkrævet.",
        "invalidMobileNumber": "Ugyldigt mobilnummer",
        "postalCodeRequired": "Postnummer er påkrævet.",
        "stateRequired": "Stat er påkrævet.",
        "streetAddressRequired": "Adresse er påkrævet."
      }
    },
    "affiliates": {
      "affiliateAboutIframe": "affiliate-om-iframe",
      "agencyOwner": "Agenturejer",
      "agencyOwnerAndAdmins": "Agenturejer og administratorer",
      "contactAgencyOwner": "Hvis du har brug for hjælp, bedes du kontakte din",
      "firstPromoterAccessMessage": "Denne FirstPromoter-rapport er kun tilgængelig for",
      "firstPromoterIframe": "firstpromoter-iframe",
      "noPartnerFound": "Kunne ikke finde en partner, der matcher dine filtre. Klik",
      "paymentDetailsAccessMessage": "Denne sektion med betalingsoplysninger er kun tilgængelig og kan redigeres af",
      "toApplyPartner": "for at ansøge om at blive partner."
    },
    "common": {
      "actions": {
        "googleDrive": "Google Drev"
      },
      "labels": {
        "doc": "Doc"
      },
      "loading": "Indlæser",
      "legalBusinessNameHelper": "Indtast det nøjagtige virksomhedsnavn, som det er registreret hos regeringen og nævnt i dine skattedokumenter (CP 575). f.eks. Leadconnector LLC i stedet for Leadconnector."
    },
    "desktop": {
      "highlevel": {
        "logoAltText": "HighLevel Logo",
        "launchingDescription": "Klik på <span class='font-semibold'>Åbn HighLevel</span> for at starte skrivebordsappen.<br>Fungerer det ikke? Du kan også <a href=\"/\" class='!text-blue-700 hover:underline'>bruge HighLevel i din browser</a>",
        "launchingTitle": "Start af HighLevel-skrivebordsappen",
        "launchButtonText": "Åbn HighLevel"
      },
      "leadconnector": {
        "logoAltText": "LeadConnector Logo",
        "launchingDescription": "Klik på <span class='font-semibold'>Åbn LeadConnector</span> for at starte skrivebordsappen.<br>Fungerer det ikke? Du kan også <a href=\"/\" class='!text-blue-700 hover:underline'>bruge LeadConnector i din browser</a>",
        "launchingTitle": "Start af LeadConnector-skrivebordsappen",
        "launchButtonText": "Åbn LeadConnector"
      }
    },
    "email": {
      "actionCard": {
        "chooseAction": "Vælg en handling",
        "destination": "Destination",
        "removeFromAllCampaigns": "Denne handling fjerner kundeemner fra alle kampagner undtagen den aktuelle kampagne",
        "triggerLinks": "Trigger-links"
      },
      "importTemplate": {
        "errorImporting": "Fejl under import af skabelon!",
        "importTemplate": "Importér skabelon",
        "importing": "Importerer",
        "title": "Importér {entityName} skabelon",
        "unnamedEntity": "Unavngivet kopi af {entityName}"
      },
      "lcEmail": {
        "migrationModal": {
          "below": "under",
          "confirmByTyping": "Bekræft ved at skrive",
          "confirmWord": "BEKRÆFT",
          "existingNotMoved": "Hvis din klient allerede har Mailgun eller SMTP-opsætning, vil de ikke blive flyttet over",
          "notNow": "Ikke nu",
          "pricingInfo": "LC Email er billigere end Mailgun og koster omkring 0,68 USD for 1000 e-mails.",
          "setAsDefault": "Angive LC Email som standardudbyder for dit bureau og kunder, der ikke allerede har Mailgun eller SMTP",
          "thisWill": "Dette vil:",
          "title": "Du migrerer til Lead Connector Email",
          "useLcEmail": "Brug LC Email"
        }
      },
      "newPostModal": {
        "dragDropMedia": "Træk eller slip medier her",
        "editPost": "Rediger indlæg",
        "enterText": "Indtast tekst her",
        "exampleComment": "Meget fedt! Jeg glæder mig til dette!",
        "exampleName": "Testtekniker",
        "hashtag1": "#hashtag",
        "hashtag2": "#fedt",
        "hashtag3": "#cool",
        "imagePlaceholder": "img(02).png",
        "needReview": "Har du brug for en gennemgang?",
        "network": "Netværk",
        "photo": "foto",
        "previewPost": "Forhåndsvisning af indlæg",
        "selectNetwork": "Vælg socialt netværk",
        "sizeExample": "245 kb",
        "textExample": "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        "urlExample": "https://searchengineland.com/google-announces-new-features-for-retail-advertisers-at-smx-advanced-300001"
      },
      "numberPool": {
        "confirmation": {
          "createdMultiple": "Du har oprettet en talpulje med {count} numre for at spore besøgende på dit website. <br />Dine opkald vil blive viderestillet til",
          "createdSingle": "Du har oprettet et {count}-nummer til at spore besøgende på dit website. <br />Dine opkald vil blive viderestillet til",
          "percentComplete": "100 % gennemført"
        },
        "create": {
          "correctErrors": "Ret de fejl!",
          "forwardHelp": "Fortæl os, hvilken telefon der skal ringe, når kunden ringer til dit sporingstelefonnummer. Dette er typisk dit primære arbejdstelefonnummer. Eksempel: 40455512",
          "heading": "Nummerpulje og viderestilling af opkald",
          "nameHelp": "'{name}' er den måde, vi vil referere til dette sporingsnummer på din konto. Vælg et kort og mindeværdigt navn.",
          "newTrackingNumbers": "nye sporingsnumre.",
          "nextTracking": "Næste: Sporingsmuligheder",
          "percentComplete": "50 % gennemført",
          "pleaseConfirm": "Bekræft:",
          "poolSize": "Puljestørrelse",
          "poolSizeError": "Indtast en puljestørrelse mellem 4 og 30 sporingsnumre.",
          "poolSizeHelp": "Størrelsen på din nummerpulje bestemmer, hvor mange samtidige besøgende vi kan spore på din hjemmeside på et givet tidspunkt. Din puljestørrelse bør være en fjerdedel af den timelige spidsbelastningstrafik rapporteret i Google Analytics, med mindst 4 tal.",
          "swappingHelp": "Fortæl os, hvilket telefonnummer vi skal udskifte på websitet. Eksempel: 40 45 55 12",
          "swappingNumber": "Udskifting af nummer",
          "validationError": "Der opstod en fejl under validering af formularen"
        },
        "features": {
          "activateNumber": "Aktivér nummer",
          "address": "{type} adresse",
          "addressHelp": "I nogle lande kræver køb af nummer en adresse. Kontakt support for at finde ud af, hvordan du indbefatter en adresse, hvis du har brug for hjælp.",
          "heading": "Nummerfunktioner",
          "leaveBlank": "Lad være tomt, hvis der ikke er nogen besked",
          "recordingDescription": "Aktivér opkaldsoptagelse, og afspil en kort besked til den, der ringer op.",
          "recordingHelp": "Nogle jurisdiktioner kræver, at begge parter samtykker til enhver optaget samtale. For at hjælpe med overholdelsen af disse love kan du aktivere en hilsen for at informere den, der ringer op, om, at samtalen kan blive optaget.",
          "whisperDescription": "En kort besked, der afspilles før opkaldet. Opkalderen hører ikke denne besked."
        },
        "tracking": {
          "heading": "Sporingsmuligheder",
          "nextCreatePool": "Næste: Opret pulje",
          "percentComplete": "34% gennemført",
          "searchLower": "søg"
        },
        "whatToTrack": {
          "heading": "Hvad vil du spore på din hjemmeside?",
          "trackCampaign": "Spor en marketingkampagne",
          "trackCampaignDescription": "Opret ét telefonnummer, der sporer alle opkaldere til en enkelt markedsføringskampagne.",
          "trackVisitor": "Spor besøgendes aktivitet",
          "trackVisitorDescription": "Opret flere numre, der korrelerer opkald til besøgende på websitet, PPC-nøgleord og andet."
        }
      }
    },
    "loader": {
      "clickHereToRefresh": "Klik her for at opdatere.",
      "issuesLoadingApp": "Hvis du har problemer med at indlæse appen",
      "loadingFreshData": "Indlæser nye data ...",
      "loadingNewSubAccountData": "Indlæser nye underkontodata ..."
    },
    "login": {
      "bySigningInYouAgree": "Ved at logge ind accepterer du vores <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>vilkår og betingelser</a>",
      "newPasswordSent": "En ny adgangskode sendes til din e-mail."
    },
    "regulatoryBundle": {
      "a2p": {
        "activityHistory": {
          "by": "Af:"
        },
        "affiliates": {
          "partnerBadgeAlt": "Partner-badge"
        },
        "checkout": {
          "cardInformation": "Kortoplysninger",
          "cardNumberInvalid": "Dit kortnummer er ugyldigt.",
          "commitment": "forpligtelse",
          "consentOneTime": "Ved at bekræfte giver du LeadConnector tilladelse til at debitere dit kort for denne betaling.",
          "consentSubscription": "Ved at bekræfte dit abonnement giver du LeadConnector tilladelse til at debitere dit kort for denne betaling og fremtidige betalinger for dette abonnement.",
          "defaultIntervalCount": "1",
          "endingIn": "slutter på",
          "errorImageAlt": "Fejlillustration",
          "intervalSuffix": "(er)",
          "month": "Måned",
          "pay": "Betal",
          "payWithCard": "betal med kort",
          "paymentProcessing": "Betalingen er under behandling. Undlad at genindlæse eller trykke på tilbage-knappen",
          "proceedWithExistingCard": "Fortsæt med det eksisterende kort",
          "proceedWithNewCard": "Fortsæt med et nyt kort",
          "prorationDetails": "Du vil blive opkrævet i {days} dage lige nu for perioden indtil {billingEnd}, og du vil begynde at blive opkrævet det fulde beløb på ${amount}/måned fra {billingDate}.",
          "prorationMessage": "De indledende gebyrer er forholdsmæssigt fordelt, og den normale fakturering starter fra {billingDate}",
          "purchase": "køb",
          "subscribe": "Abonner",
          "subscribeTo": "Abonner på",
          "updateCardDetails": "Opdater kortoplysningerne",
          "zip": "postnummer"
        },
        "options": {
          "jobPosition": {
            "gm": "GM",
            "vp": "VP"
          }
        },
        "registration": {
          "stepProgress": "Trin {currentStep} af 8",
          "successDescription": "Dit A2P-brand og -kampagne er blevet indsendt.",
          "successMessage": "Bemærk: Du vil modtage en besked med en engangskode fra TCR på dit angivne mobilnummer, som du skal bekræfte. Svar Yes inden for 24 timer efter modtagelse af SMS'en.",
          "successWaitDays": "7 dage",
          "successWaitPrefix": "Det kan tage op til ",
          "successWaitSuffix": " for din brandgodkendelse og yderligere 4-5 uger for godkendelse af kampagnen."
        },
        "reminder": {
          "noReplyYet": "Intet svar endnu",
          "patientConfirmed": "Patient verificeret"
        },
        "sendGrid": {
          "apiKeyRequired": "API Key påkrævet"
        },
        "update": {
          "brandNameHelper": "Brug det juridiske navn på den organisation, der sender beskederne.",
          "businessVerticals": "Forretningsområder*",
          "resendOTP": "Send engangsadgangskoden igen",
          "retryOTPTitle": "Prøv at gennemføre OTP-bekræftelsen igen"
        }
      },
      "addCustomEmailModal": {
        "title": "Tilføj tilpasset e-mail"
      },
      "addEditSMTPServiceModal": {
        "addProvider": "Tilføj udbyder",
        "clickHereForInfo": "Klik her for at få flere oplysninger.",
        "clickHereToFindOut": "Klik her for at opdage mere om dem.",
        "createProviderError": "Der opstod en fejl under oprettelse af udbyderen!",
        "gmailLimitations": "Gmail har visse begrænsninger.",
        "needHelp": "Har du brug for hjælp til at finde SMTP-server og portnummer?",
        "port25NotSupported": "Port 25 understøttes ikke! Brug port 2525 i stedet",
        "providerExists": "En udbyder med denne e-mail/brugernavn findes allerede.",
        "providerName": "Udbydernavn",
        "selectProvider": "Vælg udbyder",
        "smtpPortNumber": "SMTP-portnummer",
        "smtpProvider": "SMTP-udbyder",
        "smtpServer": "SMTP-server",
        "username": "Brugernavn",
        "usernameOrEmailRequired": "Enten brugernavn eller e-mail er påkrævet.",
        "verifySmtpAccount": "Bekræfte SMTP-konto"
      },
      "addTagModal": {
        "addTag": "Tilføj tag",
        "editTag": "Rediger tag",
        "tagAlreadyExists": "Tagget {tag} findes allerede"
      },
      "affiliates": {
        "firstPromoterAccessMessage": "Denne FirstPromoter-rapport er kun tilgængelig for <strong>agenturets ejer og administratorer</strong>. Hvis du har brug for hjælp, bedes du kontakte din <strong>agenturejer ({agencyOwnerEmail})</strong>.",
        "firstPromoterIframeTitle": "FirstPromoter-kontrolpanel",
        "noPartnersFound": "Kunne ikke finde en partner, der matcher dine filtre. Klik <a href='javascript:void(0);'>her</a> for at ansøge om at blive partner.",
        "paymentDetailsAccessMessage": "Denne sektion med betalingsoplysninger er kun tilgængelig og kan redigeres af <strong>agenturets ejer</strong>. Hvis du har brug for hjælp, bedes du kontakte din <strong>agenturejer ({agencyOwnerEmail})</strong>."
      },
      "appointmentDetails": {
        "title": "Oplysninger om aftale"
      },
      "attachSnapshotToggle": {
        "loadSnapshot": "Indlæs øjebliksbillede:",
        "loadSnapshotWarning": "Vil du indlæse det øjebliksbillede, der er knyttet til denne plan? <br /> <strong class='text-danger'>Eksisterende data kan gå tabt</strong>"
      },
      "auth": {
        "changePassword": {
          "changeButton": "Skift adgangskode",
          "confirmPassword": "Bekræft ny adgangskode",
          "expired": "Dit link til nulstilling af adgangskode er udløbet.",
          "regenerateLink": "Gendan link",
          "success": "Adgangskoden blev ændret",
          "title": "Angiv ny adgangskode",
          "passwordMismatch": "Adgangskoderne stemmer ikke overens"
        },
        "forgotPassword": {
          "contactAgency": "kontakte dit agentur.",
          "contactSupport": "kontakt HighLevel-support døgnet rundt ved at ringe",
          "supportMessage": "Hvis du ikke har adgang til indbakken for den mail, bedes du",
          "successMessage": "Et link til nulstilling af adgangskode er blevet sendt til din e-mailadresse.",
          "rateLimitError": "For mange anmodninger om nulstilling af adgangskode. Prøv igen senere."
        },
        "login": {
          "inactivityMsg": "Vi har bemærket, at du har været inaktiv i et stykke tid, så vi har logget dig ud for din sikkerheds skyld.",
          "loginButton": "Log ind",
          "resetPasswordMsg": "Et link til nulstilling af adgangskode sendes til din e-mail.",
          "signInWithGoogle": "Log ind med Google",
          "contactHighLevelSupport": " kontakt HighLevel-support døgnet rundt ved at ringe"
        },
        "logout": {
          "loggingOut": "Logger ud ..."
        },
        "otp": {
          "enterBackupCode": "Indtast din backupkode",
          "resend": "Send igen",
          "resendIn": "Send igen om",
          "sendToPhone": "Send kode til telefonen",
          "sending": "Sender",
          "useAuthenticator": "Brug Authenticator-appen",
          "useBackupCode": "Brug backupkode",
          "verifyButton": "Bekræft med backupkode"
        },
        "sso": {
          "agreeTerms": "Ved at logge ind accepterer du vores <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>vilkår og betingelser</a>",
          "and": ", og",
          "loginDifferentMethod": "Log ind ved hjælp af en anden metode",
          "loginSuccessRedirecting": "Login var vellykket, omdirigerer...",
          "processing": "Indlæser din forespørgsel ...",
          "redirecting": "Omdirigerer ...",
          "redirectingToDashboard": "Omdirigerer til kontrolpanelet ...",
          "signedIn": "Logget ind",
          "signingIn": "Logger ind ...",
          "testFailedRedirecting": "Testen mislykkedes, omdirigerer ...",
          "testSuccessRedirecting": "Testen var vellykket, omdirigerer ..."
        }
      },
      "businessDetailModal": {
        "businessAddress": "Virksomhedsadresse: {address}",
        "businessDetailsText": "Følgende virksomhedsoplysninger vil blive indsendt til Google Local Services Ads for Reserve med Google-integration. Kontrollér og bekræft eller {link} for at opdatere din virksomhedsprofil.",
        "businessInfoRequired": "Ovenstående virksomhedsoplysninger er nødvendige for integration, {link} for at opdatere manglende/forkerte virksomhedsoplysninger.",
        "businessName": "Virksomhedsnavn: {name}",
        "businessNiche": "Forretningsniche: {niche}",
        "city": "By: {city}",
        "confirmDetails": "Jeg bekræfter hermed, at ovenstående oplysninger er korrekte",
        "country": "Land: {country}",
        "mustConfirmDetails": "Du skal bekræfte ovenstående oplysninger.",
        "phoneNumber": "Telefonnummer: {phone}",
        "state": "Stat: {state}",
        "zipCode": "Postnummer: {zipCode}"
      },
      "calendarHourRow": {
        "addHours": "Tilføj timer",
        "applyAll": "Anvend alle"
      },
      "campaign": {
        "callerIdVerificationModal": {
          "answerCall": "Besvar opkaldet, og indtast denne bekræftelseskode:",
          "leadConnectorCalling": "Lead Connector ringer ...",
          "title": "Tilføj et opkalds-ID via stemmen",
          "waitingForVerification": "Vent på verifikationen ..."
        },
        "callerIdVerificationStatus": {
          "failed": "Bekræftelse af opkalds-ID mislykkedes. Prøv igen.",
          "success": "Du har bekræftet <strong>{contact}</strong>"
        },
        "choosePhoneNumberModal": {
          "addExistingNumbers": "Tilføj eksisterende numre",
          "areaCode": "Områdekode:",
          "checkAvailability": "Kontrollér tilgængelighed",
          "checkingAvailability": "Kontrol af nummertilgængelighed.",
          "chooseAreaCode": "Vælg et områdenummer",
          "choosePhoneNumbers": "Vælg telefonnummer/-numre",
          "goBack": "Gå tilbage",
          "localNumbers": "Lokal {type}",
          "nextNumberFeatures": "Næste: Nummerfunktioner",
          "noExistingNumbers": "Ingen eksisterende numre at tilføje",
          "noNumbersAvailable": "Ingen numre tilgængelige",
          "notEnoughNumbers": "Ikke nok numre tilgængelige",
          "numbersAvailable": "Numre tilgængelige",
          "numbersDifferentArea": "Numre i et andet områdenummer",
          "numbersLocalTo": "Lokale numre for <strong>{number}</strong>",
          "problemChecking": "Problem med at kontrollere nummertilgængeligheden. Tjek netværksforbindelsen, eller kontakt support.",
          "somethingWentWrong": "Der opstod en fejl. Tjek dine Twilio-kontooplysninger, og send en besked til support, hvis dette fortsætter.",
          "tollFreeNumbers": "Gratisnumre (tillægsgebyr på 2,00 USD pr. nummer pr. måned)",
          "percentageComplete": "67 % færdig"
        },
        "deleteNumberPoolModal": {
          "confirmDelete": "Jeg forstår konsekvenserne, slet puljen",
          "confirmText": "Skriv <b>{name}</b> for at bekræfte",
          "title": "Slet nummerpuljen – ** ** <strong>{name}</strong>",
          "warning": "Denne handling kan ikke fortrydes. Dette vil permanent slette numrene fra din Twilio-konto sammen med nummerpuljen fra vores database. Hvis du sletter nummerpuljen, fordi du oplever et problem, skal du også kontakte vores supportteam."
        },
        "editNumberFormatModal": {
          "description": "Du kan opdatere formateringen af ombyttede numre og puljenumre efter behov. Sørg for, at ombyttede numre vises på samme måde på websitet, som de er formateret.",
          "title": "Opdater nummerformat – <strong>{name}</strong>"
        },
        "editNumberPoolModal": {
          "addEditGroupId": "Tilføj/rediger gruppe-ID",
          "callConnectTooltip": "Denne funktion kræver, at modtageren trykker på en tast for at forbinde opkaldet. Dette vil resultere i højere nøjagtighed for opkaldsrapportering.",
          "createGroupIdDescription": "Tilføj et unikt gruppe-ID for at bruge flere nummerpuljer med én JavaScript-snippet.",
          "enableCallConnect": "Aktivér funktionen til opkaldsforbindelse",
          "groupId": "Gruppe-id",
          "outboundCallTimeout": "Timeout for udgående opkald",
          "passCallerID": "Brug det opkaldte nummer som opkalds-ID",
          "passCallerIDTooltip": "Som standard sender systemet opkalderens nummer, men hvis du ønsker, at Vis nummer i stedet skal vise det nummer, som opkalderen har ringet op til, kan du aktivere denne funktion.",
          "selectCallerID": "Vælg Vis nummer",
          "timeDuration": "Tidsvarighed i sekunder",
          "titleNumber": "Nummer - <strong>{number}</strong>",
          "updateWhisperWarning": "Opdater den korte, private besked, da denne funktion kræver, at modtageren trykker på en tast for at forbinde opkaldet.",
          "useVerifiedNumber": "Brug dit verificerede nummer som opkalds-ID for udgående opkald",
          "useVerifiedNumberTooltip": "Gælder kun for verificerede telefonnumre. Du kan verificere et telefonnummer i Indstillinger > Telefonnumre > Tilføj verificeret Vis nummer"
        },
        "emailOTPModal": {
          "confirmCode": "Bekræft kode",
          "resendCode": "Hvis du ikke har modtaget koden, klik her for at sende den igen",
          "unexpectedIssue": "Der opstod et uventet problem"
        },
        "facebookFieldMapModal": {
          "customFieldInfo": "Info om brugerdefinerede felter",
          "customFieldTooltip": "Værktøjstip til brugerdefineret felt: {options}",
          "field": "{companyName} felt",
          "trackingParameters": "Sporingsparametre",
          "zipCode": "Postnummer"
        },
        "howToUseNumberPoolModal": {
          "addSwappingNumbers": "Tilføj ombytning af numre",
          "addingSnippets": "Tilføjelse af JavaScript-snippets",
          "groupSnippet": "Gruppe-'{id}'-snippet",
          "normalSnippet": "Normal snippet",
          "noswapDescription": "Hvis du ikke ønsker, at vi skal ombytte numrene et bestemt sted, skal du indbefatte kategorien 'noswap' (ingen ombytning).",
          "notReplacing": "Ombyttes ikke på et bestemt sted",
          "requiredSteps": "Påkrævede trin",
          "snippetsDescription": "Kopiér nedenstående snippet, og tilføj det lige over det afsluttende body-tag på hver side, hvor du vil erstatte numrene.",
          "swappingDescription": "Brug nedenstående numre til at aktivere ombytning af telefonnummer. Vælg et lokalt eller internationalt format, eller begge dele."
        },
        "newPhoneNumberModal": {
          "areaCode": "Områdekode",
          "availableNumbers": "Tilgængelige numre",
          "bundle": "Pakke",
          "chooseAddress": "Vælg adresse ...",
          "chooseBundle": "Vælge pakke ...",
          "createRegulatory": "Opret en regulatorisk pakke/adresse her.",
          "monthlyFee": "Månedlig pris",
          "noNumbersFound": "Ingen numre fundet, prøv et andet områdenummer.",
          "selectAddress": "Vælg 'Adresse' for at købe nummeret.",
          "selectBundle": "Vælg 'Pakke' for at købe nummeret.",
          "title": "Tilføj telefonnummer",
          "upgradeAccount": "Opgrader din Twilio-konto. Kun opgraderede konti kan købe telefonnumre og foretage telefonopkald.",
          "cardAuthenticationFailed": "Kortautentificering mislykkedes!"
        },
        "reserveWithGoogleIntegration": {
          "agreeTerms": "Du skal acceptere vilkårene og privatlivsbetingelserne.",
          "clickingProceed": "Hvis du klikker på Fortsæt, åbnes LSA-tilknytningssiden i en ny fane.",
          "configureCalendar": "Konfigurer mindst én kalender for at fortsætte med Reservér med Google-integration",
          "configureCalendarBtn": "Konfigurer kalenderen",
          "linkOneAccount": "Sørg for kun at forbinde én konto. Kontakt support, hvis du ikke kan se siden på skærmbilledet ovenfor.",
          "readInstructions": "Jeg har læst de førnævnte instruktioner"
        },
        "updateTrackingModal": {
          "title": "Opdater sporingsindstilling"
        },
        "usageSummary": {
          "agencyOnlyVisible": "(Dette er kun synligt for agenturadministratorer)",
          "updatedEvery24Hours": "(opdateres hver 24. time)"
        },
        "userCalendarConfiguration": {
          "calendarNotSelected": "Kalender ikke valgt til synkronisering",
          "check": "Kontrollér {email}",
          "checkForConflicts": "Kontrollér for konflikter",
          "checkForConflictsTooltip": "Indstil kalenderne til at kontrollere for konflikter for at forhindre dobbeltbookinger.",
          "contactCreationAllowed": "Oprettelse af kontakt tilladt",
          "googleCalendar": "Google Kalender-logo",
          "noGoogleAccounts": "Ingen Google-/Outlook-konti er tilføjet i integrationsindstillingerne endnu",
          "noGoogleAccountsTeamMember": "Ingen Google-/Outlook-konti er tilføjet for dette teammedlem på den aktuelle placering. Bed dit teammedlem om at logge ind via sin konto og tilføje Google-forbindelse fra sine integrationsindstillinger.",
          "outlookCalendar": "Outlook-brugerkalender",
          "primaryCalendarTooltip": "Indstil den kalender, du vil tilføje nye begivenheder til, efterhånden som de planlægges.",
          "runTriggerAllowed": "Kør udløser tilladt"
        },
        "warningModal": {
          "contactAgency": "Kontakt dit agentur for at ændre e-mailindstillinger.",
          "title": "Advarsel"
        }
      },
      "checkout": {
        "prioritySupport": {
          "features": {
            "faster247Chat": "Hurtigere chat-support 24/7",
            "faster247Ticket": "Hurtigere sagssupport og kortere svartider 24/7"
          },
          "highlight": {
            "description": "Vi kan forstå, at du har brug for, at tingene går lidt hurtigere. Når du har et spørgsmål eller en bekymring, vil du have svar så hurtigt som muligt! Ved at opgradere til prioriteret støtte kan du springe køen over, så dine forespørgsler automatisk står forrest i køen.",
            "heading": "Er du parat til VIP-behandlingen?"
          },
          "name": "Prioriteret support",
          "success": {
            "description": "Prioriteret support er blevet aktiveret i din konto. Nu behøver du ikke længere at vente i køen.",
            "heading": "Du er nu en prioritet kunde!"
          }
        }
      },
      "cloneFunnel": {
        "cloneButton": "Klon {entityName}",
        "cloning": "Kloner ...",
        "cloningLimit": "Kloning er begrænset til 3 steder ad gangen",
        "error": "Fejl under kloning af tragt!",
        "locationsLabel": "Vælg placeringer",
        "nameLabel": "Navn til den klonede {entityName}",
        "namePlaceholder": "Indtast navn til klonet {entityName}",
        "selectUpTo": "Vælg op til {maxSelectableLocations} placeringer",
        "title": "Klon {entityName}"
      },
      "cnam": {
        "learnMore": {
          "description": "Med CNAM vises dit virksomhedsnavn på nummervisning, hvilket gør dine opkald øjeblikkeligt genkendelige og øger tilliden. Lad dine kunder vide, at det er dig, der ringer, hver gang.",
          "title": "Få dine opkald til at skille sig ud!"
        },
        "registration": {
          "characterLimit": "{count}/15",
          "confirm": "Bekræft og tilmeld dig",
          "description": "Vis dit virksomhedsnavn til modtagere af opkald for at øge tilliden og besvarelsesprocenterne.",
          "title": "Øg tilliden til opkald med CNAM",
          "warning": "Visning af virksomhedsnavn er ikke garanteret, især ikke på mobil."
        },
        "submitted": {
          "checkStatus": "Kontrollér CNAM-Omdømme",
          "description": "Dit virksomhedsnavn burde blive vist til relevante kontakter inden for cirka 3-5 dage.",
          "subtitle": "Din CNAM-anmodning er nu indsendt.",
          "title": "Tillykke!"
        }
      },
      "confirmMerchantDeleteModal": {
        "confirmDelete": "Bekræft sletning",
        "confirmation": "Bekræftelse"
      },
      "createAddress": {
        "successTitle": "Adressen er blevet indsendt",
        "underReview": "Den indsendte adresse er under gennemgang"
      },
      "createEndUser": {
        "dateFormat": "Datoformatet skal være ÅÅÅÅ-MM-DD.",
        "phoneExample": " Eksempel: +45 40 12 34 23",
        "title": "Virksomhedsoplysninger:"
      },
      "customValueModal": {
        "changingNameWarning": "Ændring af navnet vil ikke påvirke feltnøglen.",
        "editCustomValue": "Rediger brugerdefineret værdi",
        "fieldKeyCreatedWarning": "Feltnøglen oprettes i henhold til navnet og kan ikke ændres senere.",
        "nameRequired": "Navnefeltet er påkrævet",
        "nameValidation": "Navnet skal være alfanumerisk og indeholde mindst et tegn",
        "valueRequired": "Værdi-feltet er påkrævet"
      },
      "details": {
        "addressName": "Adressenavn",
        "addressTitle": "Adresseoplysninger",
        "bundleName": "Bundlenavn",
        "bundleTitle": "Detaljer om regulatorisk pakke",
        "countryFlag": "{country} flag",
        "id": "ID",
        "organisation": "Organisation",
        "rejectionReason": "Årsag til afvisning",
        "status": {
          "approved": "Godkendt",
          "notValidated": "Ikke valideret",
          "rejected": "Afvist",
          "validated": "Valideret"
        },
        "typeOfNumber": "Nummertype"
      },
      "drChronoOfficeSelect": {
        "selectOffice": "Vælg kontor",
        "whichOffice": "Hvilket kontor vil du linke til denne konto?"
      },
      "editAddToCalendarModal": {
        "allowContactCreation": "Tillad oprettelse af kontakt:",
        "allowTrigger": "Tillad udløser:",
        "doNotSync": "Synkroniser ikke nye tilfælde til den primære kalender",
        "primaryCalendarTooltip": "Du kan kun vælge en kalender med skriveadgang, som du ikke har valgt til konfliktkontrol.",
        "selectDefaultCalendar": "Vælg standardkalender",
        "whichCalendar": "Hvilken kalender skal vi bruge til at synkronisere (læse og skrive) events til?"
      },
      "editCheckForConflictsCalendarsModal": {
        "checkThesePlaces": "Tjek disse steder for konflikter",
        "howToCheckConflicts": "Hvordan skal vi tjekke for konflikter?"
      },
      "ejectModal": {
        "agencyClosing": "Elite Marketing-bureaukontoen hos HighLevel lukkes. Hvis du vil beholde din konto, bedes du kontakte {userName} for at migrere din konto direkte til Highlevel.",
        "cancelWarning": "Vær opmærksom på, at din konto officielt vil blive annulleret den 30. juni 2025, og vi vil ikke kunne hente dine data efter denne dato, hvis overførslen ikke er gennemført.",
        "contactEmail": "transfers{'@'}gohighlevel.com",
        "contactUs": "Hvis du har spørgsmål, bedes du kontakte os på",
        "faqsUrl": "gohighlevel.com/getstartedtoday-em",
        "freeTransition": "For at støtte dig under denne gratis overgang, giver vi dig {months} gratis adgang til dit nye abonnement.",
        "intro": "På grund af gentagne overtrædelser af HighLevels servicevilkår er Elite Marketing Authority (EMA) blevet permanent fjernet fra HighLevel-platformen.",
        "platformCommitment": "Som platformen bag EMA's tjenester er HighLevel forpligtet til at opretholde et sikkert, kompatibelt og troværdigt miljø for alle brugere. For at undgå afbrydelser på din konto er vi her for at hjælpe dig med en problemfri overgang – enten til en anden private label-udbyder eller direkte til HighLevel.",
        "questions": "Hvis du har spørgsmål,",
        "retainAccess": "For at bevare adgangen til dine eksisterende data og værktøjer skal du klikke på knappen nedenfor og følge instruktionerne for at starte overførslen.",
        "speakWithTeam": "for at tale med vores team.",
        "startTransfer": "Start din gratis overførsel",
        "title": "Se her, Elite Marketing-kunder",
        "viewFaqs": "Se ofte stillede spørgsmål her:",
        "whiteLabel": "Hvis du foretrækker at tilgå HighLevel gennem en anden white label-udbyder, vil vi med glæde imødekomme denne ændring via vores supportbilletsystem, når du har overført din konto direkte til HighLevel."
      },
      "emailTemplate": {
        "createdOn": "Oprettet den",
        "updatedOn": "Opdateret den"
      },
      "error": {
        "title": "Indsendelse af lovpligtig pakke mislykkedes"
      },
      "errors": {
        "funnel": {
          "multiplePages": "Mere end én side har denne URL. Skift stien til denne side for at få det til at virke.",
          "urlNotFound": "Beklager, vi kan ikke finde den webadresse, du ledte efter."
        },
        "productRebilling": {
          "requestFailed": "Forespørgslen mislykkedes"
        },
        "template": {
          "categoryNotFound": "Beklager, vi kan ikke finde den kategori, du ledte efter.",
          "internalError": "Der opstod en intern fejl."
        },
        "transfer": {
          "hipaaEnabled": {
            "message": "Den underkonto, du forsøger at overføre, er HIPAA-aktiveret og kan ikke overføres til et ikke-HIPAA-bureau."
          },
          "limitExceeded": {
            "message": "Det agentur, du forsøger at overføre underkontoen til, har opbrugt sin forbrugsgrænse og kan ikke oprette flere underkonti.  Bed dem om enten at slette en underkonto, der ikke er i brug, eller opgradere til en højere bureauplan for at få adgang til denne underkonto."
          },
          "pendingRequest": {
            "heading": "En overførselsanmodning for denne underkonto er allerede under behandling.",
            "message": "Annuller den allerede eksisterende overførselsanmodning for denne underkonto, før du fortsætter med at oprette en ny."
          }
        }
      },
      "facebookPageSelect": {
        "cannotFind": "Kan du ikke finde den side, du leder efter? Gå til dine Facebook-indstillinger, og sørg for, at alle sider er valgt.",
        "instagramAvailable": "Instagram er tilgængelig for denne konto!",
        "noPages": "Du har ikke nogen sider under denne konto.",
        "title": "Vælg, hvilken Facebook-side du vil linke til denne placering"
      },
      "googleLocationSelect": {
        "closeButton": "Luk!",
        "enableCallTracking": "Aktivér GBP-opkaldssporing",
        "noBusinesses": "Du har ingen forbundne virksomheder under denne konto."
      },
      "importCustomers": {
        "newExperience": {
          "efficient": "Mere effektiv",
          "faster": "Hurtigere",
          "itsText": "Det er",
          "smoother": "Mere ensartet",
          "title": "En ny importoplevelse er her!",
          "warningMessage": "Aktivering af Ny import-oplevelsen aktiverer Labs for denne underkonto og aktiverer betafunktionen."
        },
        "validateEmails": "Valider e-mails?"
      },
      "initBundle": {
        "numberType": "Typer af tal, du planlagde at bruge",
        "numberTypes": {
          "local": "Lokale numre",
          "mobile": "Mobil",
          "tollfree": "Gratisnummer"
        },
        "selectCountry": "Vælg dit land",
        "selectUserType": "Vælg brugertypen",
        "userTypes": {
          "business": "Virksomhed",
          "individual": "Individ"
        }
      },
      "manageLocationCredits": {
        "creditLastAddedOn": "Kreditter senest tilføjet den:",
        "currentBalance": "Aktuel saldo",
        "debitBalance": "- Debetsaldo",
        "depositComplimentaryCreditsOf": "Indsæt gratis kreditter på",
        "manageBalance": "Administrer saldo",
        "mustBeValidInteger": "Skal være et gyldigt heltal",
        "nextDate": "Næste dato:",
        "perMonth": "pr. måned",
        "remainingWalletBalance": "Resterende saldo på tegnebogen for denne underkonto",
        "rolloverCredits": "Overfør kreditter til næste måned",
        "toManageMonthlyCredits": "For at administrere månedlige kreditter"
      },
      "manageLocationSubscriptionModal": {
        "addNewSubscription": "Tilføj nyt abonnement"
      },
      "manualActions": {
        "confirmDelete": "Er du sikker på, at du vil slette denne handling?",
        "confirmDeleteAll": "Er du sikker på, at du vil slette alle manuelle handlinger på denne side?"
      },
      "membership": {
        "resetPassword": {
          "generateStrongPassword": "Generér en stærk adgangskode",
          "sendEmailNotification": "Send også en e-mailbesked."
        }
      },
      "modal": {
        "description": "Du skal gennemføre et par enkle overholdelsestrin for at bruge telefonsystemer",
        "submit": "Indsend",
        "title": "Lead Connector-telefonservice"
      },
      "notifications": {
        "list": {
          "homePageVisitors": "Besøgende på hjemmesidens forside",
          "launched": "Lanceret",
          "newNotification": "Ny notifikation",
          "startMessage": "Begynd at øge dine konverteringer ved at oprette din første notifikation",
          "types": {
            "combination": "Kombination"
          }
        },
        "page": {
          "createTitle": "Opret ny notifikation",
          "steps": {
            "display": "Visning",
            "track": "Spor"
          }
        }
      },
      "opportunities": {
        "columns": {
          "additionalInfo": "Yderligere oplysninger",
          "calendarEvent": "Kalenderbegivenhed",
          "hideAssignedTo": "Skjul Tildelt til",
          "hideTags": "Skjul tags"
        },
        "filters": {
          "dateAddedAsc": "↑ Dato tilføjet (stigende)",
          "dateAddedDesc": "↓ Dato tilføjet (faldende)",
          "orderBy": "OrderBy"
        },
        "getStarted": "kom godt i gang!",
        "noPipelines": "Ups! Det ser ud til, at der ikke er nogen processer. Opret en ny proces for at"
      },
      "pages": {
        "pageMoved": {
          "title": "Onlineannoncerne er flyttet"
        }
      },
      "recentlyVisited": {
        "prices": "{count} priser"
      },
      "reminders": {
        "appointmentReminders": "Påmindelser om aftale",
        "apptTime": "Aftaletid",
        "defaultDateRange": "Søn, 1. apr. 2018 - man, 30. apr. 2018"
      },
      "saasAccountDetailsActiveSubscription": {
        "onHold": "På hold",
        "rebillingOnHoldWarning": "Denne konto har allerede konfigurationer for genfakturering sat på hold. SaaS-abonnementet kan kun tilknyttes, når klienten har tilføjet en betalingsmetode.",
        "subscriptionId": "Abonnements-ID:"
      },
      "saasPricingTable": {
        "confirmAndProceed": "Bekræft og fortsæt",
        "documents": {
          "acceptedDocuments": "Accepterede dokumenter",
          "acceptedDocumentsLabel": "Accepterede dokumenter:",
          "additionalInfo": "Yderligere oplysninger:",
          "createAddressLink": "Opret adresse.",
          "createAddressPrompt": "Opret en adresse først, og fortsæt derefter med oprettelsen af pakken.",
          "documentInfo": "PNG, JPG, PDF op til 5 MB",
          "documentType": "Dokumenttype",
          "option": "Valgmulighed {number}",
          "selectAddress": "Vælg adresse:",
          "selectDocumentType": "Vælg dokumenttype:",
          "selectFile": "Vælg filer",
          "title": "Nødvendige dokumenter:",
          "updateDocuments": "Opdater dokumenter"
        },
        "everythingIn": "Alt i <b>{plan}+</b>",
        "noPaymentMethod": {
          "linkText": "tilføje kreditkort her",
          "message": "Bed din klient om at",
          "title": "Placeringen skal først tilføje en betalingsmetode."
        },
        "noSaasPlan": {
          "linkText": "oprette dine SaaS-planer her.",
          "message": "Du skal",
          "title": "Du har ikke konfigureret nogen SaaS-plan."
        },
        "saasModeSetupPendingWarning": "SaaS-abonnementet vil blive aktiveret, når kunden har tilføjet en betalingsmetode. Indtil da vil adgangen til deres konto være begrænset.",
        "skipForNow": "Spring over indtil nu",
        "skipPlan": "Spring abonnement over",
        "success": {
          "title": "Reguleringspakke indsendt",
          "underReview": "Pakke indsendt under gennemgang"
        }
      },
      "selectBundle": {
        "addressBundle": {
          "description": "Denne mulighed tilføjer en ny adresse til din konto",
          "label": "Adressepakke"
        },
        "regulatoryBundle": {
          "description": "Denne mulighed vil hjælpe dig med at oprette en ny regulatorisk pakke",
          "label": "Regulatorisk pakke"
        },
        "title": "Vælg, hvilken pakke du vil tilføje"
      },
      "settings": {
        "billing": "Fakturering",
        "calendars": "Kalendere",
        "customEmails": "Tilpassede e-mails",
        "domains": "Domæner",
        "domainsAndUrlRedirects": "Domæner og URL-omdirigeringer",
        "facebookFormFieldsMapping": "Kortlægning af Facebook-formularfelter",
        "groups": "Grupper",
        "integrations": "Integrationer",
        "labs": "Labs",
        "media": "Medier",
        "noShowSMS": "SMS ved udeblevet fremmøde",
        "pipelines": "Processer",
        "profile": "Profil",
        "smtpAndMailGunService": "SMTP- og MailGun-service",
        "templates": "Skabeloner",
        "urlRedirects": "URL-omdirigeringer"
      },
      "shakenStir": {
        "confirmation": {
          "title": "Dine opkald er nu bekræftet!"
        },
        "modal": {
          "andThe": " og den ",
          "certification": "Jeg bekræfter, at den tilknyttede virksomhedsprofil er ophavsmanden til telefonopkaldene, og at jeg vil deltage i sporingsindsatser, herunder dem, der er initieret af",
          "failedTitle": "Indsendelse mislykkedes",
          "friendlyNamePlaceholder": "Ex: SHST 2022-11-24 kl. 19:47:14",
          "linkInfo": {
            "description": "Alle nuværende tilgængelige numre og fremtidigt købte numre vil automatisk blive registreret hos SHAKEN/STIR.",
            "title": "Alle numre vil blive linket automatisk"
          },
          "stiPa": "Administrator af identitetspolitik for sikker telefoni (STI-PA)",
          "subtitle": "Indtast oplysninger og beskrivelse",
          "successMessage": "Din anmodning om SHAKEN/STIR-registrering er indsendt. Det kan tage op til <b>3-4 dage</b> at blive godkendt. Statussen vil blive opdateret snart.",
          "successTitle": "SHAKEN/STIR-betroede opkald aktiveret.",
          "title": "Aktivér SHAKEN/STIR-betroede opkald",
          "tracebackGroup": "US Telecom Traceback Group"
        },
        "withCnam": {
          "cnamPromo": "Vil du gå et skridt videre? Vis dit virksomhedsnavn på opkald med CNAM.",
          "registerCnam": "Tilmeld dig CNAM",
          "title": "Opbyg kundernes tillid, og øg svarprocenterne"
        },
        "successMessage": "Din anmodning om SHAKEN/STIR-registrering er indsendt. Det kan tage op til <b>3-4 dage</b> at blive godkendt. Statussen vil blive opdateret snart."
      },
      "shopify": {
        "selectLocation": "Vælg hvilken placering du vil linke til denne Shopify-butik"
      },
      "signup": {
        "accountType": "Kontotype",
        "agencyProAccount": "Agency Pro-konto (497 USD/måned)",
        "agencyTestAccount": "Agenturtestkonto",
        "freeTrialMessage": "Få en 14-dages <strong>gratis</strong> prøveperiode ved at tilmelde dig nu.",
        "freelancerAccount": "Freelancer-konto (297 USD/måned)",
        "getStartedForFree": "Kom i gang gratis!",
        "pickPassword": "Vælg en adgangskode",
        "signUp": "Tilmeld dig",
        "starterAccount": "Starter-konto (97 USD/måned)",
        "termsAndConditions": "Ved at tilmelde dig accepterer du vores <a href='https://www.gohighlevel.com/privacy' target='_blank'>vilkår og betingelser</a>",
        "yourCompanyName": "Dit firmanavn",
        "yourFullName": "Dit fulde navn"
      },
      "standardPlan": {
        "description": "Vi har følgende planer for standardbrand-registreringer.",
        "plans": {
          "common": {
            "einRequiredForRegistration": "EIN er påkrævet for registrering",
            "moreThan1Phone": "Mere end 1 telefonnummer tilladt"
          },
          "highVolume": {
            "heading": "Standard for høj volumen",
            "point3": "Op til 600.000 segmenter pr. dag",
            "infoText": "Der opkræves et engangsbeløb på 20,95 USD for registrering af brand og kampagne. Yderligere kampagnegebyr på op til 2,25 USD pr. måned vil blive pålagt i overensstemmelse med TCR-reglerne.",
            "point2": "Send op til 3000 segmenter om dagen",
            "point1": "EIN er påkrævet for registrering"
          },
          "lowVolume": {
            "heading": "Lav volumenstandard",
            "recommended": "Anbefales",
            "point3": "Op til 6000 segmenter pr. dag",
            "infoText": "Der opkræves et engangsbeløb på 20,95 USD for registrering af brand og kampagne. Yderligere kampagnegebyr på op til 2,25 USD pr. måned vil blive pålagt i overensstemmelse med TCR-reglerne.",
            "point2": "Send op til 3000 segmenter om dagen",
            "point1": "EIN er påkrævet for registrering"
          }
        },
        "title": "Vælg din standardbrandplan"
      },
      "submissionDetail": {
        "titles": {
          "bookingDetails": "Bookingoplysninger",
          "form": "Formular",
          "quiz": "Quiz",
          "submissionDetail": "Oplysninger om indsendelse",
          "survey": "Undersøgelse"
        }
      },
      "suspension": {
        "suspended": {
          "description": "Kun agenturadministratorer/brugere har adgang til denne underkonto. I øjeblikket har du og andre kontoadministratorer/brugere ikke adgang til denne underkonto.",
          "heading": "Denne underkonto er blevet sat på pause."
        },
        "temporarily": {
          "description": "Alle dine data er sikre, og alle udløsere/kampagner osv. vil starte op igen efter aktivering.",
          "heading": " Din konto er blevet midlertidigt suspenderet."
        }
      },
      "triggers": {
        "assignUser": {
          "onlyUnassignedContacts": "Anvend kun til ikke tildelte kontakter",
          "splitTraffic": "Opdelt trafik",
          "trafficWeightage": "Trafikvægtning",
          "userRequired": "Brugeren skal vælges",
          "weightage": "Vægtning"
        },
        "birthdayFilters": {
          "afterDays": "Efter antal dage",
          "beforeDays": "Før antal dage",
          "dayIs": "Dagen er",
          "daysInNumber": "Dage i antal",
          "hasTag": "Har tag",
          "monthIs": "Måneden er",
          "selectDay": "Vælg dag",
          "selectMonth": "Vælg måned"
        },
        "botConversation": {
          "enterTimeout": "Indtast en timeout (timer)",
          "selectEliza": "Vælg Eliza",
          "selectThankyouTemplate": "Vælg takkeskabelon",
          "selectWelcomeTemplate": "Vælg velkomstskabelon"
        },
        "contactField": {
          "addField": "Tilføj felt",
          "defineFilters": "Definer filtre"
        },
        "copyModal": {
          "title": "Kopiér udløser"
        },
        "detailModal": {
          "actionsPerform": "Hvilke handlinger skal vi udføre?",
          "campaignNameRequired": "Feltet Kampagnenavn er påkrævet",
          "campaignsDeprecation": "Kampagner vedligeholdes ikke længere. For at sikre en gnidningsløs overgang bedes du konvertere dine eksisterende kampagner til arbejdsgange.",
          "folderName": "Mappens navn",
          "mustSelectFolder": "Du skal vælge en mappe.",
          "newFolderName": "Nyt mappenavn",
          "selectFolder": "Vælg mappe",
          "triggerNameRequired": "Feltet Udløsernavn er påkrævet",
          "triggersDeprecation": "Udløsere vedligeholdes ikke længere. For at sikre en gnidningsløs overgang bedes du konvertere dine eksisterende udløsere til arbejdsgange.",
          "triggerName": "Triggernavn"
        },
        "dnd": {
          "disableAll": "Deaktiver DND for alle kanaler",
          "disableSpecific": "Deaktiver DND for specifikke kanaler",
          "enableAll": "Aktivér DND for alle kanaler",
          "enableSpecific": "Aktivér DND for specifikke kanaler",
          "selectAction": "Vælg handling"
        },
        "email": {
          "sendTestEmail": "Send testmail",
          "smtpWarning": "SMTP-udbyderne har nogle begrænsninger. Klik her for at få mere at vide."
        },
        "facebook": {
          "avatarAlt": "Facebook-avatar",
          "selectCustomAudience": "Vælg brugerdefineret målgruppe"
        },
        "googleAds": {
          "conversionName": "Konverteringsnavn",
          "conversionTooltip": "Konverteringskilden skal være Importer fra klik, og kategorien skal være Importeret kundeemne eller kundeemne.",
          "noConversions": "Ingen konverteringsrate fundet",
          "selectConversion": "Vælg konvertering"
        },
        "googleAnalytics": {
          "eventAction": "Begivenhedshandling",
          "eventActionRequired": "Hændelseshandling er påkrævet.",
          "eventCategory": "Begivenhedskategori",
          "eventCategoryRequired": "Begivenhedskategori er påkrævet.",
          "eventLabel": "Begivenhedsetiket",
          "eventValue": "Begivenhedsværdi",
          "hitType": "Hittype",
          "hitTypeRequired": "Hittypen er påkrævet.",
          "trackingId": "Sporings-ID",
          "trackingIdRequired": "Sporings-ID er påkrævet."
        },
        "membershipOffer": {
          "selectOffer": "Vælg tilbud"
        },
        "notification": {
          "selectRedirectPage": "Vælg omdirigeringsside",
          "selectUser": "Vælg bruger",
          "selectUserType": "Vælg brugertype"
        },
        "sms": {
          "sendTestSMS": "Send test-SMS"
        },
        "stripeCharge": {
          "customerId": "Stripe-kunde-ID",
          "enterAmount": "Indtast beløb",
          "selectCurrency": "Vælg valuta"
        },
        "webhook": {
          "webhookUrl": "Webhook-URL"
        }
      },
      "twilioReselling": {
        "transactions": {
          "fields": {
            "activityDate": "Aktivitetsdato",
            "balance": "Saldo",
            "id": "id"
          }
        },
        "upgradeBanner": {
          "subtitle": "Bureauer på pro-planen tjener omkring 363 USD om måneden ved at viderefakturere telefonomkostninger til deres kunder",
          "title": "Vil du viderefakturere dette til dine kunder?"
        }
      },
      "updateModals": {
        "error": {
          "title": "Kunne ikke indsende din profil."
        },
        "success": {
          "message": "Din A2P-brand og kampagne er blevet indsendt.<br/><br/><b>Bemærk:</b> Du vil <b>modtage en besked med en engangskode fra TCR på dit angivne mobilnummer, som du skal bekræfte</b>. <b>Svar Yes inden for 24 timer</b> efter modtagelse af SMS'en."
        }
      },
      "usageLimit": {
        "contactLimit": "Kontaktgrænse",
        "maxContactsAllowed": "Maksimalt antal kontakter tilladt i underkontoen",
        "maxUsersAllowed": "Maksimalt antal brugere tilladt i underkontoen",
        "unlimited": "Ubegrænset",
        "usageLimits": "Forbrugsgrænser",
        "userLimit": "Brugergrænse",
        "userLimitHelpMessage": "Kun brugere på underkontoniveau tæller med i denne grænse. Du kan stadig indbefatte så mange agenturbrugere i underkontiene, som du har brug for."
      },
      "yext": {
        "reselling": {
          "agreeToEnable": "Jeg accepterer at aktivere annoncer for denne klient uden mersalg, og jeg anerkender, at jeg vil blive opkrævet",
          "deployDirectly": "Implementer annoncer direkte",
          "deployDirectlyDesc": "Brug denne mulighed, hvis du tilbyder annoncer som en del af dit tilbud, eller hvis du vil fakturere din kunde eksternt.",
          "minimumCommitment": "med en minimumsbindingsperiode på 1 måned.",
          "offerListings": "Tilbudsannoncer",
          "resellListings": "Videresælg annoncer",
          "subscribedInfo": "{withoutUpsell} uden mersalg, {withUpsell} med mersalg og {withSaas} med SaaS-pakke",
          "subscriptionCreated": "Abonnementet er blevet oprettet. Vent ...",
          "subscriptionCreating": "Abonnementet er ved at blive oprettet.<br/>Undlad at genindlæse eller trykke på tilbage-knappen",
          "unableToCreate": "Kan ikke oprette abonnement. Kontakt support.",
          "unavailabilityForAgencyAdmin": "Yext er ikke tilgængelig i dette land. Hvis du mener, at dette er en fejl, bedes du anmode om det på vores køreplan på",
          "yourResellOffer": "Dit videresalgstilbud"
        }
      },
      "selectCountry": "Vælg dit land",
      "documents": {
        "additionalInfo": "Yderligere oplysninger",
        "createAddressLink": "Opret adresse.",
        "createAddressPrompt": "Opret en adresse først, og fortsæt derefter med oprettelsen af pakken.",
        "selectAddress": "Vælg adresse:"
      }
    },
    "triggers": {
      "emptyTrigger": "Tom trigger"
    },
    "util": {
      "addFiles": "+ Tilføj filer",
      "fillValues": "Udfyld værdier",
      "image": "img",
      "ok": "Ok",
      "pleaseTypeOrCancel": "Indtast {consentString} ovenfor, eller annuller denne handling.",
      "pressEnterToAddCustomOption": "Klik på enter for at inkludere en tilpasset indstilling",
      "required": "* påkrævet",
      "unsaved": "Ikke gemt"
    },
    "workflow": {
      "announcement": {
        "enableMessage": "For at aktivere arbejdsgangen for en lokation skal du gå til fanen Konti, klikke på ikonet med tre prikker til højre for en underkonto og vælge <strong>Aktiver arbejdsgangskaber</strong>. Denne proces er midlertidig, da Workflows vil blive offentliggjort på alle lokationer i næste uge."
      },
      "faq": "Ofte stillede spørgsmål",
      "gotIt": "Forstået",
      "workflowIsLive": "Arbejdsgangen er live på din konto!"
    },
    "action": {
      "stats": {
        "bounced": "Afvist",
        "clicked": "Klikket",
        "delivered": "Leveret",
        "opened": "Åbnet",
        "replied": "Besvaret",
        "unsubscribed": "Afmeldt",
        "total": "I alt",
        "failed": "Mislykkedes"
      },
      "actions": {
        "edit": "Rediger",
        "send": "Send",
        "remove": "Ryd"
      },
      "timing": {
        "days": "Dage",
        "immediately": "Øjeblikkeligt",
        "before": "Før",
        "after": "Efter",
        "minutes": "Minutter",
        "hours": "Timer"
      },
      "labels": {
        "template": "Skabelon",
        "manual": "Manuel"
      },
      "details": {
        "hideDetail": "Skjul detalje",
        "showDetail": "Vis detalje"
      },
      "queue": {
        "people": "mennesker",
        "person": "person",
        "queued": "i kø"
      },
      "tooltips": {
        "clickedHelp": "Kliksporingsnøjagtigheden kan variere afhængigt af e-mailklienten og brugerindstillingerne.",
        "statsAccuracy": "Statistikkernes nøjagtighed kan variere afhængigt af e-mailklienten og brugerindstillingerne."
      }
    },
    "bulkRequest": {
      "list": {
        "confirmDelete": "Er du sikker på, at du vil slette denne masseanmodning?",
        "startImmediately": "Start øjeblikkeligt"
      },
      "modal": {
        "contactTypes": {
          "all": "Alle",
          "leads": "Kundeemner",
          "customers": "Kunder"
        },
        "buttons": {
          "cancel": "Annuller",
          "update": "Opdater",
          "add": "Tilføj"
        },
        "labels": {
          "name": "Navn",
          "contactType": "Kontakttype",
          "campaign": "Kampagne",
          "scheduledDate": "Planlagt dato",
          "tag": "Tag"
        },
        "placeholders": {
          "tags": "Tags",
          "selectCampaign": "Vælg kampagne",
          "pickType": "Vælg type"
        },
        "sections": {
          "bulkRequest": "Masseanmodning",
          "whoShouldRun": "Hvem skal den køre for?"
        },
        "titleAdd": "Tilføj masseanmodning",
        "titleEdit": "Rediger anmodning om større mængder",
        "validation": {
          "scheduledDateRequired": "Planlagt dato er påkrævet"
        }
      }
    },
    "listFolder": {
      "expandIcon": "Udvid"
    },
    "list": {
      "confirmDeleteFolder": "Bekræft sletning af mappe",
      "delete": "Slet",
      "confirmDelete": "Er du sikker på, at du vil slette denne kampagne?",
      "moveToFolder": "Flyt til mappe",
      "pleaseRename": "omdøb",
      "removeFromFolder": "Fjern fra mappen"
    },
    "copy": {
      "title": "Kopiér kampagne",
      "newCampaignName": "Nyt kampagnenavn",
      "locations": "Placeringer"
    }
  },
  "compliance": {
    "findOutMore": "Få mere at vide",
    "gdprDescription": "Vi tager beskyttelsen af dine og dine kunders personlige oplysninger meget alvorligt, og vi behandler personlige oplysninger meget fortroligt og i overensstemmelse med lovmæssige databeskyttelsesregler og denne databeskyttelseserklæring.",
    "gdprTitle": "GDPR-overholdelse",
    "hipaaDescription": "Aktivér sikkerhedsopgraderinger for at sikre, at dataene i din HighLevel-konto er sikre og opfylder kravene i HIPAA.",
    "hipaaTitle": "HIPAA-overholdelse"
  },
  "customValues": {
    "key": "Nøgle",
    "selectedItemsCountSingular": "{count} række valgt",
    "selectedItemsCountPlural": "{count} rækker valgt"
  },
  "facebookAdFields": {
    "checkIcon": "Formularen er blevet tilknyttet",
    "errorMessage": "Sideadgangstokenet er enten udløbet eller har ikke tilstrækkelige tilladelser. Sørg for, at du har administratoradgang til siderne."
  },
  "fbLeadSync": {
    "confirmTitle": "Bekræft synkronisering af Facebook-kundeemner?",
    "impactMessage": "Forstå virkningen af synkroniseringen af Facebook-kundeemner, før du fortsætter:",
    "observations": "1. Dette vil synkronisere Facebook-kundeemner og oprette nye kontakter for alle kundeemner, der er genereret i de sidste {days} dage, og som ikke findes på din kontaktliste. <br>2. Hvis du manuelt har importeret manglende kundeemner ved hjælp af CSV eksporteret fra Facebook Ads Manager, skal du deaktivere &quot;Tillad duplikerede kontakter&quot; for at forhindre synkroniseringen i at oprette dubletter af kontakter. <br>3. Hvis du har arbejdsgange, der udløses ved <b>oprettelse af kontakter</b> eller <b>indsendelse af Facebook-kundeemneformularer</b>, vil de blive udløst for hver ny kontakt, der oprettes. <br>4. Eksisterende kontakter oprettet via Facebook-kundeemner vil ikke blive påvirket. <br>5. Tidspunktet for oprettelse af kontakt, der er registreret, vil være det aktuelle tidspunkt. <br>6. Synkroniseringen kan tage op til en time at afslutte, afhængigt af antallet af kundeemner, der endnu ikke er synkroniseret. <br>",
    "proceedQuestion": "Vil du fortsætte med synkronisering af Facebook-kundeemner?"
  },
  "integrationAI": {
    "accountDisconnected": "Konto frakoblet!",
    "appNotFound": "Appkonfiguration ikke fundet. Brug af reservedata.",
    "checkingConnection": "Kontrollerer forbindelsesstatus ...",
    "connecting": "Forbinder ...",
    "disconnectApp": "Afbryd app",
    "disconnecting": "Afbryder forbindelsen ...",
    "loadingAppInfo": "Indlæser appoplysninger ...",
    "refreshConnection": "Opdater forbindelsen",
    "refreshing": "Opdaterer ...",
    "svgNotAvailable": "SVG er ikke tilgængelig"
  },
  "phoneSystem": {
    "additionalSettings": "Yderligere indstillinger",
    "messaging": "Beskeder",
    "messagingAnalytics": "Beskedstatistik",
    "regulatoryBundles": "Regulatoriske pakker",
    "title": "Telefonsystem",
    "trustCenter": "Tillidscenter",
    "voice": "Stemme"
  },
  "demo": {
    "draggable": {
      "title": "Test af trækbar komponent",
      "usingVue3": "Brug af Vue 3-kompatibel trækbar",
      "description": "Denne komponent bruger nu den reviderede Vue 3-kompatible trækbare komponent.",
      "buttons": {
        "resetAllLists": "Nulstil alle lister",
        "clearLog": "Ryd log",
        "stopLoading": "Stop indlæsning",
        "simulateLoading": "Simuler indlæsning",
        "refreshData": "Opdater data"
      },
      "examples": {
        "basicDraggable": "Grundlæggende trækbar",
        "draggableWithElement": "Kan trækkes med element",
        "draggableWithTransitionGroup": "Kan trækkes med overgangsgruppe",
        "draggableWithMoveFunction": "Kan trækkes med flyttefunktion"
      },
      "eventLog": "Begivenhedslog",
      "handle": "Brugernavn",
      "name": "Navn",
      "cannotMove": "(kan ikke flyttes)"
    },
    "tableDemo": {
      "title": "Vue 3 UIBTable-demo",
      "basicControls": "Grundlæggende styringer",
      "labels": {
        "filter": "Filter:",
        "sortBy": "Sortér efter:",
        "sortDirection": "Sorteringsretning:",
        "perPage": "Pr. side:",
        "tableStyling": "Tabelstyling:"
      },
      "placeholders": {
        "typeToSearch": "Skriv for at søge ..."
      },
      "checkboxLabels": {
        "striped": "Stribet",
        "bordered": "Afgrænset",
        "hover": "Svæve",
        "small": "Lille",
        "responsive": "Responsiv"
      },
      "fields": {
        "id": "ID",
        "name": "Navn",
        "email": "E-mail",
        "status": "Status",
        "created": "Oprettet",
        "actions": "Handlinger"
      },
      "statuses": {
        "active": "Aktiv",
        "inactive": "Inaktiv",
        "pending": "Afventer",
        "banned": "Udelukket"
      },
      "modal": {
        "title": "Objektoplysninger",
        "close": "Luk"
      },
      "messages": {
        "confirmDelete": "Er du sikker på, at du vil slette {name}?",
        "editItem": "Rediger element {id}",
        "showingItems": "Viser {count} af {total} elementer"
      }
    },
    "saasPricingTable": {
      "confirmAndProceed": "Bekræft og fortsæt",
      "everythingIn": "Alt i <b>{plan}+</b>",
      "noPaymentMethod": {
        "linkText": "tilføje kreditkort her",
        "message": "Bed din klient om at",
        "title": "Placeringen skal først inkludere en udbetalingsmetode."
      },
      "noSaasPlan": {
        "linkText": "oprette dine SaaS-planer her.",
        "message": "Du skal",
        "title": "Du har ikke konfigureret nogen SaaS-plan."
      },
      "saasModeSetupPendingWarning": "SaaS-abonnementet vil blive aktiveret, når kunden har tilføjet en betalingsmetode. Indtil da vil adgangen til deres konto være begrænset.",
      "skipForNow": "Spring over indtil videre",
      "skipPlan": "Spring abonnement over"
    }
  },
  "isv": {
    "business_registration_id_type": "ID-type for virksomhedsregistrering",
    "business_registration_number": "Virksomhedsregistreringsnummer",
    "business_website": "Virksomhedens website",
    "enter_your_business_registration_id_type": "Indtast din virksomheds registrerings-ID-type",
    "name_of_other_registration_id_type": "Navn på anden registrerings-ID-type",
    "pick_business_industry": "Vælg branche",
    "pick_business_registration_id_type": "Vælg virksomhedens registrerings-ID-type",
    "emailWithStar": "E-mail*",
    "businessIndustry": "Virksomhedens branche*",
    "businessType": "Virksomhedstype*",
    "regionsOfOperations": "Forretningsområder for aktiviteter*",
    "registrationNumber": "Virksomhedsregistreringsnummer*",
    "registrationNumberHelper": "Nummeret, der bruges til at identificere din virksomhed. I tilfælde af et amerikansk EIN skal det være et 9-cifret nummer, f.eks. 12-3456789.",
    "businessWebsiteWithStar": "Virksomhedens website*",
    "businessTypeWithStar": "Virksomhedstype",
    "businessWebsite": "Virksomhedens website"
  },
  "aiProductRebilling": {
    "enableRebilling": "Aktivér genfakturering",
    "ratesMayDiffer": "Priserne kan variere afhængigt af region. De viste beregninger er i henhold til priserne for Storbritannien,",
    "supportDoc": "supportdokument",
    "cancel": "Annuller",
    "profit": "Fortjeneste",
    "chargedToCustomer": "Opkrævet fra kunden",
    "enabling": "Aktiverer ...",
    "forMore": "for at få flere oplysninger.",
    "rebillAmount": "Genfaktureringsbeløb",
    "tenDollarsWillGive": "10 USD vil give dig ca.",
    "yourCost": "Dine omkostninger",
    "clientBillingPage": "kundens virksomheds faktureringsside",
    "needStripeConnection": "For at aktivere genfakturering skal du forbinde Stripe på",
    "per1000Words": "pr. 1000 ord",
    "perImage": "pr. billede",
    "perReviewResponse": "pr. anmeldelsessvar",
    "perFunnel": "per funnel",
    "minimumBetween": "Minimum skal være mellem {min} og {max}",
    "images": "Billeder",
    "reviewResponse": "anmeldelsessvar",
    "funnel": "tragt",
    "pleaseCheckSupport": "Kontrollér"
  },
  "a2p": {
    "otpSuccess": {
      "title": "OTP-succes",
      "message": "Besked om vellykket engangsadgangskode"
    },
    "otpError": {
      "title": "Fejl med OTP",
      "message": "OTP-fejlmeddelelse"
    },
    "businessProfileError": {
      "title": "Fejl i virksomhedsprofil",
      "message": "Fejlmeddelelse for virksomhedsprofil"
    },
    "addressError": {
      "title": "Adressefejl",
      "status": "Fejlstatus for adresse"
    },
    "profileError": {
      "title": "A2P-profilfejl",
      "message": "Fejlmeddelelse for A2P-profil"
    },
    "address": {
      "country": "Land",
      "state": "Stat",
      "chooseCountry": "Vælg land ...",
      "statePlaceholder": "Indtast stat",
      "chooseState": "Vælg stat ...",
      "city": "By*",
      "postalCode": "Postnummer*",
      "streetAddress": "Gade/vej/nummer*",
      "streetAddressHelper": "Skal være en gyldig adresse knyttet til din virksomhed.",
      "title": "Virksomhedsadresse"
    },
    "validation": {
      "brandNameRequired": "Brandnavn er påkrævet.",
      "businessVerticalRequired": "Forretningsområde er påkrævet.",
      "cityRequired": "By er påkrævet.",
      "countryRequired": "Land er påkrævet.",
      "invalidMobileNumber": "Ugyldigt mobilnummer.",
      "mobileNumberRequired": "Mobilnummer er påkrævet.",
      "postalCodeRequired": "Postnummer er påkrævet.",
      "stateRequired": "Stat er påkrævet.",
      "streetAddressRequired": "Adresse er påkrævet."
    },
    "authorizedRep": {
      "email": "E-mail*",
      "firstName": "Fornavn*",
      "jobPosition": "Stilling*",
      "jobTitle": "Jobtitel*",
      "jobTitlePlaceholder": "Indtast jobtitel",
      "lastName": "Efternavn*",
      "phoneNumber": "Telefonnummer*",
      "phoneNumberPlaceholder": "Indtast telefonnummeret",
      "pickJobPosition": "Vælg en jobposition",
      "title": "Detaljer om autoriseret repræsentant"
    },
    "registration": {
      "stepProgress": "Trin {currentStep} af 8",
      "successTitle": "Dit A2P-brand og -kampagne er blevet indsendt.",
      "successWaitDays": "7 dage",
      "successWaitPrefix": "Det kan tage op til ",
      "successWaitSuffix": " for din brandgodkendelse og yderligere 4-5 uger for godkendelse af kampagnen.",
      "otpNote": "Bemærk: Du vil modtage en besked med en engangskode fra TCR på dit angivne mobilnummer, som du skal bekræfte. Svar Yes inden for 24 timer efter modtagelse af SMS'en."
    },
    "update": {
      "brandDetailsTitle": "Opdater branddetaljer",
      "brandName": "Brandnavn*",
      "brandNameHelper": "Brug enten det juridiske navn på den organisation, der sender beskederne, eller dit eget navn, hvis dette brand ikke er for en organisation.",
      "businessVerticals": "Virksomhedens branche*",
      "chooseVertical": "Vælg lodret ...",
      "mobileNumber": "Mobilnummer til OTP-verifikation (med landekode)*",
      "mobileNumberHelper": "Angiv et mobilnummer, du har adgang til, så du kan bekræfte OTP-verifikation. Kun amerikanske/canadiske telefonnumre vil blive accepteret. Du må ikke bruge et CPaaS-telefonnummer, f.eks. et, du har fået fra LeadConnector. Du kan ikke bruge det samme mobilnummer til at registrere mere end 3 enkeltmandsvirksomhedsmærker. Denne grænse administreres via TCR.",
      "updateButton": "Opdater",
      "retryOTPTitle": "Prøv OTP igen",
      "retryOTPMessage": "Klik på knappen nedenfor for at sende engangsadgangskode-bekræftelsesbeskeden igen.",
      "sending": "Sender ...",
      "resendOTP": "Send engangsadgangskoden igen"
    },
    "einModal": {
      "title": "Har du et EIN?",
      "question": "Har du et arbejdsgiveridentifikationsnummer (EIN)?",
      "hasEIN": "Ja, jeg har et EIN",
      "noEIN": "Nej, jeg har ikke et EIN",
      "disableNoEINText": "EIN er påkrævet for lokationer uden for USA/Canada",
      "infoText": "Et EIN-nummer er påkrævet for virksomheder i USA og Canada."
    },
    "brandDetails": {
      "brandHeading": "Branddetaljer",
      "brandName": "Brandnavn*",
      "brandNameHelper": "Brug enten det juridiske navn på den organisation, der sender beskederne, eller dit eget navn, hvis dette brand ikke er for en organisation.",
      "businessIndustry": "Virksomhedens branche*",
      "chooseVertical": "Vælg lodret ...",
      "mobileNumber": "Mobilnummer til OTP-verifikation (med landekode)*",
      "mobileNumberHelper": "Angiv et mobilnummer, du har adgang til, så du kan bekræfte OTP-verifikation. Kun amerikanske/canadiske telefonnumre vil blive accepteret. Du må ikke bruge et CPaaS-telefonnummer, f.eks. et, du har fået fra LeadConnector. Du kan ikke bruge det samme mobilnummer til at registrere mere end 3 enkeltmandsvirksomhedsmærker. Denne grænse administreres via TCR.",
      "solePropBrand": {
        "heading": "Enkeltmandsvirksomhedsbrand",
        "point1": "Kun ét telefonnummer er tilladt",
        "point2": "EIN/SSN/DUNS er ikke påkrævet",
        "subheading": "Registrering af Sole Prop-brand"
      },
      "solePropCampaign": {
        "heading": "Enkeltmandsvirksomhedskampagne",
        "point1": "Kun ét nummer må linkes til en enkeltmandsvirksomhedskampagne.",
        "point2": "Når det er godkendt, vil dit standardnummer automatisk blive knyttet",
        "infoText": "Du kan også opdatere nummeret efter godkendelse",
        "warningText": "Kun ét nummer må linkes til en enkeltmandsvirksomhedskampagne. Når det er godkendt, vil dit standardnummer automatisk blive tilknyttet. Du kan også opdatere nummeret efter godkendelse.",
        "subheading": "Registrering af Sole Prop-kampagne"
      },
      "solePropSubtitle": "Brand- og kampagnedetaljer for enkeltmandsvirksomhed",
      "standardBrand": {
        "heading": "4,41 USD – engangsbetaling",
        "point1": "EIN/SSN/DUNS er påkrævet",
        "point2": "Mere end 1 telefonnummer tilladt",
        "subheading": "Standard brandregistrering"
      },
      "standardCampaign": {
        "heading": "16,54 USD – engangsbetaling",
        "point1": "Mere end 1 nummer må tilknyttes en standardkampagne.",
        "point2": "EIN/SSN/DUNS er påkrævet",
        "infoText": "Yderligere kampagnegebyr på op til 12 USD pr. måned vil blive pålagt i overensstemmelse med TCR-reglerne.",
        "subheading": "Standard kampagneregistrering"
      },
      "standardSubtitle": "Standardbrand- og kampagnedetaljer",
      "title": "Brand- og kampagnedetaljer"
    },
    "campaign": {
      "useCaseDetails": {
        "title": "Detaljer om brugsscenarie for kampagne",
        "subtitle": "Indtast kampagneoplysningerne og beskrivelse",
        "useCase": "Kampagnebrugsscenarie*",
        "pickUseCase": "Brugsscenarie for valg af kampagne",
        "useCaseDescription": "Beskrivelse*",
        "explainInDetail": "Forklar i detaljer",
        "useCaseDescriptionPlaceholder": "Eksempel: Denne kampagne sender aftaleoplysninger – bekræftelse og påmindelsesbeskeder til vores kunder, når de har booket en aftale hos os på vores hjemmeside og tilmeldt sig at modtage reklame- og SMS-beskeder fra os.",
        "useCaseDescriptionHelper": "Giv en detaljeret beskrivelse af, hvordan du vil bruge denne kampagne.",
        "solePropLabel": "Enkeltmandsvirksomhed",
        "seeExamples": "Se eksempler",
        "closeExamples": "Luk eksempler"
      }
    }
  },
  "opportunities": {
    "email": "E-mail",
    "phone": "Telefon",
    "status": "Status",
    "contactType": "Kontakttype",
    "bulkOperation": "Massehandlinger",
    "contactName": "Navn på kontaktperson",
    "unassigned": "Ikke tildelt",
    "abandoned": "Forladt",
    "addOpportunityName": "Tilføj muligheds navn",
    "companyName": "Firmanavn",
    "contactInfo": "Kontaktoplysninger",
    "enterValue": "Indtast værdi",
    "lost": "Tabt",
    "open": "Åbn",
    "opportunityInfo": "Info om muligheder",
    "opportunityName": "Navn på mulighed",
    "opportunitySource": "Mulighedskilde",
    "owner": "Ejer",
    "pipeline": "Proces",
    "selectPipeline": "Vælg proces",
    "selectStage": "Vælg trin",
    "stage": "Trin",
    "won": "Vundet",
    "createdOn": "Oprettet Til",
    "goToContactDetail": "Gå til kontaktdetaljesiden",
    "leadValue": "Kundeemnets værdi",
    "removeOwner": "Fjern ejeren",
    "createdBy": "Oprettet af",
    "notAllowedToChange": "Du har ikke tilladelse til at ændre denne kontakt",
    "opportunityAlreadyExists": "Der findes allerede en kundeemne for denne kontakt i den valgte proces.",
    "filters": {
      "all": "Alle",
      "statuses": {
        "all": "Alle",
        "open": "Åbn",
        "won": "Vundet",
        "lost": "Tabt",
        "abandoned": "Forladt"
      },
      "search": "Søg",
      "status": "Status",
      "campaign": "Kampagne",
      "owner": "Ejer",
      "pipeline": "Proces",
      "dateAddedAsc": "↑ Dato tilføjet (stigende)",
      "dateAddedDesc": "↓ Dato tilføjet (faldende)",
      "orderBy": "OrderBy"
    },
    "columns": {
      "note": "Note",
      "task": "Opgave",
      "companyName": "Firmanavn",
      "additionalInfo": "Yderligere oplysninger",
      "calendarEvent": "Kalenderbegivenhed",
      "hideAssignedTo": "Skjul Tildelt til",
      "hideTags": "Skjul tags"
    },
    "buttons": {
      "new": "Ny"
    },
    "dragActions": {
      "abandoned": "Forladt",
      "lost": "Tabt",
      "won": "Vundet"
    },
    "getStarted": "komme i gang.",
    "noPipelines": "Ups! Det ser ud til, at der ikke er nogen processer. Opret en ny proces for at",
    "addTask": "Tilføj opgave",
    "tasksCount": "{count} opgaver"
  },
  "appointmentDetails": "Oplysninger om aftale",
  "cloneFunnel": {
    "cloneButton": "Klon {entityName}",
    "cloning": "Kloner...",
    "cloningLimit": "Kloning er begrænset til 3 steder ad gangen",
    "error": "Fejl under kloning af tragt!",
    "locationsLabel": "Vælg placeringer",
    "nameLabel": "Navn til den klonede {entityName}",
    "namePlaceholder": "Indtast navn til den klonede {entityName}",
    "selectUpTo": "Vælg op til {maxSelectableLocations} placeringer",
    "title": "Klon {entityName}"
  },
  "errors": "Fejl",
  "renderEmailAddress": "Gengiv e-mailadresse",
  "noPaymentMethodWarning": "Advarsel: Ingen betalingsmetode",
  "pageDetail": "Sidedetaljer",
  "activityHistory": "Aktivitetshistorik",
  "uiAlert": "UI-advarsel",
  "eventModals": {
    "wait": {
      "save": "Gem",
      "days": "Dage",
      "fri": "Fre",
      "mon": "Man",
      "sat": "Lør",
      "sun": "Søn",
      "thu": "Tor",
      "tue": "Tir",
      "wed": "Ons",
      "wait": "Vent",
      "minutes": "Minutter",
      "hours": "Timer",
      "title": "Rediger ventebegivenhed",
      "whichDaysResume": "Hvilke dage skal vi genoptage?",
      "pickDayError": "Vælg mindst én dag",
      "whatTimeResume": "Hvad tid skal vi genoptage?"
    },
    "sms": {
      "send": "Send",
      "name": "Navn",
      "attachFile": "Vedhæft fil",
      "learnMore": "Få mere at vide",
      "sendTest": "Send test",
      "title": "Rediger {eventType} begivenhed",
      "titleTemplate": "Rediger {eventType} skabelon",
      "nameRequired": "Navn er påkrævet",
      "pickTemplate": "Vælg en skabelon",
      "appCharacters": "App-tegn",
      "numSegments": "Antal segmenter",
      "approximateCost": "Omtrentlig omkostning",
      "costEstimateNote": "Note om omkostningsestimat",
      "urlAttachmentAutocompleteToken": "URL-vedhæftning",
      "addFileUrl": "Tilføj en fil-URL",
      "urlImageAlt": "Billed-URL",
      "fileImageAlt": "Billedfil",
      "enterMessage": "Indtast en besked",
      "mobilePhonePlaceholder": "Mobiltelefon",
      "unsupportedContentType": "Ikke-understøttet indholdstype: {fileType}",
      "urlAttachmentWarning": "{count} URL-vedhæftning{plural} kunne ikke indlæses. Vil du fortsætte?",
      "provideMobileNumber": "Angiv mobilnummeret"
    },
    "email": {
      "text": "Tekst",
      "checkLinks": "Tjek de links, hvor du har en brugerdefineret værdi. Der er en ekstra '%20' mellem {{ og custom_values.",
      "errorOccurred": "Der opstod en fejl. Prøv igen.",
      "insertToAddress": "Indsæt en til-adresse."
    },
    "voicemail": {
      "save": "Gem",
      "dropFile": "Slip filen her, eller klik for at uploade",
      "faq": "Ofte stillede spørgsmål",
      "title": "Rediger talebeskedbegivenhed",
      "voicemailFile": "Talebesked-fil",
      "warning": "Advarsel: Voicemail-filer skal være i MP3-, WAV- eller GSM-format.",
      "unsupportedFormat": "Ikke-understøttet filformat. Brug MP3, WAV eller GSM."
    },
    "call": {
      "title": "Rediger opkaldsbegivenhed",
      "save": "Gem",
      "name": "Navn",
      "nameRequired": "Navn er påkrævet",
      "callWhisper": "Opkaldsvisker",
      "whisperMessage": "Kort, privat besked",
      "thisIsTheMessage": "Dette er beskeden, der vil blive afspillet for agenten, før opkaldet forbindes.",
      "callTimeoutS": "Opkalds-timeout (s)",
      "timeoutSeconds": "Timeout (sekunder)",
      "disableVoicemailDetect": "Slå registrering af telefonsvarer fra",
      "callWillPatchInstantly": "Opkaldet vil blive straks omstillet uden at registrere telefonsvareren."
    }
  },
  "emailTemplate": {
    "createdOn": "Oprettet den",
    "updatedOn": "Opdateret den"
  },
  "cnam": {
    "learnMore": {
      "title": "CNAM Læs mere",
      "description": "CNAM-beskrivelse"
    },
    "submitted": {
      "checkStatus": "Kontrollér CNAM-Omdømme",
      "description": "Dit virksomhedsnavn burde blive vist til relevante kontakter inden for cirka 3-5 dage.",
      "subtitle": "Din CNAM-anmodning er nu indsendt.",
      "title": "Tillykke!"
    },
    "registration": {
      "confirm": "Bekræft",
      "learnMore": "Få mere at vide",
      "characterLimit": "{count}/15",
      "title": "CNAM-registrering",
      "description": "Indtast dit virksomhedsnavn (maks. 15 tegn)",
      "warning": "Advarsel: Dit firmanavn vil blive vist på opkalds-id. "
    }
  },
  "updateModals": {
    "error": {
      "title": "Opdateringsfejl",
      "message": "Opdateringsfejlmeddelelse"
    },
    "success": {
      "message": "Din A2P-Retningslinjer for brand og Kampagne er blevet indsendt.<br/><br/><b>Bemærk:</b> Du vil <b>modtage en besked med en engangskode fra TCR på dit angivne mobilnummer, som du skal bekræfte</b>. <b>Svar Yes inden for 24 timer</b> efter modtagelse af SMS'en.",
      "title": "Dit A2P-brand og din A2P-kampagne er blevet indsendt. Det kan tage op til <b>7 dage</b> for din brandgodkendelse og yderligere 4-5 uger for godkendelse af kampagnen."
    }
  },
  "regulatoryBundle": {
    "error": {
      "title": "Fejl i lovgivningsmæssig bundling",
      "status": "Status for fejl i lovpligtig pakke"
    },
    "createAddress": {
      "successMessage": "Dit A2P-brand og -kampagne er blevet indsendt.",
      "successTitle": "Adressen er blevet indsendt",
      "underReview": "Den indsendte adresse er under gennemgang"
    },
    "createEndUser": {
      "dateFormat": "Datoformatet skal være ÅÅÅÅ-MM-DD.",
      "phoneExample": " Eksempel: +45 40 12 34 23",
      "title": "Virksomhedsoplysninger:"
    },
    "success": {
      "title": "Reguleringspakke indsendt",
      "underReview": "Pakke indsendt under gennemgang",
      "message": "Din anmodning om SHAKEN/STIR-registrering er indsendt. Det kan tage op til <b>3-4 dage</b> at blive godkendt. Statussen vil blive opdateret snart."
    },
    "documents": {
      "additionalInfo": "Yderligere oplysninger",
      "createAddressLink": "Opret adresse.",
      "createAddressPrompt": "Opret en adresse først, og fortsæt derefter med oprettelsen af pakken.",
      "selectAddress": "Vælg adresse:"
    },
    "selectBundle": {
      "addressBundle": {
        "description": "Denne mulighed vil inkludere en ny adresse til din konto",
        "label": "Adressepakke"
      },
      "regulatoryBundle": {
        "description": "Denne mulighed vil hjælpe dig med at oprette en ny regulatorisk pakke",
        "label": "Lovpligtig pakke"
      },
      "title": "Vælg, hvilken pakke du vil tilføje"
    },
    "modal": {
      "back": "Tilbage",
      "next": "Næste",
      "submit": "Indsend",
      "title": "Ny regulatorisk pakke",
      "description": "Opret en ny regulatorisk pakke for din placering"
    }
  },
  "reminder": {
    "phone": "Telefon",
    "noReplyYet": "Intet svar endnu"
  },
  "sendGrid": {
    "apiKey": "SendGrid API-nøgle",
    "save": "SendGrid Save",
    "apiKeyRequired": "SendGrid API-nøgle er påkrævet"
  },
  "twilioReselling": {
    "upgradeBanner": {
      "upgradeButton": "Opgrader",
      "subtitle": "Bureauer på pro-planen tjener omkring 363 USD om måneden ved at viderefakturere telefonomkostninger til deres kunder",
      "title": "Vil du viderefakturere dette til dine kunder?"
    }
  },
  "emailField": {
    "label": "E-mail",
    "placeholder": "E-mail",
    "tooltip": {
      "primary": "Primær",
      "emails": "E-mails"
    }
  },
  "attachSnapshotToggle": {
    "loadSnapshot": "Indlæs øjebliksbillede:",
    "loadSnapshotWarning": "Vil du indlæse det øjebliksbillede, der er knyttet til denne plan? <br /> <strong class='text-danger'>Eksisterende data kan gå tabt</strong>"
  },
  "suspension": {
    "suspended": {
      "description": "Kun agenturvisning administratorer/brugere har adgang til denne underkonto. I øjeblikket har du og andre kontoadministratorer/brugere ikke adgang til denne underkonto.",
      "heading": "Denne underkonto er blevet sat på pause."
    },
    "temporarily": {
      "description": "Alle dine data er sikre, og alle udløsere/kampagner osv. vil starte op igen efter aktivering.",
      "heading": " Din konto er blevet midlertidigt suspenderet."
    }
  },
  "callerIdUpdateModal": {
    "friendlyName": "Venligt virksomhedsnavn",
    "title": "Opdater opkalds-ID"
  },
  "drChronoOfficeSelect": {
    "selectOffice": "Vælg kontor",
    "whichOffice": "Hvilket kontor vil du linke til denne konto?",
    "connect": "Forbind!"
  },
  "phoneField": {
    "label": "Telefon",
    "placeholder": "Telefonnummer",
    "tooltip": {
      "invalidNumber": "Ugyldigt telefonnummer",
      "notSmsCapable": "Dette {type} nummer understøtter ikke SMS"
    }
  },
  "submissionDetail": {
    "titles": {
      "bookingDetails": "Bookingoplysninger",
      "form": "Formular",
      "quiz": "Quiz",
      "submissionDetail": "Oplysninger om indsendelse",
      "survey": "Undersøgelse"
    }
  },
  "shakenStir": {
    "confirmation": {
      "description": "Din anmodning om SHAKEN/STIR-registrering er indsendt. Det kan tage op til <b>3-4 dage</b> at blive godkendt. Statussen vil blive opdateret snart.",
      "title": "SHAKEN/STIR-betroede opkald aktiveret."
    },
    "modal": {
      "andThe": " og den ",
      "businessProfile": "Virksomhedsprofil",
      "certification": "Jeg bekræfter, at den tilknyttede virksomhedsprofil er ophavsmanden til telefonopkaldene, og at jeg vil deltage i sporingsindsatser, herunder dem, der er initieret af",
      "failedTitle": "Indsendelse mislykkedes",
      "friendlyName": "Venligt navn",
      "friendlyNamePlaceholder": "Ex: SHST 2022-11-24 kl. 19:47:14",
      "linkInfo": {
        "description": "Alle nuværende tilgængelige numre og fremtidigt købte numre vil automatisk blive registreret hos SHAKEN/STIR.",
        "title": "Alle numre vil blive linket automatisk"
      },
      "stiPa": "Administrator af identitetspolitik for sikker telefoni (STI-PA)",
      "subtitle": "Indtast oplysninger og beskrivelse",
      "successMessage": "Din anmodning om SHAKEN/STIR-registrering er indsendt. Det kan tage op til <b>3-4 dage</b> at blive godkendt. Statussen vil snart blive opdateret.",
      "successTitle": "SHAKEN/STIR-betroede opkald er aktiveret.",
      "title": "Aktivér SHAKEN/STIR-betroede opkald",
      "tracebackGroup": "US Telecom Traceback Group"
    },
    "withCnam": {
      "cnamPromo": "Registrer dig hos CNAM for at få vist dit virksomhedsnavn på nummervisning",
      "registerCnam": "Registrer CNAM"
    }
  },
  "task": {
    "2day": "2 dage",
    "3day": "3 dage",
    "4day": "4 dage",
    "5day": "5 dage",
    "addTask": "Tilføj opgave",
    "countTasks": "{count} opgaver"
  },
  "updatedProductsModal": {
    "title": "Opdaterede produkter",
    "copyDirectSaleLink": "Kopiér direkte salgslink",
    "setupFeeInstruction": "Opsætningsgebyret kan konfigureres i Stripe Dashboard. ",
    "doNotDeleteWarning": "Slet ikke produkter eller priser fra Stripe Dashboard. Dette vil bryde integrationen."
  },
  "termsOfService": {
    "privacyLink": "Privatlivspolitik",
    "accept": "Accepter",
    "termsLink": "Servicevilkår",
    "updateMessage": "Vi har opdateret vores servicevilkår og privatlivspolitik. Gennemse og accepter for at fortsætte.",
    "agreementPrefix": "Ved at fortsætte accepterer du vores ",
    "agreementConjunction": " og "
  },
  "callerIdVerificationModal": {
    "answerCall": "Besvar opkaldet, og indtast denne bekræftelseskode:",
    "leadConnectorCalling": "Lead Connector ringer ...",
    "title": "Tilføj et opkalds-ID via stemmen",
    "waitingForVerification": "Vent på verifikationen ..."
  },
  "emailOTPModal": {
    "confirmCode": "Bekræft kode",
    "resendCode": "Hvis du ikke har modtaget koden, skal du klikke her for at sende den igen"
  },
  "survey": {
    "copy": {
      "cancel": "Annuller",
      "location": "Placering",
      "copy": "Kopiér",
      "newSurveyName": "Nyt undersøgelsesnavn",
      "title": "Kopiér undersøgelse",
      "locationRequired": "Placering er påkrævet"
    }
  },
  "stripeProductDetailsModal": {
    "productName": "Produktnavn",
    "planDetails": "Oplysninger om plan",
    "title": "Produktoplysninger",
    "planId": "Plan ID",
    "copiedToClipboard": "Kopieret til udklipsholder"
  },
  "importCustomers": {
    "newExperience": {
      "efficient": "Mere effektiv",
      "faster": "Hurtigere",
      "itsText": "Det er",
      "smoother": "Mere ensartet",
      "title": "En ny importoplevelse er her!",
      "warningMessage": "Aktivering af Ny import-oplevelsen aktiverer Labs for denne underkonto og aktiverer betafunktionen.",
      "tryNow": "Prøv nu"
    },
    "validateEmails": "Valider e-mails?"
  },
  "yext": {
    "reselling": {
      "zero": "0",
      "highlevelPrice": "HighLevel-pris",
      "howDoesItWork": "Hvordan fungerer det?",
      "payNow": "Betal nu",
      "priceError": "Prisen skal være højere end eller lig med HighLevel-prisen",
      "saving": "Gemmer",
      "yourPrice": "Din pris",
      "yourProfit": "Dit overskud",
      "subscriptionCreating": "Abonnementet er ved at blive oprettet.<br/>Undlad at genindlæse eller trykke på tilbage-knappen.",
      "subscriptionCreated": "Abonnementet er blevet oprettet. Vent ...",
      "unableToCreate": "Kan ikke oprette abonnement. Kontakt support.",
      "perMonth": "pr. måned",
      "agreeToEnable": "Jeg accepterer at aktivere annoncer for denne klient uden mersalg, og jeg anerkender, at jeg vil blive opkrævet",
      "deployDirectly": "Implementer annoncer direkte",
      "deployDirectlyDesc": "Brug denne mulighed, hvis du tilbyder annoncer som en del af dit tilbud, eller hvis du vil fakturere din kunde eksternt.",
      "minimumCommitment": "med en minimumsbindingsperiode på 1 måned.",
      "offerListings": "Tilbudsannoncer",
      "resellListings": "Videresælg annoncer",
      "subscribedInfo": "{withoutUpsell} uden mersalg, {withUpsell} med mersalg og {withSaas} med SaaS-pakke",
      "yourResellOffer": "Dit videresalgstilbud"
    }
  }
}
